/* 🚨🚨🚨 DO NOT EDIT: This file has been auto generated by graphql-code-generator */
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = {
	[K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
	[SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
	[SubKey in K]: Maybe<T[SubKey]>
}
export type MakeEmpty<
	T extends { [key: string]: unknown },
	K extends keyof T,
> = { [_ in K]?: never }
export type Incremental<T> =
	| T
	| {
			[P in keyof T]?: P extends " $fragmentName" | "__typename"
				? T[P]
				: never
	  }
export type EntireFieldWrapper<T> = T
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
	ID: { input: string; output: string }
	String: { input: string; output: string }
	Boolean: { input: boolean; output: boolean }
	Int: { input: number; output: number }
	Float: { input: number; output: number }
	CustomDate: { input: any; output: any }
	CustomDateTime: { input: any; output: any }
	Date: { input: any; output: any }
	DateTime: { input: any; output: any }
	Decimal: { input: string; output: string }
	FileField: { input: any; output: any }
	JSONString: { input: any; output: any }
	UUID: { input: any; output: any }
}

/** An enumeration. */
export const CoreEnergySupplierCustomerFeePerKwhCurrencyChoices = {
	/** Euro */
	Eur: "EUR",
} as const

export type CoreEnergySupplierCustomerFeePerKwhCurrencyChoices =
	(typeof CoreEnergySupplierCustomerFeePerKwhCurrencyChoices)[keyof typeof CoreEnergySupplierCustomerFeePerKwhCurrencyChoices]
/** An enumeration. */
export const CoreInvestmentTestCategoryChoices = {
	/** Experience */
	Experience: "EXPERIENCE",
	/** Loss Calculator */
	LossCalculator: "LOSS_CALCULATOR",
	/** Questions */
	Questions: "QUESTIONS",
} as const

export type CoreInvestmentTestCategoryChoices =
	(typeof CoreInvestmentTestCategoryChoices)[keyof typeof CoreInvestmentTestCategoryChoices]
/** An enumeration. */
export const CoreInvestmentTestExperienceChoices = {
	/** Expert */
	Expert: "EXPERT",
	/** Novice */
	Novice: "NOVICE",
} as const

export type CoreInvestmentTestExperienceChoices =
	(typeof CoreInvestmentTestExperienceChoices)[keyof typeof CoreInvestmentTestExperienceChoices]
/** An enumeration. */
export const CoreLocationCountryChoices = {
	/** Austria */
	At: "AT",
	/** Belgium */
	Be: "BE",
	/** Bulgaria */
	Bg: "BG",
	/** Cyprus */
	Cy: "CY",
	/** Czechia */
	Cz: "CZ",
	/** Germany */
	De: "DE",
	/** Denmark */
	Dk: "DK",
	/** Estonia */
	Ee: "EE",
	/** Spain */
	Es: "ES",
	/** Finland */
	Fi: "FI",
	/** France */
	Fr: "FR",
	/** Greece */
	Gr: "GR",
	/** Croatia */
	Hr: "HR",
	/** Hungary */
	Hu: "HU",
	/** Ireland */
	Ie: "IE",
	/** Italy */
	It: "IT",
	/** Lithuania */
	Lt: "LT",
	/** Luxembourg */
	Lu: "LU",
	/** Latvia */
	Lv: "LV",
	/** Malta */
	Mt: "MT",
	/** Netherlands */
	Nl: "NL",
	/** Poland */
	Pl: "PL",
	/** Portugal */
	Pt: "PT",
	/** Romania */
	Ro: "RO",
	/** Sweden */
	Se: "SE",
	/** Slovenia */
	Si: "SI",
	/** Slovakia */
	Sk: "SK",
} as const

export type CoreLocationCountryChoices =
	(typeof CoreLocationCountryChoices)[keyof typeof CoreLocationCountryChoices]
/** An enumeration. */
export const CoreLocationRegionChoices = {
	/** Drenthe */
	Dr: "DR",
	/** Flevoland */
	Fl: "FL",
	/** Fryslân */
	Fr: "FR",
	/** Gelderland */
	Gl: "GL",
	/** Groningen */
	Gr: "GR",
	/** Limburg */
	Lb: "LB",
	/** Noord-Brabant */
	Nb: "NB",
	/** Noord-Holland */
	Nh: "NH",
	/** Overijssel */
	Ov: "OV",
	/** Utrecht */
	Ut: "UT",
	/** Zeeland */
	Ze: "ZE",
	/** Zuid-Holland */
	Zh: "ZH",
} as const

export type CoreLocationRegionChoices =
	(typeof CoreLocationRegionChoices)[keyof typeof CoreLocationRegionChoices]
/** An enumeration. */
export const CrowdfundingCampaignAmountRaisedCurrencyEnum = {
	/** Euro */
	Eur: "EUR",
} as const

export type CrowdfundingCampaignAmountRaisedCurrencyEnum =
	(typeof CrowdfundingCampaignAmountRaisedCurrencyEnum)[keyof typeof CrowdfundingCampaignAmountRaisedCurrencyEnum]
/** An enumeration. */
export const CrowdfundingCampaignAmountRequestedCurrencyEnum = {
	/** Euro */
	Eur: "EUR",
} as const

export type CrowdfundingCampaignAmountRequestedCurrencyEnum =
	(typeof CrowdfundingCampaignAmountRequestedCurrencyEnum)[keyof typeof CrowdfundingCampaignAmountRequestedCurrencyEnum]
/** An enumeration. */
export const CrowdfundingCampaignMaxInvestmentAmountCurrencyEnum = {
	/** Euro */
	Eur: "EUR",
} as const

export type CrowdfundingCampaignMaxInvestmentAmountCurrencyEnum =
	(typeof CrowdfundingCampaignMaxInvestmentAmountCurrencyEnum)[keyof typeof CrowdfundingCampaignMaxInvestmentAmountCurrencyEnum]
/** An enumeration. */
export const CrowdfundingCampaignMinInvestmentAmountCurrencyEnum = {
	/** Euro */
	Eur: "EUR",
} as const

export type CrowdfundingCampaignMinInvestmentAmountCurrencyEnum =
	(typeof CrowdfundingCampaignMinInvestmentAmountCurrencyEnum)[keyof typeof CrowdfundingCampaignMinInvestmentAmountCurrencyEnum]
/** An enumeration. */
export const CrowdfundingCampaignStateEnum = {
	/** Closed */
	Closed: "CLOSED",
	/** Draft */
	Draft: "DRAFT",
	/** Hidden */
	Hidden: "HIDDEN",
	/** Live */
	Live: "LIVE",
	/** Successful */
	Successful: "SUCCESSFUL",
} as const

export type CrowdfundingCampaignStateEnum =
	(typeof CrowdfundingCampaignStateEnum)[keyof typeof CrowdfundingCampaignStateEnum]
/** An enumeration. */
export const CrowdfundingCampaignStepInvestmentAmountCurrencyEnum = {
	/** Euro */
	Eur: "EUR",
} as const

export type CrowdfundingCampaignStepInvestmentAmountCurrencyEnum =
	(typeof CrowdfundingCampaignStepInvestmentAmountCurrencyEnum)[keyof typeof CrowdfundingCampaignStepInvestmentAmountCurrencyEnum]
/** An enumeration. */
export const CrowdfundingCampaignUnitShareAmountCurrencyEnum = {
	/** Euro */
	Eur: "EUR",
} as const

export type CrowdfundingCampaignUnitShareAmountCurrencyEnum =
	(typeof CrowdfundingCampaignUnitShareAmountCurrencyEnum)[keyof typeof CrowdfundingCampaignUnitShareAmountCurrencyEnum]
export type CrowdfundingTransactionType = {
	__typename?: "CrowdfundingTransactionType"
	amount: EntireFieldWrapper<Scalars["Decimal"]["output"]>
	created_at: EntireFieldWrapper<Scalars["DateTime"]["output"]>
	crowdfundingtransaction?: EntireFieldWrapper<
		Maybe<CrowdfundingTransactionType>
	>
	customer_BIC_provided_by_bank?: EntireFieldWrapper<
		Maybe<Scalars["String"]["output"]>
	>
	customer_IBAN_provided_by_bank?: EntireFieldWrapper<
		Maybe<Scalars["String"]["output"]>
	>
	customer_legal_name_provided_by_bank?: EntireFieldWrapper<
		Maybe<Scalars["String"]["output"]>
	>
	deleted_at?: EntireFieldWrapper<Maybe<Scalars["DateTime"]["output"]>>
	error_reason_description: EntireFieldWrapper<Scalars["String"]["output"]>
	fee_amount: EntireFieldWrapper<Scalars["Decimal"]["output"]>
	fee_amount_currency: EntireFieldWrapper<PaymentsFinancialTransactionFeeAmountCurrencyChoices>
	id: EntireFieldWrapper<Scalars["ID"]["output"]>
	interoperable_id?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	modified_at: EntireFieldWrapper<Scalars["DateTime"]["output"]>
	payment_amount: EntireFieldWrapper<Scalars["Decimal"]["output"]>
	payment_amount_currency: EntireFieldWrapper<PaymentsFinancialTransactionPaymentAmountCurrencyChoices>
	payment_type?: EntireFieldWrapper<
		Maybe<PaymentsFinancialTransactionPaymentTypeChoices>
	>
	processor_context_data: EntireFieldWrapper<Scalars["JSONString"]["output"]>
	/** The ID of the Mangopay remote wallet associated with this project. */
	project_wallet_id?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	refunded_interoperable_id?: EntireFieldWrapper<
		Maybe<Scalars["String"]["output"]>
	>
	state: EntireFieldWrapper<PaymentsFinancialTransactionStateChoices>
	transaction_type: EntireFieldWrapper<PaymentsFinancialTransactionTransactionTypeChoices>
	/** Universally unique identifier. */
	uuid: EntireFieldWrapper<Scalars["UUID"]["output"]>
	/** Short version of the universally unique identifier. */
	uuid_short: EntireFieldWrapper<Scalars["String"]["output"]>
}

export type DefaultRatePerYearType = {
	__typename?: "DefaultRatePerYearType"
	default_rate?: EntireFieldWrapper<Maybe<Scalars["Float"]["output"]>>
	denominator?: EntireFieldWrapper<Maybe<Scalars["Int"]["output"]>>
	numerator?: EntireFieldWrapper<Maybe<Scalars["Int"]["output"]>>
	year?: EntireFieldWrapper<Maybe<Scalars["Int"]["output"]>>
}

/** Debugging information for the current query. */
export type DjangoDebug = {
	__typename?: "DjangoDebug"
	/** Raise exceptions for this API query. */
	exceptions?: EntireFieldWrapper<Maybe<Array<Maybe<DjangoDebugException>>>>
	/** Executed SQL queries for this API query. */
	sql?: EntireFieldWrapper<Maybe<Array<Maybe<DjangoDebugSql>>>>
}

/** Represents a single exception raised. */
export type DjangoDebugException = {
	__typename?: "DjangoDebugException"
	/** The class of the exception */
	exc_type: EntireFieldWrapper<Scalars["String"]["output"]>
	/** The message of the exception */
	message: EntireFieldWrapper<Scalars["String"]["output"]>
	/** The stack trace */
	stack: EntireFieldWrapper<Scalars["String"]["output"]>
}

/** Represents a single database query made to a Django managed DB. */
export type DjangoDebugSql = {
	__typename?: "DjangoDebugSQL"
	/** The Django database alias (e.g. 'default'). */
	alias: EntireFieldWrapper<Scalars["String"]["output"]>
	/** Duration of this database query in seconds. */
	duration: EntireFieldWrapper<Scalars["Float"]["output"]>
	/** Postgres connection encoding if available. */
	encoding?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** Whether this database query was a SELECT. */
	is_select: EntireFieldWrapper<Scalars["Boolean"]["output"]>
	/** Whether this database query took more than 10 seconds. */
	is_slow: EntireFieldWrapper<Scalars["Boolean"]["output"]>
	/** Postgres isolation level if available. */
	iso_level?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** JSON encoded database query parameters. */
	params: EntireFieldWrapper<Scalars["String"]["output"]>
	/** The raw SQL of this query, without params. */
	raw_sql: EntireFieldWrapper<Scalars["String"]["output"]>
	/** The actual SQL sent to this database. */
	sql?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** Start time of this database query. */
	start_time: EntireFieldWrapper<Scalars["Float"]["output"]>
	/** Stop time of this database query. */
	stop_time: EntireFieldWrapper<Scalars["Float"]["output"]>
	/** Postgres transaction ID if available. */
	trans_id?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** Postgres transaction status if available. */
	trans_status?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** The type of database being used (e.g. postrgesql, mysql, sqlite). */
	vendor: EntireFieldWrapper<Scalars["String"]["output"]>
}

export type EmailUpdateInput = {
	clientMutationId?: InputMaybe<Scalars["String"]["input"]>
	confirm_email: Scalars["String"]["input"]
	current_password: Scalars["String"]["input"]
	new_email: Scalars["String"]["input"]
}

export type EmailUpdatePayload = {
	__typename?: "EmailUpdatePayload"
	clientMutationId?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** May contain more than one error for same field. */
	errors?: EntireFieldWrapper<Maybe<Array<Maybe<ErrorType>>>>
	new_email?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** URL to verify the email change via Mangopay SCA */
	verification_url?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
}

export type EnergySupplierType = {
	__typename?: "EnergySupplierType"
	/** Email address to send communications related to interest period payouts. */
	billing_email?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** Customer fees calculated based on this value and paid directly to the investor. */
	customer_fee_per_kwh?: EntireFieldWrapper<
		Maybe<Scalars["Decimal"]["output"]>
	>
	customer_fee_per_kwh_currency?: EntireFieldWrapper<
		Maybe<CoreEnergySupplierCustomerFeePerKwhCurrencyChoices>
	>
	id: EntireFieldWrapper<Scalars["ID"]["output"]>
	/** Indicates whether this energy supplier is a partner. */
	is_partner: EntireFieldWrapper<Scalars["Boolean"]["output"]>
	/** Indicates whether solar interest payments should be paid to this supplier instead of the investor. */
	is_solar_interest_paid_to_supplier: EntireFieldWrapper<
		Scalars["Boolean"]["output"]
	>
	/** The maximum KWH cap for customer fee calculations. */
	kwh_cap?: EntireFieldWrapper<Maybe<Scalars["Decimal"]["output"]>>
	logo?: EntireFieldWrapper<Maybe<Scalars["FileField"]["output"]>>
	/** The name of the energy supplier. */
	name: EntireFieldWrapper<Scalars["String"]["output"]>
	/** When enabled, we no longer wait for this supplier's approval in the interest payment workflow. The supplier still receives the invite email and can view/correct data and accept or reject, but the payment proceeds independently. */
	skip_interest_payment_approval: EntireFieldWrapper<
		Scalars["Boolean"]["output"]
	>
	/** The website URL of the energy supplier. */
	url?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
}

export type ErrorType = {
	__typename?: "ErrorType"
	field: EntireFieldWrapper<Scalars["String"]["output"]>
	messages: EntireFieldWrapper<Array<Scalars["String"]["output"]>>
}

export type FiscalOverviewType = {
	__typename?: "FiscalOverviewType"
	value_end?: EntireFieldWrapper<Maybe<Scalars["Decimal"]["output"]>>
	value_start?: EntireFieldWrapper<Maybe<Scalars["Decimal"]["output"]>>
	year?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
}

export type IdentityVerificationSessionType = {
	__typename?: "IdentityVerificationSessionType"
	created_at: EntireFieldWrapper<Scalars["DateTime"]["output"]>
	/** The Mangopay-hosted URL where the user completes the verification session. */
	hosted_url: EntireFieldWrapper<Scalars["String"]["output"]>
	id: EntireFieldWrapper<Scalars["ID"]["output"]>
	/** Human-readable reasons the hosted verification session was refused, translated to the request language. */
	refusal_reasons?: EntireFieldWrapper<
		Maybe<Array<Maybe<Scalars["String"]["output"]>>>
	>
	status?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
}

/**
 * Start (or resume) a Mangopay hosted identity verification session for the
 * logged-in user and return the hosted URL the frontend should redirect them
 * to. The outcome of the session arrives asynchronously via webhooks; the
 * frontend should poll `me { kyc { state identity_verification { status } } }`
 * after the user returns, never interpret the return redirect itself.
 */
export type IdentityVerificationStart = {
	__typename?: "IdentityVerificationStart"
	/** URL of the Mangopay-hosted verification session to send the user to. Null when no session can be started (hosted flow disabled, user already verified with no renewal due, verification already processing, or the Mangopay user is not active). */
	hosted_url?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** True when the user must complete SCA enrollment before a session can be created; chain the sca_enrollment_start mutation first. */
	sca_required?: EntireFieldWrapper<Maybe<Scalars["Boolean"]["output"]>>
}

export type InstallerType = {
	__typename?: "InstallerType"
	id: EntireFieldWrapper<Scalars["ID"]["output"]>
	/** The logo image for this installer. */
	logo?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** The name of the installer. */
	name: EntireFieldWrapper<Scalars["String"]["output"]>
}

export type InterestPaymentListType = {
	__typename?: "InterestPaymentListType"
	/** Payment list, paginated by LimitOffsetPaginator */
	results?: EntireFieldWrapper<Maybe<Array<Maybe<InterestPaymentType>>>>
	/** Total count of matches elements */
	totalCount?: EntireFieldWrapper<Maybe<Scalars["Int"]["output"]>>
}

export type InterestPaymentListTypeResultsArgs = {
	limit?: InputMaybe<Scalars["Int"]["input"]>
	offset?: InputMaybe<Scalars["Int"]["input"]>
	ordering?: InputMaybe<Scalars["String"]["input"]>
}

export type InterestPaymentType = {
	__typename?: "InterestPaymentType"
	/** Created At */
	created?: EntireFieldWrapper<Maybe<Scalars["CustomDateTime"]["output"]>>
	days_since_period_end?: EntireFieldWrapper<Maybe<Scalars["Int"]["output"]>>
	download_csv_url?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	download_pdf_url?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	energy_supplier_acceptance_date_time?: EntireFieldWrapper<
		Maybe<Scalars["DateTime"]["output"]>
	>
	/** Django object unique identification field */
	id: EntireFieldWrapper<Scalars["ID"]["output"]>
	interest_amount?: EntireFieldWrapper<Maybe<Scalars["Decimal"]["output"]>>
	/** CAP/FLOOR Limit */
	interest_per_share_limit_applied?: EntireFieldWrapper<
		Maybe<PaymentInterestPerShareLimitAppliedEnum>
	>
	/** Interest Period */
	interestperiod?: EntireFieldWrapper<Maybe<InterestPeriodType>>
	/** Set to True when the payment is paid by the project owner. */
	is_paid_by_owner?: EntireFieldWrapper<Maybe<Scalars["Boolean"]["output"]>>
	/** Modified At */
	modified?: EntireFieldWrapper<Maybe<Scalars["CustomDateTime"]["output"]>>
	owner_verification?: EntireFieldWrapper<Maybe<OwnerVerificationType>>
	payment_completion_date?: EntireFieldWrapper<
		Maybe<Scalars["Date"]["output"]>
	>
	payment_date?: EntireFieldWrapper<Maybe<Scalars["Date"]["output"]>>
	payment_deadline_days?: EntireFieldWrapper<Maybe<Scalars["Int"]["output"]>>
	/** PaymentEntry list */
	payment_entries?: EntireFieldWrapper<Maybe<Array<PaymentEntryType>>>
	/** Payment Link */
	payment_link?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** Payment service provider chosen for interest payments. */
	payment_service_provider?: EntireFieldWrapper<
		Maybe<PaymentPaymentServiceProviderEnum>
	>
	progress_percentage?: EntireFieldWrapper<Maybe<Scalars["Int"]["output"]>>
	project?: EntireFieldWrapper<Maybe<ProjectType>>
	/** Project's CAP for interest per share (Euro) */
	project_cap_eur_interest_per_share?: EntireFieldWrapper<
		Maybe<Scalars["Float"]["output"]>
	>
	/** Project's FLOOR for interest per share (Euro) */
	project_floor_eur_interest_per_share?: EntireFieldWrapper<
		Maybe<Scalars["Float"]["output"]>
	>
	project_owner_acceptance_date_time?: EntireFieldWrapper<
		Maybe<Scalars["DateTime"]["output"]>
	>
	/** Payment State */
	state?: EntireFieldWrapper<Maybe<PaymentStateEnum>>
	supplier_verification?: EntireFieldWrapper<Maybe<SupplierVerificationType>>
	/** Total production based on measurements */
	total_production?: EntireFieldWrapper<Maybe<Scalars["Float"]["output"]>>
	total_production_investor?: EntireFieldWrapper<
		Maybe<Scalars["Decimal"]["output"]>
	>
	total_production_investor_limited?: EntireFieldWrapper<
		Maybe<Scalars["Decimal"]["output"]>
	>
	total_production_of_investors_with_supplier?: EntireFieldWrapper<
		Maybe<Scalars["Decimal"]["output"]>
	>
	total_production_of_investors_with_supplier_limited?: EntireFieldWrapper<
		Maybe<Scalars["Decimal"]["output"]>
	>
	/** Transaction fee invoice sent to project owner? */
	transaction_fee_invoiced?: EntireFieldWrapper<
		Maybe<Scalars["Boolean"]["output"]>
	>
	transaction_id?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
}

export type InterestPaymentTypePayment_EntriesArgs = {
	id?: InputMaybe<Scalars["ID"]["input"]>
	limit?: InputMaybe<Scalars["Int"]["input"]>
	name?: InputMaybe<Scalars["String"]["input"]>
	offset?: InputMaybe<Scalars["Int"]["input"]>
	ordering?: InputMaybe<Scalars["String"]["input"]>
	partner_supplier_only?: InputMaybe<Scalars["Boolean"]["input"]>
	state?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
	transaction_id?: InputMaybe<Scalars["String"]["input"]>
}

export type InterestPeriodType = {
	__typename?: "InterestPeriodType"
	/** Total amortization for this interest period. */
	amortization?: EntireFieldWrapper<Maybe<Scalars["Float"]["output"]>>
	/** Avg. Endex tarif (euros per mWh) for this period. Calculated automatically when the period starts. */
	average_endex_tariff?: EntireFieldWrapper<Maybe<Scalars["Float"]["output"]>>
	/** Cost in eurocent per kWh */
	cost_kwh?: EntireFieldWrapper<Maybe<Scalars["Float"]["output"]>>
	/** Created At */
	created?: EntireFieldWrapper<Maybe<Scalars["CustomDateTime"]["output"]>>
	/** End Date (up to and including) */
	end?: EntireFieldWrapper<Maybe<Scalars["CustomDate"]["output"]>>
	/** Expected interest amount as stated in the Information Memorandum. */
	expected_interest_amount?: EntireFieldWrapper<
		Maybe<Scalars["Float"]["output"]>
	>
	/** Django object unique identification field */
	id: EntireFieldWrapper<Scalars["ID"]["output"]>
	interest_amount?: EntireFieldWrapper<Maybe<Scalars["Decimal"]["output"]>>
	is_current_period?: EntireFieldWrapper<Maybe<Scalars["Boolean"]["output"]>>
	is_first_period?: EntireFieldWrapper<Maybe<Scalars["Boolean"]["output"]>>
	/** Modified At */
	modified?: EntireFieldWrapper<Maybe<Scalars["CustomDateTime"]["output"]>>
	payment_deadline_date?: EntireFieldWrapper<
		Maybe<Scalars["DateTime"]["output"]>
	>
	/** Total repayment for this interest period. */
	repayment?: EntireFieldWrapper<Maybe<Scalars["Float"]["output"]>>
	/** Start Date (from) */
	start?: EntireFieldWrapper<Maybe<Scalars["CustomDate"]["output"]>>
}

/** An enumeration. */
export const InvestmentAmountTotalCurrencyEnum = {
	/** Euro */
	Eur: "EUR",
} as const

export type InvestmentAmountTotalCurrencyEnum =
	(typeof InvestmentAmountTotalCurrencyEnum)[keyof typeof InvestmentAmountTotalCurrencyEnum]
export type InvestmentCampaignDocument = {
	__typename?: "InvestmentCampaignDocument"
	description?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	document_type?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	file_name?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	title?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	url?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
}

export type InvestmentCampaignProjectType = {
	__typename?: "InvestmentCampaignProjectType"
	/** Total valuation of the project in Euros. */
	amount_total?: EntireFieldWrapper<Maybe<Scalars["Float"]["output"]>>
	/** amount total currency */
	amount_total_currency?: EntireFieldWrapper<
		Maybe<ProjectHorizonAmountTotalCurrencyEnum>
	>
	/** Created At */
	created_at?: EntireFieldWrapper<Maybe<Scalars["CustomDateTime"]["output"]>>
	/** Deleted At */
	deleted_at?: EntireFieldWrapper<Maybe<Scalars["CustomDateTime"]["output"]>>
	/** Detailed description of the project. */
	description?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** Django object unique identification field */
	id: EntireFieldWrapper<Scalars["ID"]["output"]>
	investment_campaigns?: EntireFieldWrapper<
		Maybe<Array<Maybe<InvestmentCampaignType>>>
	>
	/** Flexible financing maximum amount. */
	maximum_amount_total?: EntireFieldWrapper<Maybe<Scalars["Float"]["output"]>>
	/** maximum amount total currency */
	maximum_amount_total_currency?: EntireFieldWrapper<
		Maybe<ProjectHorizonMaximumAmountTotalCurrencyEnum>
	>
	/** Modified At */
	modified_at?: EntireFieldWrapper<Maybe<Scalars["CustomDateTime"]["output"]>>
	/** The organisation that owns this project. */
	owner?: EntireFieldWrapper<Maybe<OrganisationType>>
	/** Total panels contained by the project. */
	panels?: EntireFieldWrapper<Maybe<Scalars["Int"]["output"]>>
	/** Partner organizations associated with this project. */
	partners?: EntireFieldWrapper<Maybe<Array<Maybe<PartnerType>>>>
	project?: EntireFieldWrapper<Maybe<ProjectType>>
	/** The ID of the Mangopay remote wallet associated with this project. */
	project_wallet_id?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** Project title/name. Should be unique. */
	title?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** Universally unique identifier. */
	uuid?: EntireFieldWrapper<Maybe<Scalars["UUID"]["output"]>>
	/** Short version of the universally unique identifier. */
	uuid_short?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
}

export type InvestmentCampaignProjectTypePartnersArgs = {
	id?: InputMaybe<Scalars["ID"]["input"]>
	name__icontains?: InputMaybe<Scalars["String"]["input"]>
}

export type InvestmentCampaignType = {
	__typename?: "InvestmentCampaignType"
	/** Total amount raised till date from all the successful and confirmed payments. */
	amount_raised?: EntireFieldWrapper<Maybe<Scalars["Float"]["output"]>>
	/** amount raised currency */
	amount_raised_currency?: EntireFieldWrapper<
		Maybe<CrowdfundingCampaignAmountRaisedCurrencyEnum>
	>
	/** Amount to be raised in Euros. */
	amount_requested?: EntireFieldWrapper<Maybe<Scalars["Float"]["output"]>>
	/** amount requested currency */
	amount_requested_currency?: EntireFieldWrapper<
		Maybe<CrowdfundingCampaignAmountRequestedCurrencyEnum>
	>
	/** The date and time when the crowdfunding campaign stops accepting investments. */
	campaign_end_at?: EntireFieldWrapper<
		Maybe<Scalars["CustomDateTime"]["output"]>
	>
	/** The date and time when the crowdfunding campaign starts accepting investments. */
	campaign_start_at?: EntireFieldWrapper<
		Maybe<Scalars["CustomDateTime"]["output"]>
	>
	/** If there is no fixed start date select this option. */
	coming_soon?: EntireFieldWrapper<Maybe<Scalars["Boolean"]["output"]>>
	/** Created At */
	created_at?: EntireFieldWrapper<Maybe<Scalars["CustomDateTime"]["output"]>>
	/** Deleted At */
	deleted_at?: EntireFieldWrapper<Maybe<Scalars["CustomDateTime"]["output"]>>
	/** Allow the bank transfers for the invest amount greater than 10000. */
	enable_bank_transfers_button?: EntireFieldWrapper<
		Maybe<Scalars["Boolean"]["output"]>
	>
	/** Estimated production in kWh per share per year. */
	estimated_annual_production_per_share?: EntireFieldWrapper<
		Maybe<Scalars["Float"]["output"]>
	>
	/** Django object unique identification field */
	id: EntireFieldWrapper<Scalars["ID"]["output"]>
	/** External ID of the imported record */
	imported_id?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** Date of the information memorandum document related to this campaign. */
	information_memorandum_date?: EntireFieldWrapper<
		Maybe<Scalars["CustomDate"]["output"]>
	>
	is_imported?: EntireFieldWrapper<Maybe<Scalars["Boolean"]["output"]>>
	/** Maximum investment amount in euros used for investment slider. */
	max_investment_amount?: EntireFieldWrapper<
		Maybe<Scalars["Float"]["output"]>
	>
	/** max investment amount currency */
	max_investment_amount_currency?: EntireFieldWrapper<
		Maybe<CrowdfundingCampaignMaxInvestmentAmountCurrencyEnum>
	>
	/** Minimum investment amount in euros used for investment slider. */
	min_investment_amount?: EntireFieldWrapper<
		Maybe<Scalars["Float"]["output"]>
	>
	/** min investment amount currency */
	min_investment_amount_currency?: EntireFieldWrapper<
		Maybe<CrowdfundingCampaignMinInvestmentAmountCurrencyEnum>
	>
	/** Modified At */
	modified_at?: EntireFieldWrapper<Maybe<Scalars["CustomDateTime"]["output"]>>
	/** Funding will be allowed over 100% (campaign will not succeed automatically). */
	overfunding_allowed?: EntireFieldWrapper<
		Maybe<Scalars["Boolean"]["output"]>
	>
	page_url?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** Part of total panels for the project which will be paid for by this funding. */
	panels?: EntireFieldWrapper<Maybe<Scalars["Int"]["output"]>>
	/** The investment project associated with this funding. */
	project?: EntireFieldWrapper<Maybe<InvestmentCampaignProjectType>>
	/** Total solar shares to be disbursed for this campaign. */
	shares?: EntireFieldWrapper<Maybe<Scalars["Int"]["output"]>>
	/** No. of solar shares per panel. */
	shares_per_panel?: EntireFieldWrapper<Maybe<Scalars["Int"]["output"]>>
	/** Funding state. */
	state?: EntireFieldWrapper<Maybe<CrowdfundingCampaignStateEnum>>
	/** Step investment amount in euros used for investment slider. */
	step_investment_amount?: EntireFieldWrapper<
		Maybe<Scalars["Float"]["output"]>
	>
	/** step investment amount currency */
	step_investment_amount_currency?: EntireFieldWrapper<
		Maybe<CrowdfundingCampaignStepInvestmentAmountCurrencyEnum>
	>
	/** Amount per Share. */
	unit_share_amount?: EntireFieldWrapper<Maybe<Scalars["Float"]["output"]>>
	/** unit share amount currency */
	unit_share_amount_currency?: EntireFieldWrapper<
		Maybe<CrowdfundingCampaignUnitShareAmountCurrencyEnum>
	>
	/** Universally unique identifier. */
	uuid?: EntireFieldWrapper<Maybe<Scalars["UUID"]["output"]>>
	/** Short version of the universally unique identifier. */
	uuid_short?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
}

export type InvestmentListType = {
	__typename?: "InvestmentListType"
	/** Investment list, paginated by LimitOffsetPaginator */
	results?: EntireFieldWrapper<Maybe<Array<Maybe<InvestmentType>>>>
	/** Total count of matches elements */
	totalCount?: EntireFieldWrapper<Maybe<Scalars["Int"]["output"]>>
}

export type InvestmentListTypeResultsArgs = {
	limit?: InputMaybe<Scalars["Int"]["input"]>
	offset?: InputMaybe<Scalars["Int"]["input"]>
	ordering?: InputMaybe<Scalars["String"]["input"]>
}

/** An enumeration. */
export const InvestmentPaymentAmountCurrencyEnum = {
	/** Euro */
	Eur: "EUR",
} as const

export type InvestmentPaymentAmountCurrencyEnum =
	(typeof InvestmentPaymentAmountCurrencyEnum)[keyof typeof InvestmentPaymentAmountCurrencyEnum]
/** An enumeration. */
export const InvestmentRefundAmountCurrencyEnum = {
	/** Euro */
	Eur: "EUR",
} as const

export type InvestmentRefundAmountCurrencyEnum =
	(typeof InvestmentRefundAmountCurrencyEnum)[keyof typeof InvestmentRefundAmountCurrencyEnum]
/** An enumeration. */
export const InvestmentRefundReasonEnum = {
	/** No KYC ID provided */
	NoKycId: "NO_KYC_ID",
	/** Other reason */
	Other: "OTHER",
	/** Project overfunded */
	Overfunding: "OVERFUNDING",
} as const

export type InvestmentRefundReasonEnum =
	(typeof InvestmentRefundReasonEnum)[keyof typeof InvestmentRefundReasonEnum]
/** An enumeration. */
export const InvestmentStateEnum = {
	/** Cancelled */
	Cancelled: "CANCELLED",
	/** Draft */
	Draft: "DRAFT",
	/** Error */
	Error: "ERROR",
	/** Partial Refund Complete */
	PartialRefundComplete: "PARTIAL_REFUND_COMPLETE",
	/** Partial Refund Failed */
	PartialRefundFailed: "PARTIAL_REFUND_FAILED",
	/** Processing Partial Refund */
	PartialRefundProcessing: "PARTIAL_REFUND_PROCESSING",
	/** Payment Complete */
	PaymentComplete: "PAYMENT_COMPLETE",
	/** Payment Partially Complete */
	PaymentPartial: "PAYMENT_PARTIAL",
	/** Processing Payment */
	PaymentProcessing: "PAYMENT_PROCESSING",
	/** Payment Processor Error  */
	PaymentProcessorError: "PAYMENT_PROCESSOR_ERROR",
	/** Refund Complete */
	RefundComplete: "REFUND_COMPLETE",
	/** Refund Failed */
	RefundFailed: "REFUND_FAILED",
	/** Processing Refund */
	RefundProcessing: "REFUND_PROCESSING",
	/** User Cancelled */
	UserCancelled: "USER_CANCELLED",
} as const

export type InvestmentStateEnum =
	(typeof InvestmentStateEnum)[keyof typeof InvestmentStateEnum]
export type InvestmentTestType = {
	__typename?: "InvestmentTestType"
	/** The category of the investment test (Experience, Questions, or Loss Calculator). */
	category: EntireFieldWrapper<CoreInvestmentTestCategoryChoices>
	created_at: EntireFieldWrapper<Scalars["DateTime"]["output"]>
	/** Optional extra data for specific tests */
	data?: EntireFieldWrapper<Maybe<Scalars["JSONString"]["output"]>>
	/** The experience level of the investor (Expert or Novice). */
	experience?: EntireFieldWrapper<Maybe<CoreInvestmentTestExperienceChoices>>
	/** The date when this investment test expires. */
	expiry_date?: EntireFieldWrapper<Maybe<Scalars["Date"]["output"]>>
	id: EntireFieldWrapper<Scalars["ID"]["output"]>
}

export type InvestmentType = {
	__typename?: "InvestmentType"
	agreement_file?: EntireFieldWrapper<Maybe<Scalars["FileField"]["output"]>>
	/** Total amount for this investment including vouchers payments, discounts etc. */
	amount_total?: EntireFieldWrapper<Maybe<Scalars["Float"]["output"]>>
	/** amount total currency */
	amount_total_currency?: EntireFieldWrapper<
		Maybe<InvestmentAmountTotalCurrencyEnum>
	>
	/** If true, the investor's name will not be shown on the website. */
	anonymous?: EntireFieldWrapper<Maybe<Scalars["Boolean"]["output"]>>
	/** Comment or motivation over the investment. */
	comment?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** Created At */
	created_at?: EntireFieldWrapper<Maybe<Scalars["CustomDateTime"]["output"]>>
	/** The crowdfunding campaign this investment belongs to. */
	crowdfunding_campaign?: EntireFieldWrapper<Maybe<InvestmentCampaignType>>
	/** Custom text for the refund reason in cases where the refund reason is anything other than No_KYC/Overfunding. */
	custom_refund_reason_text?: EntireFieldWrapper<
		Maybe<Scalars["String"]["output"]>
	>
	/** Deleted At */
	deleted_at?: EntireFieldWrapper<Maybe<Scalars["CustomDateTime"]["output"]>>
	/** Email address of the investor. */
	email?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** Django object unique identification field */
	id: EntireFieldWrapper<Scalars["ID"]["output"]>
	/** The state of KYC (Know Your Customer) validation for this investment. */
	kyc_validation_state?: EntireFieldWrapper<
		Maybe<Scalars["String"]["output"]>
	>
	/** Modified At */
	modified_at?: EntireFieldWrapper<Maybe<Scalars["CustomDateTime"]["output"]>>
	/** Amount to charge via a payment method. */
	payment_amount?: EntireFieldWrapper<Maybe<Scalars["Float"]["output"]>>
	/** payment amount currency */
	payment_amount_currency?: EntireFieldWrapper<
		Maybe<InvestmentPaymentAmountCurrencyEnum>
	>
	personal_data?: EntireFieldWrapper<Maybe<InvestorPersonalDataType>>
	/** Amount to refund via a payment method. */
	refund_amount?: EntireFieldWrapper<Maybe<Scalars["Float"]["output"]>>
	/** refund amount currency */
	refund_amount_currency?: EntireFieldWrapper<
		Maybe<InvestmentRefundAmountCurrencyEnum>
	>
	/** Reason for refunding the full investment. Based on this reason, we are sending a custom email to the user. */
	refund_reason?: EntireFieldWrapper<Maybe<InvestmentRefundReasonEnum>>
	/** Investment related remarks for internal administration. */
	remarks?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** Current state of the investment. */
	state?: EntireFieldWrapper<Maybe<InvestmentStateEnum>>
	transaction?: EntireFieldWrapper<Maybe<CrowdfundingTransactionType>>
	/** Universally unique identifier. */
	uuid?: EntireFieldWrapper<Maybe<Scalars["UUID"]["output"]>>
	/** Short version of the universally unique identifier. */
	uuid_short?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
}

/** An enumeration. */
export const InvestorCountryEnum = {
	/** Andorra */
	Ad: "AD",
	/** United Arab Emirates */
	Ae: "AE",
	/** Afghanistan */
	Af: "AF",
	/** Antigua and Barbuda */
	Ag: "AG",
	/** Anguilla */
	Ai: "AI",
	/** Albania */
	Al: "AL",
	/** Armenia */
	Am: "AM",
	/** Angola */
	Ao: "AO",
	/** Antarctica */
	Aq: "AQ",
	/** Argentina */
	Ar: "AR",
	/** American Samoa */
	As: "AS",
	/** Austria */
	At: "AT",
	/** Australia */
	Au: "AU",
	/** Aruba */
	Aw: "AW",
	/** Åland Islands */
	Ax: "AX",
	/** Azerbaijan */
	Az: "AZ",
	/** Bosnia and Herzegovina */
	Ba: "BA",
	/** Barbados */
	Bb: "BB",
	/** Bangladesh */
	Bd: "BD",
	/** Belgium */
	Be: "BE",
	/** Burkina Faso */
	Bf: "BF",
	/** Bulgaria */
	Bg: "BG",
	/** Bahrain */
	Bh: "BH",
	/** Burundi */
	Bi: "BI",
	/** Benin */
	Bj: "BJ",
	/** Saint Barthélemy */
	Bl: "BL",
	/** Bermuda */
	Bm: "BM",
	/** Brunei */
	Bn: "BN",
	/** Bolivia */
	Bo: "BO",
	/** Bonaire, Sint Eustatius and Saba */
	Bq: "BQ",
	/** Brazil */
	Br: "BR",
	/** Bahamas (The) */
	Bs: "BS",
	/** Bhutan */
	Bt: "BT",
	/** Bouvet Island */
	Bv: "BV",
	/** Botswana */
	Bw: "BW",
	/** Belarus */
	By: "BY",
	/** Belize */
	Bz: "BZ",
	/** Canada */
	Ca: "CA",
	/** Cocos (Keeling) Islands */
	Cc: "CC",
	/** Democratic Republic of the Congo */
	Cd: "CD",
	/** Central African Republic */
	Cf: "CF",
	/** Congo */
	Cg: "CG",
	/** Switzerland */
	Ch: "CH",
	/** Côte d'Ivoire */
	Ci: "CI",
	/** Cook Islands */
	Ck: "CK",
	/** Chile */
	Cl: "CL",
	/** Cameroon */
	Cm: "CM",
	/** China */
	Cn: "CN",
	/** Colombia */
	Co: "CO",
	/** Costa Rica */
	Cr: "CR",
	/** Cuba */
	Cu: "CU",
	/** Cabo Verde */
	Cv: "CV",
	/** Curaçao */
	Cw: "CW",
	/** Christmas Island */
	Cx: "CX",
	/** Cyprus */
	Cy: "CY",
	/** Czechia */
	Cz: "CZ",
	/** Germany */
	De: "DE",
	/** Djibouti */
	Dj: "DJ",
	/** Denmark */
	Dk: "DK",
	/** Dominica */
	Dm: "DM",
	/** Dominican Republic */
	Do: "DO",
	/** Algeria */
	Dz: "DZ",
	/** Ecuador */
	Ec: "EC",
	/** Estonia */
	Ee: "EE",
	/** Egypt */
	Eg: "EG",
	/** Western Sahara */
	Eh: "EH",
	/** Eritrea */
	Er: "ER",
	/** Spain */
	Es: "ES",
	/** Ethiopia */
	Et: "ET",
	/** Finland */
	Fi: "FI",
	/** Fiji */
	Fj: "FJ",
	/** Falkland Islands (Malvinas) */
	Fk: "FK",
	/** Micronesia */
	Fm: "FM",
	/** Faroe Islands */
	Fo: "FO",
	/** France */
	Fr: "FR",
	/** Gabon */
	Ga: "GA",
	/** United Kingdom */
	Gb: "GB",
	/** Grenada */
	Gd: "GD",
	/** Georgia */
	Ge: "GE",
	/** French Guiana */
	Gf: "GF",
	/** Guernsey */
	Gg: "GG",
	/** Ghana */
	Gh: "GH",
	/** Gibraltar */
	Gi: "GI",
	/** Greenland */
	Gl: "GL",
	/** Gambia */
	Gm: "GM",
	/** Guinea */
	Gn: "GN",
	/** Guadeloupe */
	Gp: "GP",
	/** Equatorial Guinea */
	Gq: "GQ",
	/** Greece */
	Gr: "GR",
	/** South Georgia */
	Gs: "GS",
	/** Guatemala */
	Gt: "GT",
	/** Guam */
	Gu: "GU",
	/** Guinea-Bissau */
	Gw: "GW",
	/** Guyana */
	Gy: "GY",
	/** Hong Kong */
	Hk: "HK",
	/** Heard Island and McDonald Islands */
	Hm: "HM",
	/** Honduras */
	Hn: "HN",
	/** Croatia */
	Hr: "HR",
	/** Haiti */
	Ht: "HT",
	/** Hungary */
	Hu: "HU",
	/** Indonesia */
	Id: "ID",
	/** Ireland */
	Ie: "IE",
	/** Israel */
	Il: "IL",
	/** Isle of Man */
	Im: "IM",
	/** India */
	In: "IN",
	/** British Indian Ocean Territory */
	Io: "IO",
	/** Iraq */
	Iq: "IQ",
	/** Iran */
	Ir: "IR",
	/** Iceland */
	Is: "IS",
	/** Italy */
	It: "IT",
	/** Jersey */
	Je: "JE",
	/** Jamaica */
	Jm: "JM",
	/** Jordan */
	Jo: "JO",
	/** Japan */
	Jp: "JP",
	/** Kenya */
	Ke: "KE",
	/** Kyrgyzstan */
	Kg: "KG",
	/** Cambodia */
	Kh: "KH",
	/** Kiribati */
	Ki: "KI",
	/** Comoros */
	Km: "KM",
	/** Saint Kitts and Nevis */
	Kn: "KN",
	/** North Korea */
	Kp: "KP",
	/** South Korea */
	Kr: "KR",
	/** Kuwait */
	Kw: "KW",
	/** Cayman Islands */
	Ky: "KY",
	/** Kazakhstan */
	Kz: "KZ",
	/** Laos */
	La: "LA",
	/** Lebanon */
	Lb: "LB",
	/** Saint Lucia */
	Lc: "LC",
	/** Liechtenstein */
	Li: "LI",
	/** Sri Lanka */
	Lk: "LK",
	/** Liberia */
	Lr: "LR",
	/** Lesotho */
	Ls: "LS",
	/** Lithuania */
	Lt: "LT",
	/** Luxembourg */
	Lu: "LU",
	/** Latvia */
	Lv: "LV",
	/** Libya */
	Ly: "LY",
	/** Morocco */
	Ma: "MA",
	/** Monaco */
	Mc: "MC",
	/** Moldova */
	Md: "MD",
	/** Montenegro */
	Me: "ME",
	/** Saint Martin (French part) */
	Mf: "MF",
	/** Madagascar */
	Mg: "MG",
	/** Marshall Islands */
	Mh: "MH",
	/** North Macedonia */
	Mk: "MK",
	/** Mali */
	Ml: "ML",
	/** Myanmar */
	Mm: "MM",
	/** Mongolia */
	Mn: "MN",
	/** Macao */
	Mo: "MO",
	/** Northern Mariana Islands */
	Mp: "MP",
	/** Martinique */
	Mq: "MQ",
	/** Mauritania */
	Mr: "MR",
	/** Montserrat */
	Ms: "MS",
	/** Malta */
	Mt: "MT",
	/** Mauritius */
	Mu: "MU",
	/** Maldives */
	Mv: "MV",
	/** Malawi */
	Mw: "MW",
	/** Mexico */
	Mx: "MX",
	/** Malaysia */
	My: "MY",
	/** Mozambique */
	Mz: "MZ",
	/** Namibia */
	Na: "NA",
	/** New Caledonia */
	Nc: "NC",
	/** Niger */
	Ne: "NE",
	/** Norfolk Island */
	Nf: "NF",
	/** Nigeria */
	Ng: "NG",
	/** Nicaragua */
	Ni: "NI",
	/** Netherlands */
	Nl: "NL",
	/** Norway */
	No: "NO",
	/** Nepal */
	Np: "NP",
	/** Nauru */
	Nr: "NR",
	/** Niue */
	Nu: "NU",
	/** New Zealand */
	Nz: "NZ",
	/** Oman */
	Om: "OM",
	/** Panama */
	Pa: "PA",
	/** Peru */
	Pe: "PE",
	/** French Polynesia */
	Pf: "PF",
	/** Papua New Guinea */
	Pg: "PG",
	/** Philippines */
	Ph: "PH",
	/** Pakistan */
	Pk: "PK",
	/** Poland */
	Pl: "PL",
	/** Saint Pierre and Miquelon */
	Pm: "PM",
	/** Pitcairn */
	Pn: "PN",
	/** Puerto Rico */
	Pr: "PR",
	/** Palestine */
	Ps: "PS",
	/** Portugal */
	Pt: "PT",
	/** Palau */
	Pw: "PW",
	/** Paraguay */
	Py: "PY",
	/** Qatar */
	Qa: "QA",
	/** Réunion */
	Re: "RE",
	/** Romania */
	Ro: "RO",
	/** Serbia */
	Rs: "RS",
	/** Russia */
	Ru: "RU",
	/** Rwanda */
	Rw: "RW",
	/** Saudi Arabia */
	Sa: "SA",
	/** Solomon Islands */
	Sb: "SB",
	/** Seychelles */
	Sc: "SC",
	/** Sudan */
	Sd: "SD",
	/** Sweden */
	Se: "SE",
	/** Singapore */
	Sg: "SG",
	/** Saint Helena */
	Sh: "SH",
	/** Slovenia */
	Si: "SI",
	/** Svalbard and Jan Mayen */
	Sj: "SJ",
	/** Slovakia */
	Sk: "SK",
	/** Sierra Leone */
	Sl: "SL",
	/** San Marino */
	Sm: "SM",
	/** Senegal */
	Sn: "SN",
	/** Somalia */
	So: "SO",
	/** Suriname */
	Sr: "SR",
	/** South Sudan */
	Ss: "SS",
	/** Sao Tome and Principe */
	St: "ST",
	/** El Salvador */
	Sv: "SV",
	/** Sint Maarten (Dutch part) */
	Sx: "SX",
	/** Syria */
	Sy: "SY",
	/** Eswatini */
	Sz: "SZ",
	/** Turks and Caicos Islands */
	Tc: "TC",
	/** Chad */
	Td: "TD",
	/** French Southern Territories */
	Tf: "TF",
	/** Togo */
	Tg: "TG",
	/** Thailand */
	Th: "TH",
	/** Tajikistan */
	Tj: "TJ",
	/** Tokelau */
	Tk: "TK",
	/** Timor-Leste */
	Tl: "TL",
	/** Turkmenistan */
	Tm: "TM",
	/** Tunisia */
	Tn: "TN",
	/** Tonga */
	To: "TO",
	/** Türkiye */
	Tr: "TR",
	/** Trinidad and Tobago */
	Tt: "TT",
	/** Tuvalu */
	Tv: "TV",
	/** Taiwan */
	Tw: "TW",
	/** Tanzania */
	Tz: "TZ",
	/** Ukraine */
	Ua: "UA",
	/** Uganda */
	Ug: "UG",
	/** United States Minor Outlying Islands */
	Um: "UM",
	/** United States of America */
	Us: "US",
	/** Uruguay */
	Uy: "UY",
	/** Uzbekistan */
	Uz: "UZ",
	/** Vatican City */
	Va: "VA",
	/** Saint Vincent and the Grenadines */
	Vc: "VC",
	/** Venezuela */
	Ve: "VE",
	/** Virgin Islands (British) */
	Vg: "VG",
	/** Virgin Islands (U.S.) */
	Vi: "VI",
	/** Vietnam */
	Vn: "VN",
	/** Vanuatu */
	Vu: "VU",
	/** Wallis and Futuna */
	Wf: "WF",
	/** Samoa */
	Ws: "WS",
	/** Yemen */
	Ye: "YE",
	/** Mayotte */
	Yt: "YT",
	/** South Africa */
	Za: "ZA",
	/** Zambia */
	Zm: "ZM",
	/** Zimbabwe */
	Zw: "ZW",
} as const

export type InvestorCountryEnum =
	(typeof InvestorCountryEnum)[keyof typeof InvestorCountryEnum]
/** An enumeration. */
export const InvestorHomeTypeEnum = {
	/** Appartement */
	App: "APP",
	/** Twee-onder-één-kap-woning */
	A_21K: "A_21K",
	/** Hoekwoning */
	Hoe: "HOE",
	/** Onbekend / overig */
	Onb: "ONB",
	/** Tussenwoning */
	Tus: "TUS",
	/** Vrijstaande woning */
	Vry: "VRY",
} as const

export type InvestorHomeTypeEnum =
	(typeof InvestorHomeTypeEnum)[keyof typeof InvestorHomeTypeEnum]
export type InvestorInternalRateOfReturns = {
	__typename?: "InvestorInternalRateOfReturns"
	expected_internal_rate_of_return?: EntireFieldWrapper<
		Maybe<Scalars["Decimal"]["output"]>
	>
	internal_rate_of_return?: EntireFieldWrapper<
		Maybe<Scalars["Decimal"]["output"]>
	>
}

/** An enumeration. */
export const InvestorPersonalDataCountryEnum = {
	/** Austria */
	At: "AT",
	/** Belgium */
	Be: "BE",
	/** Bulgaria */
	Bg: "BG",
	/** Cyprus */
	Cy: "CY",
	/** Czechia */
	Cz: "CZ",
	/** Germany */
	De: "DE",
	/** Denmark */
	Dk: "DK",
	/** Estonia */
	Ee: "EE",
	/** Spain */
	Es: "ES",
	/** Finland */
	Fi: "FI",
	/** France */
	Fr: "FR",
	/** Greece */
	Gr: "GR",
	/** Croatia */
	Hr: "HR",
	/** Hungary */
	Hu: "HU",
	/** Ireland */
	Ie: "IE",
	/** Italy */
	It: "IT",
	/** Lithuania */
	Lt: "LT",
	/** Luxembourg */
	Lu: "LU",
	/** Latvia */
	Lv: "LV",
	/** Malta */
	Mt: "MT",
	/** Netherlands */
	Nl: "NL",
	/** Poland */
	Pl: "PL",
	/** Portugal */
	Pt: "PT",
	/** Romania */
	Ro: "RO",
	/** Sweden */
	Se: "SE",
	/** Slovenia */
	Si: "SI",
	/** Slovakia */
	Sk: "SK",
} as const

export type InvestorPersonalDataCountryEnum =
	(typeof InvestorPersonalDataCountryEnum)[keyof typeof InvestorPersonalDataCountryEnum]
/** An enumeration. */
export const InvestorPersonalDataIdentityTypeEnum = {
	/** Business */
	Business: "BUSINESS",
	/** Private */
	Private: "PRIVATE",
	/** Unavailable */
	Unavailable: "UNAVAILABLE",
} as const

export type InvestorPersonalDataIdentityTypeEnum =
	(typeof InvestorPersonalDataIdentityTypeEnum)[keyof typeof InvestorPersonalDataIdentityTypeEnum]
export type InvestorPersonalDataType = {
	__typename?: "InvestorPersonalDataType"
	/** Street Address, P.O. Box, Company Name, c/o. 1–255 characters; the characters (, ) and / are not allowed (rejected by our payment provider). */
	address_line_primary?: EntireFieldWrapper<
		Maybe<Scalars["String"]["output"]>
	>
	/** Street Nr, House Nr, Apartment, Suite, Unit, Building, Floor etc. Up to 255 characters; the characters (, ) and / are not allowed (rejected by our payment provider). */
	address_line_secondary?: EntireFieldWrapper<
		Maybe<Scalars["String"]["output"]>
	>
	/** Name as officially registered at KVK. Up to 100 characters, no leading or trailing whitespace. */
	business_legal_name?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** Business registration number (e.g. KVK for NL, HRB for DE, BE0… for BE). Up to 40 characters. */
	business_nr?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** City, Area, Locality etc. 1–80 characters; the characters & , . : _ are not allowed (rejected by our payment provider). */
	city?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** Currently only projects in The Netherlands can be setup. */
	country?: EntireFieldWrapper<Maybe<InvestorPersonalDataCountryEnum>>
	/** Created At */
	created_at?: EntireFieldWrapper<Maybe<Scalars["CustomDateTime"]["output"]>>
	/** e.g. 31/01/1980, 31-12-1980 etc. */
	date_of_birth?: EntireFieldWrapper<Maybe<Scalars["CustomDate"]["output"]>>
	/** Deleted At */
	deleted_at?: EntireFieldWrapper<Maybe<Scalars["CustomDateTime"]["output"]>>
	/** First name as on the bank account. */
	first_name?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** Django object unique identification field */
	id: EntireFieldWrapper<Scalars["ID"]["output"]>
	/** The type of identity document provided by the investor. */
	identity_type?: EntireFieldWrapper<
		Maybe<InvestorPersonalDataIdentityTypeEnum>
	>
	/** Initials as on bank card. */
	initials?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** Last name as on the bank account. */
	last_name?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** Modified At */
	modified_at?: EntireFieldWrapper<Maybe<Scalars["CustomDateTime"]["output"]>>
	/** The postal code or ZIP code of the investor's address. 1–10 characters; the characters ( ) & , . : _ ' / are not allowed (rejected by our payment provider). */
	postal_code?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** e.g. +31612345678. */
	telephone_nr?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** Universally unique identifier. */
	uuid?: EntireFieldWrapper<Maybe<Scalars["UUID"]["output"]>>
	/** Short version of the universally unique identifier. */
	uuid_short?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
}

export type InvestorProductionStatsType = {
	__typename?: "InvestorProductionStatsType"
	cumulative_production_data?: EntireFieldWrapper<
		Maybe<Array<Maybe<StatsProductionGeneric>>>
	>
	/**
	 * Percentage difference between actual and expected production.
	 *         Positive means above expected, negative means below expected.
	 *
	 */
	delta_production_per_investor?: EntireFieldWrapper<
		Maybe<Scalars["Decimal"]["output"]>
	>
	expected_cumulative_production_data?: EntireFieldWrapper<
		Maybe<Array<Maybe<StatsProductionGeneric>>>
	>
	expected_production_data?: EntireFieldWrapper<
		Maybe<Array<Maybe<StatsProductionGeneric>>>
	>
	expected_production_per_project_in_kwh?: EntireFieldWrapper<
		Maybe<Array<Maybe<InvestorStatsExpectedProductionPerProjectInKwh>>>
	>
	/**
	 * Total CO2 saved by this investor: production in kWh multiplied by the average CO2 cost
	 *         for the period.
	 *
	 */
	investor_co2_saving?: EntireFieldWrapper<
		Maybe<Scalars["Decimal"]["output"]>
	>
	/**
	 * Total cost saved by this investor, calculated as production in kWh multiplied by a
	 *         weighted average cost per kWh across overlapping interest periods.
	 *
	 */
	investor_cost_saving?: EntireFieldWrapper<
		Maybe<Scalars["Decimal"]["output"]>
	>
	/**
	 * Total production across all relevant projects, scaled by the investor's share ratio in each.
	 *         Returns a single Decimal value in Wh.
	 *
	 */
	investor_generated_power?: EntireFieldWrapper<
		Maybe<Scalars["Decimal"]["output"]>
	>
	investor_generated_power_by_project_kwh?: EntireFieldWrapper<
		Maybe<Array<Maybe<InvestorStatsInvestorGeneratedPowerByProjectKwh>>>
	>
	/** Total investor production across all relevant projects in kWh (converted from Wh). */
	investor_generated_power_in_kwh?: EntireFieldWrapper<
		Maybe<Scalars["Decimal"]["output"]>
	>
	/** Returns the greater of expected vs actual production in kWh. Used to set the upper bound on UI graphs. */
	max_production?: EntireFieldWrapper<Maybe<Scalars["Decimal"]["output"]>>
	/** Investor production grouped by time buckets, excluding the last (incomplete) bucket. */
	production_by_time?: EntireFieldWrapper<
		Maybe<Array<Maybe<InvestorStatsProductionByTimeType>>>
	>
	production_data?: EntireFieldWrapper<
		Maybe<Array<Maybe<StatsProductionGeneric>>>
	>
	production_for_day?: EntireFieldWrapper<Maybe<StatsProductionForDay>>
	/** Investor's aggregate production speed, weighted by their share count in each project. */
	production_speed?: EntireFieldWrapper<Maybe<Scalars["Decimal"]["output"]>>
	/**
	 * ROI as investor cost savings divided by total nominal value of all investor shares.
	 *         Uses all investor shares (not just relevant ones). Returns None if the investor has no shares.
	 *
	 */
	return_on_investment?: EntireFieldWrapper<
		Maybe<Scalars["Decimal"]["output"]>
	>
	/** Total expected production in kWh across all relevant projects, scaled by the investor's share ratio. */
	total_expected_production_in_kwh?: EntireFieldWrapper<
		Maybe<Scalars["Decimal"]["output"]>
	>
	/**
	 * Total investor production in Wh including estimated production since the last measurement.
	 *         Used for real-time counters so the value stays consistent between page loads.
	 *
	 */
	total_production_for_counter?: EntireFieldWrapper<
		Maybe<Scalars["Decimal"]["output"]>
	>
	/**
	 * Actual production as a percentage of expected production (100 = exactly on target).
	 *         Returns None if there is no expected production.
	 *
	 */
	total_production_percentage?: EntireFieldWrapper<
		Maybe<Scalars["Decimal"]["output"]>
	>
}

export type InvestorProductionStatsTypeCumulative_Production_DataArgs = {
	grouped_by?: Scalars["String"]["input"]
}

export type InvestorProductionStatsTypeExpected_Cumulative_Production_DataArgs =
	{
		grouped_by?: Scalars["String"]["input"]
	}

export type InvestorProductionStatsTypeExpected_Production_DataArgs = {
	grouped_by?: Scalars["String"]["input"]
}

export type InvestorProductionStatsTypeProduction_DataArgs = {
	grouped_by?: Scalars["String"]["input"]
}

export type InvestorProductionStatsTypeProduction_For_DayArgs = {
	day?: InputMaybe<Scalars["Date"]["input"]>
}

export type InvestorSharesValueStatsType = {
	__typename?: "InvestorSharesValueStatsType"
	/**
	 * Returns (expected_IRR, actual_IRR), each weighted by the investor's investment ratio
	 *         (nominal value proportion) in each project.
	 *
	 */
	internal_rate_of_returns?: EntireFieldWrapper<
		Maybe<InvestorInternalRateOfReturns>
	>
	number_of_shares_per_project?: EntireFieldWrapper<
		Maybe<Array<Maybe<InvestorStatsNumberOfSharesPerProject>>>
	>
	/** Returns the distinct set of projects associated with the investor's relevant shares. */
	projects?: EntireFieldWrapper<Maybe<Array<Maybe<ProjectType>>>>
	/** Returns the unit share value as of the end date. Requires exactly one project to be set. */
	share_value?: EntireFieldWrapper<Maybe<Scalars["Decimal"]["output"]>>
	share_value_per_project?: EntireFieldWrapper<
		Maybe<Array<Maybe<InvestorStatsInvestorShareValuePerProject>>>
	>
	/**
	 * Investor's shares, filtered by context.
	 *
	 *         If a valuation_date is set: includes shares acquired on or before that date, excludes projects
	 *         paid off before it. Otherwise: excludes projects paid off before the start date.
	 *         Additionally filters to self.projects and excludes self.excluded_projects when set.
	 *
	 */
	shares?: EntireFieldWrapper<Maybe<Array<Maybe<SolarShareType>>>>
	shares_ratio_per_project?: EntireFieldWrapper<
		Maybe<Array<Maybe<InvestorStatsSharesRatioPerProject>>>
	>
	/** Total paid amortization for investor */
	total_amortization?: EntireFieldWrapper<Maybe<Scalars["Decimal"]["output"]>>
	/** Total paid interest for investor */
	total_cost?: EntireFieldWrapper<Maybe<Scalars["Decimal"]["output"]>>
	/**
	 * Total investment value (unit share value * total shares) for a single project.
	 *         Requires exactly one project to be set.
	 *
	 */
	total_investment_for_project?: EntireFieldWrapper<
		Maybe<Scalars["Decimal"]["output"]>
	>
	/** Sum of total investment values (unit share value * share count) across all relevant projects. */
	total_investment_value?: EntireFieldWrapper<
		Maybe<Scalars["Decimal"]["output"]>
	>
	/** Total investment value per project (unit share value multiplied by share count). */
	total_investment_value_per_project?: EntireFieldWrapper<
		Maybe<Array<Maybe<InvestorStatsInvestorShareValuePerProject>>>
	>
	/** Total investment value grouped by project type (sums total_investment_value_per_project by type). */
	total_investment_value_per_project_type?: EntireFieldWrapper<
		Maybe<Array<Maybe<InvestorStatsInvestorShareValuePerProjectType>>>
	>
	/** Sum of the nominal values of all relevant shares. Returns Decimal(0) if no shares exist. */
	total_nominal_investment?: EntireFieldWrapper<
		Maybe<Scalars["Decimal"]["output"]>
	>
	/** Total sum of everything paid to investor */
	total_repaid?: EntireFieldWrapper<Maybe<Scalars["Decimal"]["output"]>>
	/**
	 * Total of interest, amortization, and repayment paid to the investor for a single project.
	 *         Only includes completed (DONE) payments up to the valuation date. Requires exactly one project.
	 *
	 */
	total_repaid_for_project?: EntireFieldWrapper<
		Maybe<Scalars["Decimal"]["output"]>
	>
	/** Total paid repayments for investor */
	total_repayment?: EntireFieldWrapper<Maybe<Scalars["Decimal"]["output"]>>
	/** Total number of relevant shares this investor holds. */
	total_shares?: EntireFieldWrapper<Maybe<Scalars["Int"]["output"]>>
}

/** Expected production per project in kWh, scaled by the investor's share ratio in each project. */
export type InvestorStatsExpectedProductionPerProjectInKwh = {
	__typename?: "InvestorStatsExpectedProductionPerProjectInKwh"
	expected_production?: EntireFieldWrapper<
		Maybe<Scalars["Decimal"]["output"]>
	>
	project_id?: EntireFieldWrapper<Maybe<Scalars["ID"]["output"]>>
}

/**
 * Like investor_generated_power, but returns a dict mapping each project to the investor's
 *         share-weighted production in kWh.
 *
 */
export type InvestorStatsInvestorGeneratedPowerByProjectKwh = {
	__typename?: "InvestorStatsInvestorGeneratedPowerByProjectKwh"
	power?: EntireFieldWrapper<Maybe<Scalars["Decimal"]["output"]>>
	project_id?: EntireFieldWrapper<Maybe<Scalars["ID"]["output"]>>
}

/** Returns the unit share value for each relevant project as of the end date. */
export type InvestorStatsInvestorShareValuePerProject = {
	__typename?: "InvestorStatsInvestorShareValuePerProject"
	project_id?: EntireFieldWrapper<Maybe<Scalars["ID"]["output"]>>
	project_name?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	share_value?: EntireFieldWrapper<Maybe<Scalars["Decimal"]["output"]>>
}

/** Total investment value grouped by project type (sums total_investment_value_per_project by type). */
export type InvestorStatsInvestorShareValuePerProjectType = {
	__typename?: "InvestorStatsInvestorShareValuePerProjectType"
	project_type?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	share_value?: EntireFieldWrapper<Maybe<Scalars["Decimal"]["output"]>>
}

/** Returns a dict mapping each relevant project to the number of shares the investor holds in it. */
export type InvestorStatsNumberOfSharesPerProject = {
	__typename?: "InvestorStatsNumberOfSharesPerProject"
	project_id?: EntireFieldWrapper<Maybe<Scalars["ID"]["output"]>>
	shares_count?: EntireFieldWrapper<Maybe<Scalars["Int"]["output"]>>
}

export type InvestorStatsProductionByTimeType = {
	__typename?: "InvestorStatsProductionByTimeType"
	datestamp?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	production?: EntireFieldWrapper<Maybe<Scalars["Float"]["output"]>>
	project_ids?: EntireFieldWrapper<
		Maybe<Array<Maybe<Scalars["ID"]["output"]>>>
	>
	timestamp?: EntireFieldWrapper<Maybe<Scalars["Int"]["output"]>>
}

/**
 * Returns a dict mapping each relevant project to the investor's ownership fraction
 *         (investor shares / total theoretical shares).
 *
 */
export type InvestorStatsSharesRatioPerProject = {
	__typename?: "InvestorStatsSharesRatioPerProject"
	project_id?: EntireFieldWrapper<Maybe<Scalars["ID"]["output"]>>
	shares_ratio?: EntireFieldWrapper<Maybe<Scalars["Decimal"]["output"]>>
}

export type InvestorTestMutationsInput = {
	/** The category of the investment test (Experience, Questions, or Loss Calculator). */
	category: Scalars["String"]["input"]
	clientMutationId?: InputMaybe<Scalars["String"]["input"]>
	/** Optional extra data for specific tests */
	data?: InputMaybe<Scalars["String"]["input"]>
	/** The experience level of the investor (Expert or Novice). */
	experience?: InputMaybe<Scalars["String"]["input"]>
	id?: InputMaybe<Scalars["ID"]["input"]>
	investor: Scalars["ID"]["input"]
}

export type InvestorTestMutationsPayload = {
	__typename?: "InvestorTestMutationsPayload"
	clientMutationId?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	errors: EntireFieldWrapper<Array<ErrorType>>
	investor_test?: EntireFieldWrapper<Maybe<InvestmentTestType>>
}

export type InvestorType = {
	__typename?: "InvestorType"
	/** The total number of adults living in the investor's household. */
	adult_count?: EntireFieldWrapper<Maybe<Scalars["Int"]["output"]>>
	/** The date of birth of the investor. */
	birth_date?: EntireFieldWrapper<Maybe<Scalars["CustomDate"]["output"]>>
	/** The total number of children living in the investor's household. */
	child_count?: EntireFieldWrapper<Maybe<Scalars["Int"]["output"]>>
	/** The city of the investor's address. */
	city?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** The country of the investor's address. */
	country?: EntireFieldWrapper<Maybe<InvestorCountryEnum>>
	/** The type of home the investor lives in. */
	home_type?: EntireFieldWrapper<Maybe<InvestorHomeTypeEnum>>
	/** The IBAN (International Bank Account Number) for receiving interest payments. */
	iban?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	masked_iban?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	member_get_member_voucher?: EntireFieldWrapper<Maybe<VoucherObjectType>>
	notification_configuration?: EntireFieldWrapper<
		Maybe<NotificationConfigurationType>
	>
	/** The house number of the investor's address. */
	number?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** PaymentEntry list */
	paymententry?: EntireFieldWrapper<Maybe<Array<Maybe<PaymentEntryType>>>>
	/** The postal code of the investor's address. */
	postcode?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** SolarShare list */
	solarshare?: EntireFieldWrapper<Maybe<Array<Maybe<SolarShareType>>>>
	/** The street name of the investor's address. */
	street?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** The house number suffix (e.g., apartment number) of the investor's address. */
	suffix?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	supplier?: EntireFieldWrapper<Maybe<EnergySupplierType>>
	/** The customer account number for the investor at their energy supplier. */
	supplier_account?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
}

export type InvestorTypePaymententryArgs = {
	id?: InputMaybe<Scalars["ID"]["input"]>
	name?: InputMaybe<Scalars["String"]["input"]>
	partner_supplier_only?: InputMaybe<Scalars["Boolean"]["input"]>
	state?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
	transaction_id?: InputMaybe<Scalars["String"]["input"]>
}

export type InvestorTypeSolarshareArgs = {
	id?: InputMaybe<Scalars["ID"]["input"]>
	project?: InputMaybe<Scalars["ID"]["input"]>
	project__name__icontains?: InputMaybe<Scalars["String"]["input"]>
}

export type InvestorUpdateInput = {
	clientMutationId?: InputMaybe<Scalars["String"]["input"]>
	notification_configuration?: InputMaybe<NotificationConfigurationSerializerInput>
	/** The customer account number for the investor at their energy supplier. */
	supplier_account?: InputMaybe<Scalars["String"]["input"]>
	supplier_id?: InputMaybe<Scalars["String"]["input"]>
}

export type InvestorUpdatePayload = {
	__typename?: "InvestorUpdatePayload"
	clientMutationId?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** May contain more than one error for same field. */
	errors?: EntireFieldWrapper<Maybe<Array<Maybe<ErrorType>>>>
	masked_iban?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	notification_configuration?: EntireFieldWrapper<
		Maybe<NotificationConfigurationType>
	>
	supplier?: EntireFieldWrapper<Maybe<EnergySupplierType>>
	/** The customer account number for the investor at their energy supplier. */
	supplier_account?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	supplier_id?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
}

export type KycType = {
	__typename?: "KycType"
	/** KycVerificationDocument(id, uuid, uuid_short, created_at, modified_at, deleted_at, kyc, state, document_type, document, document_back, document_name, document_number, document_description, issuing_country, issuing_place, issuing_authority, issue_date, expiry_date, remote_document_id, rejected_reason) */
	documents?: EntireFieldWrapper<
		Maybe<Array<Maybe<KycVerificationDocumentType>>>
	>
	/** A personal KYC declined reason that we want shown in the KYC Failed email template. Should be in Dutch. */
	human_readable_kyc_error?: EntireFieldWrapper<
		Maybe<Scalars["String"]["output"]>
	>
	id: EntireFieldWrapper<Scalars["ID"]["output"]>
	/** The latest hosted identity verification session, if any. */
	identity_verification?: EntireFieldWrapper<
		Maybe<IdentityVerificationSessionType>
	>
	last_verified_on?: EntireFieldWrapper<Maybe<Scalars["Date"]["output"]>>
	/** Date by which the user must renew their KYC/KYB verification or be downgraded by Mangopay. Read from Mangopay when the USER_KYC_RENEWAL_REQUIRED webhook arrives, falling back to 90 days out if Mangopay cannot be reached. Cleared when the renewal completes. */
	renewal_deadline?: EntireFieldWrapper<Maybe<Scalars["Date"]["output"]>>
	state: EntireFieldWrapper<RiskKycStateChoices>
	/** True when this user verifies through Mangopay's hosted identity verification flow instead of the legacy document upload. */
	uses_hosted_verification?: EntireFieldWrapper<
		Maybe<Scalars["Boolean"]["output"]>
	>
}

export type KycVerificationDocumentType = {
	__typename?: "KycVerificationDocumentType"
	document_type: EntireFieldWrapper<RiskKycVerificationDocumentDocumentTypeChoices>
	/** The expiry date of the document. */
	expiry_date?: EntireFieldWrapper<Maybe<Scalars["Date"]["output"]>>
	id: EntireFieldWrapper<Scalars["ID"]["output"]>
}

export type LocationSerializerInput = {
	/** Street Address, P.O. Box, Company Name, c/o etc. 1–255 characters; the characters (, ) and / are not allowed (rejected by our payment provider). */
	address_line_primary: Scalars["String"]["input"]
	/** Street Nr, House Nr, Apartment, Suite, Unit, Building, Floor etc. Up to 255 characters; the characters (, ) and / are not allowed (rejected by our payment provider). */
	address_line_secondary?: InputMaybe<Scalars["String"]["input"]>
	/** City, Area, Locality etc. 1–80 characters; the characters & , . : _ are not allowed (rejected by our payment provider). */
	city?: InputMaybe<Scalars["String"]["input"]>
	/** Currently only projects in The Netherlands can be setup. */
	country?: InputMaybe<Country>
	/** The postal code or ZIP code of the location. 1–10 characters; the characters ( ) & , . : _ ' / are not allowed (rejected by our payment provider). */
	postal_code?: InputMaybe<Scalars["String"]["input"]>
	/** Region, Province, State etc. */
	region?: InputMaybe<Region>
}

export type LocationType = {
	__typename?: "LocationType"
	/** Street Address, P.O. Box, Company Name, c/o etc. 1–255 characters; the characters (, ) and / are not allowed (rejected by our payment provider). */
	address_line_primary: EntireFieldWrapper<Scalars["String"]["output"]>
	/** Street Nr, House Nr, Apartment, Suite, Unit, Building, Floor etc. Up to 255 characters; the characters (, ) and / are not allowed (rejected by our payment provider). */
	address_line_secondary: EntireFieldWrapper<Scalars["String"]["output"]>
	/** City, Area, Locality etc. 1–80 characters; the characters & , . : _ are not allowed (rejected by our payment provider). */
	city: EntireFieldWrapper<Scalars["String"]["output"]>
	/** Currently only projects in The Netherlands can be setup. */
	country: EntireFieldWrapper<CoreLocationCountryChoices>
	created_at: EntireFieldWrapper<Scalars["DateTime"]["output"]>
	deleted_at?: EntireFieldWrapper<Maybe<Scalars["DateTime"]["output"]>>
	id: EntireFieldWrapper<Scalars["ID"]["output"]>
	/** Latitude decimal values ranging from +90 to -90. */
	latitude?: EntireFieldWrapper<Maybe<Scalars["Decimal"]["output"]>>
	/** Longitude decimal values ranging from +180 to -180. */
	longitude?: EntireFieldWrapper<Maybe<Scalars["Decimal"]["output"]>>
	modified_at: EntireFieldWrapper<Scalars["DateTime"]["output"]>
	/** The postal code or ZIP code of the location. 1–10 characters; the characters ( ) & , . : _ ' / are not allowed (rejected by our payment provider). */
	postal_code: EntireFieldWrapper<Scalars["String"]["output"]>
	/** Region, Province, State etc. */
	region?: EntireFieldWrapper<Maybe<CoreLocationRegionChoices>>
	userprofile?: EntireFieldWrapper<Maybe<UserProfileType>>
	/** Universally unique identifier. */
	uuid: EntireFieldWrapper<Scalars["UUID"]["output"]>
	/** Short version of the universally unique identifier. */
	uuid_short: EntireFieldWrapper<Scalars["String"]["output"]>
}

/**
 * Tri-state SCA proxy-consent value returned by Mangopay's
 * ``/sca/users/{id}/sca-status`` endpoint.
 *
 * Mangopay reports the third state as JSON ``null`` on the wire; we
 * translate it to ``NOT_APPLICABLE`` on read so every consumer must handle
 * the third state explicitly rather than remembering to check for null.
 * ``NOT_APPLICABLE`` means Mangopay has not activated this scope for our
 * platform (or the consent has not been synced yet) — the row should be
 * hidden in the UI rather than shown as revoked.
 */
export const MangopayScaConsentState = {
	Active: "ACTIVE",
	Inactive: "INACTIVE",
	NotApplicable: "NOT_APPLICABLE",
} as const

export type MangopayScaConsentState =
	(typeof MangopayScaConsentState)[keyof typeof MangopayScaConsentState]
export type MangopayScaType = {
	__typename?: "MangopayScaType"
	/** Lifecycle status of the Mangopay Recipient. Only ACTIVE recipients can be paid out to. */
	recipient_status?: EntireFieldWrapper<
		Maybe<UsersUserMangopayRecipientStatusChoices>
	>
	sca_consent_contact_information: EntireFieldWrapper<MangopayScaConsentState>
	sca_consent_recipient_registration: EntireFieldWrapper<MangopayScaConsentState>
	sca_consent_transfer: EntireFieldWrapper<MangopayScaConsentState>
	sca_consent_view_account_information: EntireFieldWrapper<MangopayScaConsentState>
	/** Indicates if the user is enrolled in Strong Customer Authentication (SCA) for Mangopay. */
	sca_enrolled: EntireFieldWrapper<Scalars["Boolean"]["output"]>
}

export type MangopayUserRemoteType = {
	__typename?: "MangopayUserRemoteType"
	/** Get the enrollment URL for the user in Mangopay. Returns the URL if the user needs to enroll in SCA, or None if the user does not have a Mangopay user or does not need to enroll. */
	enrollment_url?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** Check if the user has a pending user action in Mangopay. Returns True if there is a pending action, False if not, and None if the user does not have a Mangopay user. */
	has_pending_user_action?: EntireFieldWrapper<
		Maybe<Scalars["Boolean"]["output"]>
	>
	/** Check if the user is active in Mangopay. Returns True if the user is active, False if not, and None if the user does not have a Mangopay user. */
	is_user_active?: EntireFieldWrapper<Maybe<Scalars["Boolean"]["output"]>>
}

export type MessageConnectionType = {
	__typename?: "MessageConnectionType"
	results?: EntireFieldWrapper<Maybe<Array<Maybe<MessageType>>>>
	total_count?: EntireFieldWrapper<Maybe<Scalars["Int"]["output"]>>
}

export type MessageType = {
	__typename?: "MessageType"
	attachments?: EntireFieldWrapper<Maybe<Scalars["JSONString"]["output"]>>
	html_body?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	message_events?: EntireFieldWrapper<Maybe<Scalars["JSONString"]["output"]>>
	message_id?: EntireFieldWrapper<Maybe<Scalars["UUID"]["output"]>>
	received_at?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	subject?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	text_body?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
}

export type MessagesType = {
	__typename?: "MessagesType"
	detail?: EntireFieldWrapper<Maybe<MessageType>>
	list?: EntireFieldWrapper<Maybe<MessageConnectionType>>
}

export type MessagesTypeDetailArgs = {
	message_id?: InputMaybe<Scalars["UUID"]["input"]>
}

export type MessagesTypeListArgs = {
	count?: InputMaybe<Scalars["Int"]["input"]>
	offset?: InputMaybe<Scalars["Int"]["input"]>
	subject?: InputMaybe<Scalars["String"]["input"]>
}

/**
 *
 *     Returns project monitoring status dictionary with 'status' and 'data' keys.
 *     Sensor needs to be online and has had recent data post.
 *
 *     STATUS:
 *     - If all the sensors are not ok - returns offline status.
 *     - If only part of sensors are offline (not ok) - then these sensors are appended to the result's "check list".
 *     - If some sensors report malformed data(see corresponding method) - these sensors are appended to the "check list".
 *     - If everything's OK, returns 2 ('Online')
 *     - If first solar interest period for the project hasn't started yet, returns 3
 *     - If project has no sensors at all, returns 4 (Project is being built)
 *
 *     DATA:
 *     - some additional info about this status (f. ex. malformed sensors types)
 *     - If one of the (same) sensors are malformed, the method adds a counter to
 *     the sensor short name, f. ex. ['pwr', 'pwr2', 'rad', 'rad2'] and etc.
 *
 */
export type MonitoringStatusStatsType = {
	__typename?: "MonitoringStatusStatsType"
	/** Malformed sensors type */
	data?: EntireFieldWrapper<Maybe<Array<Maybe<Scalars["String"]["output"]>>>>
	name?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	status?: EntireFieldWrapper<Maybe<Scalars["Int"]["output"]>>
}

export type Mutations = {
	__typename?: "Mutations"
	email_update?: EntireFieldWrapper<Maybe<EmailUpdatePayload>>
	/**
	 * Start (or resume) a Mangopay hosted identity verification session for the
	 * logged-in user and return the hosted URL the frontend should redirect them
	 * to. The outcome of the session arrives asynchronously via webhooks; the
	 * frontend should poll `me { kyc { state identity_verification { status } } }`
	 * after the user returns, never interpret the return redirect itself.
	 */
	identity_verification_start?: EntireFieldWrapper<
		Maybe<IdentityVerificationStart>
	>
	investment_test_update?: EntireFieldWrapper<
		Maybe<InvestorTestMutationsPayload>
	>
	investor_update?: EntireFieldWrapper<Maybe<InvestorUpdatePayload>>
	organisation_update?: EntireFieldWrapper<Maybe<OrganisationUpdatePayload>>
	password_reset?: EntireFieldWrapper<Maybe<PasswordResetPayload>>
	profile_update?: EntireFieldWrapper<Maybe<ProfileUpdatePayload>>
	/**
	 * Start a Mangopay proxy consent session for the logged-in user and return the
	 * redirect URL the frontend should send them to.
	 *
	 * Mangopay offers no way to set the consent scopes directly: the user ticks or
	 * unticks them on the hosted SCA page, where they can grant consent for the
	 * first time, add scopes, or revoke. The resulting ``sca_consent_*`` flags land
	 * through the consent webhooks; call ``sca_status_refresh`` on the return leg
	 * to read them without waiting for those.
	 */
	sca_consent_manage?: EntireFieldWrapper<Maybe<ScaConsentManage>>
	/**
	 * Create a new Mangopay SCA enrollment for the logged-in user and return the
	 * redirect URL the frontend should send them to in order to complete strong
	 * customer authentication.
	 *
	 * Each call creates a fresh enrollment on Mangopay's side (short TTL); the
	 * frontend should invoke this only when the user explicitly starts the SCA
	 * flow, not on every page load.
	 */
	sca_enrollment_start?: EntireFieldWrapper<Maybe<ScaEnrollmentStart>>
	/**
	 * Reconcile the caller's SCA status against Mangopay and return the fresh values.
	 *
	 * Intended for the return leg of the Mangopay SCA redirect: the enrollment or
	 * consent webhook may not have landed yet, and the user is looking at the page
	 * right now. Kept out of the ``me`` query resolvers on purpose -- those run on
	 * every page load and must not make PSP calls.
	 */
	sca_status_refresh?: EntireFieldWrapper<Maybe<ScaStatusRefresh>>
}

export type MutationsEmail_UpdateArgs = {
	input: EmailUpdateInput
}

export type MutationsIdentity_Verification_StartArgs = {
	return_url?: InputMaybe<Scalars["String"]["input"]>
}

export type MutationsInvestment_Test_UpdateArgs = {
	input: InvestorTestMutationsInput
}

export type MutationsInvestor_UpdateArgs = {
	input: InvestorUpdateInput
}

export type MutationsOrganisation_UpdateArgs = {
	input: OrganisationUpdateInput
}

export type MutationsPassword_ResetArgs = {
	input: PasswordResetInput
}

export type MutationsProfile_UpdateArgs = {
	input: ProfileUpdateInput
}

export type MutationsSca_Consent_ManageArgs = {
	return_url?: InputMaybe<Scalars["String"]["input"]>
}

export type MutationsSca_Enrollment_StartArgs = {
	return_url?: InputMaybe<Scalars["String"]["input"]>
}

export type NearbyProjectListType = {
	__typename?: "NearbyProjectListType"
	/** Project list, paginated by LimitOffsetPaginator */
	results?: EntireFieldWrapper<Maybe<Array<Maybe<ProjectType>>>>
	/** Total count of matches elements */
	totalCount?: EntireFieldWrapper<Maybe<Scalars["Int"]["output"]>>
}

export type NearbyProjectListTypeResultsArgs = {
	limit?: InputMaybe<Scalars["Int"]["input"]>
	offset?: InputMaybe<Scalars["Int"]["input"]>
	ordering?: InputMaybe<Scalars["String"]["input"]>
}

export type NotificationConfigurationSerializerInput = {
	disabled_yearly_interest_report_projects?: InputMaybe<
		Array<InputMaybe<Scalars["Int"]["input"]>>
	>
	receive_check_data?: InputMaybe<Scalars["Boolean"]["input"]>
	receive_monthly_report?: InputMaybe<Scalars["Boolean"]["input"]>
}

export type NotificationConfigurationType = {
	__typename?: "NotificationConfigurationType"
	disabled_yearly_interest_report_projects?: EntireFieldWrapper<
		Maybe<Array<Maybe<ProjectForInvestorType>>>
	>
	/** Django object unique identification field */
	id: EntireFieldWrapper<Scalars["ID"]["output"]>
	receive_check_data?: EntireFieldWrapper<Maybe<Scalars["Boolean"]["output"]>>
	receive_monthly_report?: EntireFieldWrapper<
		Maybe<Scalars["Boolean"]["output"]>
	>
}

/** Roles available for organisation memberships. */
export const OrganisationMembershipRole = {
	Admin: "ADMIN",
	Billing: "BILLING",
	Viewer: "VIEWER",
} as const

export type OrganisationMembershipRole =
	(typeof OrganisationMembershipRole)[keyof typeof OrganisationMembershipRole]
/** GraphQL type for organisation memberships. */
export type OrganisationMembershipType = {
	__typename?: "OrganisationMembershipType"
	created_at: EntireFieldWrapper<Scalars["DateTime"]["output"]>
	id: EntireFieldWrapper<Scalars["ID"]["output"]>
	modified_at: EntireFieldWrapper<Scalars["DateTime"]["output"]>
	role?: EntireFieldWrapper<Maybe<OrganisationMembershipRole>>
	user_email?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	user_name?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** Universally unique identifier. */
	uuid: EntireFieldWrapper<Scalars["UUID"]["output"]>
	/** Short version of the universally unique identifier. */
	uuid_short: EntireFieldWrapper<Scalars["String"]["output"]>
}

/** An enumeration. */
export const OrganisationOrganisationTypeEnum = {
	/** Energy supplier */
	EnergySupplier: "ENERGY_SUPPLIER",
	/** Installer */
	Installer: "INSTALLER",
	/** Investor */
	Investor: "INVESTOR",
	/** Project owner */
	ProjectOwner: "PROJECT_OWNER",
} as const

export type OrganisationOrganisationTypeEnum =
	(typeof OrganisationOrganisationTypeEnum)[keyof typeof OrganisationOrganisationTypeEnum]
export type OrganisationType = {
	__typename?: "OrganisationType"
	/** BIC will be auto generated on save, based on IBAN. */
	bic?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** Name as officially registered at KVK. Up to 100 characters, no leading or trailing whitespace. */
	business_legal_name?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** Business registration number (e.g. KVK for NL, HRB for DE, BE0… for BE). Up to 40 characters. */
	business_nr?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	current_user_role?: EntireFieldWrapper<Maybe<OrganisationMembershipRole>>
	/** The primary email address for the organisation. */
	email?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** International Bank Account Number for SEPA payments. */
	iban?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** Django object unique identification field */
	id: EntireFieldWrapper<Scalars["ID"]["output"]>
	location?: EntireFieldWrapper<Maybe<LocationType>>
	/** The logo image for this organisation. */
	logo?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	memberships?: EntireFieldWrapper<
		Maybe<Array<Maybe<OrganisationMembershipType>>>
	>
	/** The type of organisation (Investor, Installer, Energy Supplier, or Project Owner). */
	organisation_type?: EntireFieldWrapper<
		Maybe<OrganisationOrganisationTypeEnum>
	>
	/** ProjectHorizon list */
	owned_projects?: EntireFieldWrapper<
		Maybe<Array<Maybe<InvestmentCampaignProjectType>>>
	>
	/** Project list */
	projects?: EntireFieldWrapper<Maybe<Array<Maybe<ProjectType>>>>
	/** Universally unique identifier. */
	uuid?: EntireFieldWrapper<Maybe<Scalars["UUID"]["output"]>>
	/** Short version of the universally unique identifier. */
	uuid_short?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
}

export type OrganisationTypeOwned_ProjectsArgs = {
	id?: InputMaybe<Scalars["ID"]["input"]>
	owner?: InputMaybe<Scalars["ID"]["input"]>
	partners?: InputMaybe<Scalars["ID"]["input"]>
	project?: InputMaybe<Scalars["ID"]["input"]>
	title__icontains?: InputMaybe<Scalars["String"]["input"]>
}

export type OrganisationTypeProjectsArgs = {
	id?: InputMaybe<Scalars["ID"]["input"]>
	name__icontains?: InputMaybe<Scalars["String"]["input"]>
	state?: InputMaybe<Scalars["String"]["input"]>
	supplier__name__icontains?: InputMaybe<Scalars["String"]["input"]>
	type?: InputMaybe<Scalars["String"]["input"]>
}

export type OrganisationUpdateInput = {
	clientMutationId?: InputMaybe<Scalars["String"]["input"]>
	id?: InputMaybe<Scalars["String"]["input"]>
	location?: InputMaybe<LocationSerializerInput>
}

export type OrganisationUpdatePayload = {
	__typename?: "OrganisationUpdatePayload"
	clientMutationId?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** May contain more than one error for same field. */
	errors?: EntireFieldWrapper<Maybe<Array<Maybe<ErrorType>>>>
	id?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	location?: EntireFieldWrapper<Maybe<LocationType>>
}

export type OverallStatisticsType = {
	__typename?: "OverallStatisticsType"
	/** Average production per investor in Wh (total rough production / investor count). */
	average_investor_production?: EntireFieldWrapper<
		Maybe<Scalars["Decimal"]["output"]>
	>
	/** Average savings per investor. */
	average_investor_savings?: EntireFieldWrapper<
		Maybe<Scalars["Decimal"]["output"]>
	>
	/** Average number of solar shares per investor, counting only shares associated with an investor. */
	average_solar_shares?: EntireFieldWrapper<
		Maybe<Scalars["Decimal"]["output"]>
	>
	/** Appropriate resolution, as a month/day/hour string, for this timeframe. */
	by_time_resolution?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** Capacity in watt = SUM of all projects (solar panels * capacity per panel) */
	capacity_in_watt?: EntireFieldWrapper<Maybe<Scalars["Decimal"]["output"]>>
	/** Total CO2 saved by this production. */
	co2_saved?: EntireFieldWrapper<Maybe<Scalars["Decimal"]["output"]>>
	/** Speed at which CO2 is being saved, based on the most recent measurement, per 250ms. Used for counters. */
	co2_saved_speed?: EntireFieldWrapper<Maybe<Scalars["Decimal"]["output"]>>
	/** Total cost saved by this production. */
	cost_saved?: EntireFieldWrapper<Maybe<Scalars["Decimal"]["output"]>>
	cumulative_production_data?: EntireFieldWrapper<
		Maybe<Array<Maybe<StatsProductionGeneric>>>
	>
	/** Average Dutch power usage in this timeframe. */
	dutch_power_usage?: EntireFieldWrapper<Maybe<Scalars["Decimal"]["output"]>>
	/** Estimated total production in Wh since the last measurement, extrapolated from the latest reading. */
	est_power_since_last_measurement?: EntireFieldWrapper<
		Maybe<Scalars["Decimal"]["output"]>
	>
	expected_cumulative_production_data?: EntireFieldWrapper<
		Maybe<Array<Maybe<StatsProductionGeneric>>>
	>
	/** Total expected production in kWh for the configured time period, summed from daily expectations. */
	expected_production_by_time_period?: EntireFieldWrapper<
		Maybe<Scalars["Decimal"]["output"]>
	>
	expected_production_data?: EntireFieldWrapper<
		Maybe<Array<Maybe<StatsProductionGeneric>>>
	>
	/**
	 * Expected production per panel for single project
	 *         return type: Decimal, units: kWh
	 *
	 */
	expected_production_per_panel?: EntireFieldWrapper<
		Maybe<Scalars["Decimal"]["output"]>
	>
	/**
	 * Expected production per share for single project.
	 *         return type: Decimal, units: kWh
	 *
	 */
	expected_production_per_share?: EntireFieldWrapper<
		Maybe<Scalars["Decimal"]["output"]>
	>
	/** Number of distinct investors holding shares in the given projects. */
	investor_count?: EntireFieldWrapper<Maybe<Scalars["Int"]["output"]>>
	/** Returns the greater of expected vs actual production in kWh. Used to set the upper bound on UI graphs. */
	max_production_in_kwh?: EntireFieldWrapper<
		Maybe<Scalars["Decimal"]["output"]>
	>
	/** Total panels in given projects. */
	panel_count?: EntireFieldWrapper<Maybe<Scalars["Int"]["output"]>>
	/**
	 * Total production within the time period based on MeasurementDayView.
	 *         Units: Wh
	 *
	 */
	production?: EntireFieldWrapper<Maybe<Scalars["Decimal"]["output"]>>
	production_for_day?: EntireFieldWrapper<Maybe<StatsProductionForDay>>
	/**
	 * Total production within the time period based on MeasurementDayView.
	 *         Units: kWh
	 *
	 */
	production_in_kwh?: EntireFieldWrapper<Maybe<Scalars["Decimal"]["output"]>>
	production_performance_ratio?: EntireFieldWrapper<
		Maybe<StatsPerformanceRatioData>
	>
	/**
	 * Ratio of panels owned by investors.
	 *         In some projects, some of the SolarShares are not associated with a client, having special handling outside
	 *         of Mijn Stroom.
	 *
	 */
	production_ratio_for_investors?: EntireFieldWrapper<
		Maybe<Scalars["Decimal"]["output"]>
	>
	/** Speed at which power is being produced, based on the most recent measurement, per 250ms. Used for counters. */
	production_speed?: EntireFieldWrapper<Maybe<Scalars["Decimal"]["output"]>>
	/** Human readable text of total production. */
	production_text?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** Total shares in given projects. */
	shares_count?: EntireFieldWrapper<Maybe<Scalars["Int"]["output"]>>
	/** Total number of solar shares (bonds) held by investors across the given projects. */
	solar_bonds_volume?: EntireFieldWrapper<Maybe<Scalars["Decimal"]["output"]>>
	/** Length of the timeframe in days. */
	timeframe_length?: EntireFieldWrapper<Maybe<Scalars["Int"]["output"]>>
	/**
	 * Total production up to right now, i.e. including the estimated production since the last measurement.
	 *         The production since last measurement is important to make counters work intuitively: when the user loads the
	 *         page and the counter counts for a while, and they refresh, they should see roughly the same value.
	 *
	 */
	total_production?: EntireFieldWrapper<Maybe<Scalars["Decimal"]["output"]>>
	total_production_data?: EntireFieldWrapper<
		Maybe<Array<Maybe<StatsProductionGeneric>>>
	>
	/**
	 * Total production up to right now, i.e. including the estimated production since the last measurement.
	 *         The production since last measurement is important to make counters work intuitively: when the user loads the
	 *         page and the counter counts for a while, and they refresh, they should see roughly the same value.
	 *
	 */
	total_production_for_counter?: EntireFieldWrapper<
		Maybe<Scalars["Decimal"]["output"]>
	>
	/**
	 * Total power produced for project investors.
	 *         In some projects, some of the SolarShares are not associated with a client. The power produced by these special
	 *          panels is excluded in this property.
	 *
	 */
	total_production_for_investors?: EntireFieldWrapper<
		Maybe<Scalars["Decimal"]["output"]>
	>
	/**
	 * 'total_production_rough' per panel for single project.
	 *         return type: Decimal, units: kWh
	 *
	 */
	total_production_per_panel?: EntireFieldWrapper<
		Maybe<Scalars["Decimal"]["output"]>
	>
	/**
	 * 'total_production_rough' per share for single project.
	 *         return type: Decimal, units: kWh
	 *
	 */
	total_production_per_share?: EntireFieldWrapper<
		Maybe<Scalars["Decimal"]["output"]>
	>
	/**
	 * Total production in Wh up to the latest measurement, excluding the estimated production since then.
	 *         Lighter than total_production as it skips the speed estimation.
	 *
	 */
	total_production_rough?: EntireFieldWrapper<
		Maybe<Scalars["Decimal"]["output"]>
	>
	/**
	 * Like total_production_rough, but ignores the user-submitted time component and instead
	 *         uses the full day range (00:00 to 23:59).
	 *         Units: Wh
	 *
	 */
	total_production_rough_full_day?: EntireFieldWrapper<
		Maybe<Scalars["Decimal"]["output"]>
	>
	/** 'total_production_rough' in kWhs */
	total_production_rough_kwh?: EntireFieldWrapper<
		Maybe<Scalars["Decimal"]["output"]>
	>
}

export type OverallStatisticsTypeCumulative_Production_DataArgs = {
	grouped_by?: Scalars["String"]["input"]
}

export type OverallStatisticsTypeExpected_Cumulative_Production_DataArgs = {
	grouped_by?: Scalars["String"]["input"]
}

export type OverallStatisticsTypeExpected_Production_DataArgs = {
	grouped_by?: Scalars["String"]["input"]
}

export type OverallStatisticsTypeProduction_For_DayArgs = {
	day?: InputMaybe<Scalars["Date"]["input"]>
}

export type OverallStatisticsTypeProduction_Performance_RatioArgs = {
	grouped_by?: Scalars["String"]["input"]
	knmi_data?: Scalars["Boolean"]["input"]
}

export type OverallStatisticsTypeTotal_Production_DataArgs = {
	grouped_by?: Scalars["String"]["input"]
}

/** An enumeration. */
export const OwnerVerificationStateEnum = {
	/** Accepted */
	Accepted: "ACCEPTED",
	/** Pending */
	Pending: "PENDING",
} as const

export type OwnerVerificationStateEnum =
	(typeof OwnerVerificationStateEnum)[keyof typeof OwnerVerificationStateEnum]
export type OwnerVerificationType = {
	__typename?: "OwnerVerificationType"
	/** Created At */
	created?: EntireFieldWrapper<Maybe<Scalars["CustomDateTime"]["output"]>>
	/** id */
	id?: EntireFieldWrapper<Maybe<Scalars["UUID"]["output"]>>
	/** Message */
	message?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** Modified At */
	modified?: EntireFieldWrapper<Maybe<Scalars["CustomDateTime"]["output"]>>
	/** State */
	state?: EntireFieldWrapper<Maybe<OwnerVerificationStateEnum>>
}

/** An enumeration. */
export const PartnerPartnerTypeEnum = {
	/** Bank */
	Bank: "BANK",
	/** Energy Supplier */
	EnergySupplier: "ENERGY_SUPPLIER",
	/** Other */
	Other: "OTHER",
} as const

export type PartnerPartnerTypeEnum =
	(typeof PartnerPartnerTypeEnum)[keyof typeof PartnerPartnerTypeEnum]
export type PartnerType = {
	__typename?: "PartnerType"
	/** Created At */
	created_at?: EntireFieldWrapper<Maybe<Scalars["CustomDateTime"]["output"]>>
	/** Deleted At */
	deleted_at?: EntireFieldWrapper<Maybe<Scalars["CustomDateTime"]["output"]>>
	/** Django object unique identification field */
	id: EntireFieldWrapper<Scalars["ID"]["output"]>
	/** Modified At */
	modified_at?: EntireFieldWrapper<Maybe<Scalars["CustomDateTime"]["output"]>>
	/** The name of the partner organization. */
	name?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** The type of partner (Energy Supplier, Bank, or Other). */
	partner_type?: EntireFieldWrapper<Maybe<PartnerPartnerTypeEnum>>
	/** ProjectHorizon list */
	projects?: EntireFieldWrapper<
		Maybe<Array<Maybe<InvestmentCampaignProjectType>>>
	>
	/** Universally unique identifier. */
	uuid?: EntireFieldWrapper<Maybe<Scalars["UUID"]["output"]>>
	/** Short version of the universally unique identifier. */
	uuid_short?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
}

export type PartnerTypeProjectsArgs = {
	id?: InputMaybe<Scalars["ID"]["input"]>
	owner?: InputMaybe<Scalars["ID"]["input"]>
	partners?: InputMaybe<Scalars["ID"]["input"]>
	project?: InputMaybe<Scalars["ID"]["input"]>
	title__icontains?: InputMaybe<Scalars["String"]["input"]>
}

export type PasswordResetInput = {
	clientMutationId?: InputMaybe<Scalars["String"]["input"]>
	confirm_password: Scalars["String"]["input"]
	current_password: Scalars["String"]["input"]
	new_password: Scalars["String"]["input"]
}

export type PasswordResetPayload = {
	__typename?: "PasswordResetPayload"
	clientMutationId?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** May contain more than one error for same field. */
	errors?: EntireFieldWrapper<Maybe<Array<Maybe<ErrorType>>>>
}

/**
 *
 *         Payment states are used to track the state of a payment entry. This is used to track whether a payment entry has been payed out.
 *
 */
export const PayOutState = {
	New: "new",
	PayoutCompleted: "payout_completed",
	PayoutFailed: "payout_failed",
	PayoutInitiated: "payout_initiated",
	TransferCompleted: "transfer_completed",
	TransferFailed: "transfer_failed",
	TransferInitiated: "transfer_initiated",
} as const

export type PayOutState = (typeof PayOutState)[keyof typeof PayOutState]
export type PaymentEntriesListType = {
	__typename?: "PaymentEntriesListType"
	/** PaymentEntry list, paginated by LimitOffsetPaginator */
	results?: EntireFieldWrapper<Maybe<Array<Maybe<PaymentEntryType>>>>
	/** Total count of matches elements */
	totalCount?: EntireFieldWrapper<Maybe<Scalars["Int"]["output"]>>
}

export type PaymentEntriesListTypeResultsArgs = {
	limit?: InputMaybe<Scalars["Int"]["input"]>
	offset?: InputMaybe<Scalars["Int"]["input"]>
	ordering?: InputMaybe<Scalars["String"]["input"]>
}

export type PaymentEntryType = {
	__typename?: "PaymentEntryType"
	/** Aflossing */
	amortization?: EntireFieldWrapper<Maybe<Scalars["Float"]["output"]>>
	/** Rente */
	cost?: EntireFieldWrapper<Maybe<Scalars["Float"]["output"]>>
	/** energy supplier bonus */
	energy_supplier_bonus?: EntireFieldWrapper<
		Maybe<Scalars["Float"]["output"]>
	>
	/** IBAN nummer */
	iban?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** Django object unique identification field */
	id: EntireFieldWrapper<Scalars["ID"]["output"]>
	interest_period?: EntireFieldWrapper<Maybe<InterestPeriodType>>
	investor_email?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** investor payout */
	investor_payout?: EntireFieldWrapper<Maybe<Scalars["Float"]["output"]>>
	investor_phone_number?: EntireFieldWrapper<
		Maybe<Scalars["String"]["output"]>
	>
	/** Name */
	name?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** House Nr. */
	number?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	payment_completion_date?: EntireFieldWrapper<
		Maybe<Scalars["Date"]["output"]>
	>
	payment_state?: EntireFieldWrapper<Maybe<State>>
	/** Postcode */
	postcode?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** kWh opgewekt */
	production?: EntireFieldWrapper<Maybe<Scalars["Float"]["output"]>>
	project?: EntireFieldWrapper<Maybe<ProjectType>>
	/** Afrekening */
	repayment?: EntireFieldWrapper<Maybe<Scalars["Float"]["output"]>>
	/** # obligaties */
	share_count?: EntireFieldWrapper<Maybe<Scalars["Int"]["output"]>>
	state?: EntireFieldWrapper<Maybe<PayOutState>>
	/** House Nr. Suffix */
	suffix?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	supplier?: EntireFieldWrapper<Maybe<EnergySupplierType>>
	/** klant nummer */
	supplier_account?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** supplier payout */
	supplier_payout?: EntireFieldWrapper<Maybe<Scalars["Float"]["output"]>>
	transaction_id?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
}

/** An enumeration. */
export const PaymentInterestPerShareLimitAppliedEnum = {
	/** CAP */
	Cap: "CAP",
	/** FLOOR */
	Floor: "FLOOR",
} as const

export type PaymentInterestPerShareLimitAppliedEnum =
	(typeof PaymentInterestPerShareLimitAppliedEnum)[keyof typeof PaymentInterestPerShareLimitAppliedEnum]
/** An enumeration. */
export const PaymentPaymentServiceProviderEnum = {
	/** Buckaroo */
	Buckaroo: "BUCKAROO",
	/** Mangopay */
	Mangopay: "MANGOPAY",
} as const

export type PaymentPaymentServiceProviderEnum =
	(typeof PaymentPaymentServiceProviderEnum)[keyof typeof PaymentPaymentServiceProviderEnum]
/** An enumeration. */
export const PaymentStateEnum = {
	/** Done */
	Done: "DONE",
	/** New */
	New: "NEW",
	/** Pending approval by zpd */
	PendingApprovalByZpd: "PENDING_APPROVAL_BY_ZPD",
	/** Pending employee */
	PendingEmployee: "PENDING_EMPLOYEE",
	/** Pending investor payment */
	PendingInvestorPayment: "PENDING_INVESTOR_PAYMENT",
	/** Pending owner */
	PendingOwner: "PENDING_OWNER",
	/** Pending owner payment */
	PendingOwnerPayment: "PENDING_OWNER_PAYMENT",
	/** Pending supplier */
	PendingSupplier: "PENDING_SUPPLIER",
	/** Scheduled Creation */
	ScheduledCreation: "SCHEDULED_CREATION",
	/** Verified */
	Verified: "VERIFIED",
} as const

export type PaymentStateEnum =
	(typeof PaymentStateEnum)[keyof typeof PaymentStateEnum]
/** An enumeration. */
export const PaymentsFinancialTransactionFeeAmountCurrencyChoices = {
	/** Euro */
	Eur: "EUR",
} as const

export type PaymentsFinancialTransactionFeeAmountCurrencyChoices =
	(typeof PaymentsFinancialTransactionFeeAmountCurrencyChoices)[keyof typeof PaymentsFinancialTransactionFeeAmountCurrencyChoices]
/** An enumeration. */
export const PaymentsFinancialTransactionPaymentAmountCurrencyChoices = {
	/** Euro */
	Eur: "EUR",
} as const

export type PaymentsFinancialTransactionPaymentAmountCurrencyChoices =
	(typeof PaymentsFinancialTransactionPaymentAmountCurrencyChoices)[keyof typeof PaymentsFinancialTransactionPaymentAmountCurrencyChoices]
/** An enumeration. */
export const PaymentsFinancialTransactionPaymentTypeChoices = {
	/** Bank wire */
	BankWire: "BANK_WIRE",
	/** Ideal payment */
	IdealPayment: "IDEAL_PAYMENT",
	/** Pay by bank */
	PayByBank: "PAY_BY_BANK",
} as const

export type PaymentsFinancialTransactionPaymentTypeChoices =
	(typeof PaymentsFinancialTransactionPaymentTypeChoices)[keyof typeof PaymentsFinancialTransactionPaymentTypeChoices]
/** An enumeration. */
export const PaymentsFinancialTransactionStateChoices = {
	/** Cancelled by customer */
	CancelledByCustomer: "CANCELLED_BY_CUSTOMER",
	/** Expired */
	Expired: "EXPIRED",
	/** Failed */
	Failed: "FAILED",
	/** Initialized */
	Initialized: "INITIALIZED",
	/** Manual intervention */
	ManualIntervention: "MANUAL_INTERVENTION",
	/** Partial refund completed */
	PartialRefundCompleted: "PARTIAL_REFUND_COMPLETED",
	/** Partial refund failed */
	PartialRefundFailed: "PARTIAL_REFUND_FAILED",
	/** Partial refund processing */
	PartialRefundProcessing: "PARTIAL_REFUND_PROCESSING",
	/** Pending */
	Pending: "PENDING",
	/** Processing */
	Processing: "PROCESSING",
	/** PSP waiting consumer */
	PspWaitingConsumer: "PSP_WAITING_CONSUMER",
	/** Refund completed */
	RefundCompleted: "REFUND_COMPLETED",
	/** Refund failed */
	RefundFailed: "REFUND_FAILED",
	/** Refund processing */
	RefundProcessing: "REFUND_PROCESSING",
	/** Rejected */
	Rejected: "REJECTED",
	/** Succeeded */
	Succeeded: "SUCCEEDED",
} as const

export type PaymentsFinancialTransactionStateChoices =
	(typeof PaymentsFinancialTransactionStateChoices)[keyof typeof PaymentsFinancialTransactionStateChoices]
/** An enumeration. */
export const PaymentsFinancialTransactionTransactionTypeChoices = {
	/** Energy supplier pay in */
	EnergySupplierPayIn: "ENERGY_SUPPLIER_PAY_IN",
	/** Energy supplier pay out */
	EnergySupplierPayOut: "ENERGY_SUPPLIER_PAY_OUT",
	/** Interest Payment Payin Wallet to Payout Wallet transfer */
	InterestPayinToPayoutTransfer: "INTEREST_PAYIN_TO_PAYOUT_TRANSFER",
	/** Investor pay in */
	InvestorPayIn: "INVESTOR_PAY_IN",
	/** Investor pay out */
	InvestorPayOut: "INVESTOR_PAY_OUT",
	/** Project owner pay in */
	ProjectOwnerPayIn: "PROJECT_OWNER_PAY_IN",
	/** Project owner pay out */
	ProjectOwnerPayOut: "PROJECT_OWNER_PAY_OUT",
	/** Project Wallet to to Energy Supplier Wallet transfer */
	ProjectOwnerToEnergySupplierTransfer:
		"PROJECT_OWNER_TO_ENERGY_SUPPLIER_TRANSFER",
	/** Project Wallet to Investor Wallet transfer */
	ProjectOwnerToInvestorTransfer: "PROJECT_OWNER_TO_INVESTOR_TRANSFER",
	/** Voucher Wallet to Project Wallet transfer */
	VoucherToProjectTransfer: "VOUCHER_TO_PROJECT_TRANSFER",
} as const

export type PaymentsFinancialTransactionTransactionTypeChoices =
	(typeof PaymentsFinancialTransactionTransactionTypeChoices)[keyof typeof PaymentsFinancialTransactionTransactionTypeChoices]
export type PlatformStatisticsPerProjectType = {
	__typename?: "PlatformStatisticsPerProjectType"
	results?: EntireFieldWrapper<Maybe<PlatformStatisticsType>>
	type?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
}

export type PlatformStatisticsType = {
	__typename?: "PlatformStatisticsType"
	capacity_in_mwp?: EntireFieldWrapper<Maybe<Scalars["Float"]["output"]>>
	capital_loss?: EntireFieldWrapper<Maybe<Scalars["Float"]["output"]>>
	capital_repaid?: EntireFieldWrapper<Maybe<Scalars["Float"]["output"]>>
	default_rates?: EntireFieldWrapper<
		Maybe<Array<Maybe<DefaultRatePerYearType>>>
	>
	percentage_of_project_wise_repeated_investors?: EntireFieldWrapper<
		Maybe<Scalars["Float"]["output"]>
	>
	percentage_of_projects_successfully_funded?: EntireFieldWrapper<
		Maybe<Scalars["Float"]["output"]>
	>
	project_owners?: EntireFieldWrapper<Maybe<ProjectOwnersResultType>>
	project_partners?: EntireFieldWrapper<Maybe<Scalars["Int"]["output"]>>
	saved_co2?: EntireFieldWrapper<Maybe<Scalars["Float"]["output"]>>
	solar_bonds_volume?: EntireFieldWrapper<Maybe<Scalars["Float"]["output"]>>
	total_amount_invested?: EntireFieldWrapper<
		Maybe<Scalars["Float"]["output"]>
	>
	total_investors?: EntireFieldWrapper<Maybe<Scalars["Int"]["output"]>>
	total_production_in_gwh?: EntireFieldWrapper<
		Maybe<Scalars["Float"]["output"]>
	>
	total_production_in_households_usage?: EntireFieldWrapper<
		Maybe<Scalars["Float"]["output"]>
	>
	total_production_in_households_usage_per_year?: EntireFieldWrapper<
		Maybe<Array<Maybe<TotalProductionInHouseholdsUsagePerYearType>>>
	>
	total_projects?: EntireFieldWrapper<Maybe<Scalars["Int"]["output"]>>
	total_projects_active?: EntireFieldWrapper<Maybe<Scalars["Int"]["output"]>>
	total_projects_ended_partial?: EntireFieldWrapper<
		Maybe<Scalars["Int"]["output"]>
	>
	total_projects_repaid?: EntireFieldWrapper<Maybe<Scalars["Int"]["output"]>>
	total_solar_panels?: EntireFieldWrapper<Maybe<Scalars["Int"]["output"]>>
}

export type ProfileUpdateInput = {
	address?: InputMaybe<LocationSerializerInput>
	clientMutationId?: InputMaybe<Scalars["String"]["input"]>
	date_of_birth?: InputMaybe<Scalars["Date"]["input"]>
	initials?: InputMaybe<Scalars["String"]["input"]>
	language?: InputMaybe<Language>
	nationality?: InputMaybe<Nationality>
}

export type ProfileUpdatePayload = {
	__typename?: "ProfileUpdatePayload"
	address?: EntireFieldWrapper<Maybe<LocationType>>
	clientMutationId?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	date_of_birth?: EntireFieldWrapper<Maybe<Scalars["Date"]["output"]>>
	/** May contain more than one error for same field. */
	errors?: EntireFieldWrapper<Maybe<Array<Maybe<ErrorType>>>>
	initials?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	language?: EntireFieldWrapper<Maybe<Language>>
	nationality?: EntireFieldWrapper<Maybe<Nationality>>
}

/** An enumeration. */
export const ProjectAmortizationScheduleEnum = {
	/** Bullet */
	Bullet: "BULLET",
	/** Custom */
	Custom: "CUSTOM",
	/** Linear */
	Linear: "LINEAR",
} as const

export type ProjectAmortizationScheduleEnum =
	(typeof ProjectAmortizationScheduleEnum)[keyof typeof ProjectAmortizationScheduleEnum]
/** An enumeration. */
export const ProjectCountryEnum = {
	/** Andorra */
	Ad: "AD",
	/** United Arab Emirates */
	Ae: "AE",
	/** Afghanistan */
	Af: "AF",
	/** Antigua and Barbuda */
	Ag: "AG",
	/** Anguilla */
	Ai: "AI",
	/** Albania */
	Al: "AL",
	/** Armenia */
	Am: "AM",
	/** Angola */
	Ao: "AO",
	/** Antarctica */
	Aq: "AQ",
	/** Argentina */
	Ar: "AR",
	/** American Samoa */
	As: "AS",
	/** Austria */
	At: "AT",
	/** Australia */
	Au: "AU",
	/** Aruba */
	Aw: "AW",
	/** Åland Islands */
	Ax: "AX",
	/** Azerbaijan */
	Az: "AZ",
	/** Bosnia and Herzegovina */
	Ba: "BA",
	/** Barbados */
	Bb: "BB",
	/** Bangladesh */
	Bd: "BD",
	/** Belgium */
	Be: "BE",
	/** Burkina Faso */
	Bf: "BF",
	/** Bulgaria */
	Bg: "BG",
	/** Bahrain */
	Bh: "BH",
	/** Burundi */
	Bi: "BI",
	/** Benin */
	Bj: "BJ",
	/** Saint Barthélemy */
	Bl: "BL",
	/** Bermuda */
	Bm: "BM",
	/** Brunei */
	Bn: "BN",
	/** Bolivia */
	Bo: "BO",
	/** Bonaire, Sint Eustatius and Saba */
	Bq: "BQ",
	/** Brazil */
	Br: "BR",
	/** Bahamas (The) */
	Bs: "BS",
	/** Bhutan */
	Bt: "BT",
	/** Bouvet Island */
	Bv: "BV",
	/** Botswana */
	Bw: "BW",
	/** Belarus */
	By: "BY",
	/** Belize */
	Bz: "BZ",
	/** Canada */
	Ca: "CA",
	/** Cocos (Keeling) Islands */
	Cc: "CC",
	/** Democratic Republic of the Congo */
	Cd: "CD",
	/** Central African Republic */
	Cf: "CF",
	/** Congo */
	Cg: "CG",
	/** Switzerland */
	Ch: "CH",
	/** Côte d'Ivoire */
	Ci: "CI",
	/** Cook Islands */
	Ck: "CK",
	/** Chile */
	Cl: "CL",
	/** Cameroon */
	Cm: "CM",
	/** China */
	Cn: "CN",
	/** Colombia */
	Co: "CO",
	/** Costa Rica */
	Cr: "CR",
	/** Cuba */
	Cu: "CU",
	/** Cabo Verde */
	Cv: "CV",
	/** Curaçao */
	Cw: "CW",
	/** Christmas Island */
	Cx: "CX",
	/** Cyprus */
	Cy: "CY",
	/** Czechia */
	Cz: "CZ",
	/** Germany */
	De: "DE",
	/** Djibouti */
	Dj: "DJ",
	/** Denmark */
	Dk: "DK",
	/** Dominica */
	Dm: "DM",
	/** Dominican Republic */
	Do: "DO",
	/** Algeria */
	Dz: "DZ",
	/** Ecuador */
	Ec: "EC",
	/** Estonia */
	Ee: "EE",
	/** Egypt */
	Eg: "EG",
	/** Western Sahara */
	Eh: "EH",
	/** Eritrea */
	Er: "ER",
	/** Spain */
	Es: "ES",
	/** Ethiopia */
	Et: "ET",
	/** Finland */
	Fi: "FI",
	/** Fiji */
	Fj: "FJ",
	/** Falkland Islands (Malvinas) */
	Fk: "FK",
	/** Micronesia */
	Fm: "FM",
	/** Faroe Islands */
	Fo: "FO",
	/** France */
	Fr: "FR",
	/** Gabon */
	Ga: "GA",
	/** United Kingdom */
	Gb: "GB",
	/** Grenada */
	Gd: "GD",
	/** Georgia */
	Ge: "GE",
	/** French Guiana */
	Gf: "GF",
	/** Guernsey */
	Gg: "GG",
	/** Ghana */
	Gh: "GH",
	/** Gibraltar */
	Gi: "GI",
	/** Greenland */
	Gl: "GL",
	/** Gambia */
	Gm: "GM",
	/** Guinea */
	Gn: "GN",
	/** Guadeloupe */
	Gp: "GP",
	/** Equatorial Guinea */
	Gq: "GQ",
	/** Greece */
	Gr: "GR",
	/** South Georgia */
	Gs: "GS",
	/** Guatemala */
	Gt: "GT",
	/** Guam */
	Gu: "GU",
	/** Guinea-Bissau */
	Gw: "GW",
	/** Guyana */
	Gy: "GY",
	/** Hong Kong */
	Hk: "HK",
	/** Heard Island and McDonald Islands */
	Hm: "HM",
	/** Honduras */
	Hn: "HN",
	/** Croatia */
	Hr: "HR",
	/** Haiti */
	Ht: "HT",
	/** Hungary */
	Hu: "HU",
	/** Indonesia */
	Id: "ID",
	/** Ireland */
	Ie: "IE",
	/** Israel */
	Il: "IL",
	/** Isle of Man */
	Im: "IM",
	/** India */
	In: "IN",
	/** British Indian Ocean Territory */
	Io: "IO",
	/** Iraq */
	Iq: "IQ",
	/** Iran */
	Ir: "IR",
	/** Iceland */
	Is: "IS",
	/** Italy */
	It: "IT",
	/** Jersey */
	Je: "JE",
	/** Jamaica */
	Jm: "JM",
	/** Jordan */
	Jo: "JO",
	/** Japan */
	Jp: "JP",
	/** Kenya */
	Ke: "KE",
	/** Kyrgyzstan */
	Kg: "KG",
	/** Cambodia */
	Kh: "KH",
	/** Kiribati */
	Ki: "KI",
	/** Comoros */
	Km: "KM",
	/** Saint Kitts and Nevis */
	Kn: "KN",
	/** North Korea */
	Kp: "KP",
	/** South Korea */
	Kr: "KR",
	/** Kuwait */
	Kw: "KW",
	/** Cayman Islands */
	Ky: "KY",
	/** Kazakhstan */
	Kz: "KZ",
	/** Laos */
	La: "LA",
	/** Lebanon */
	Lb: "LB",
	/** Saint Lucia */
	Lc: "LC",
	/** Liechtenstein */
	Li: "LI",
	/** Sri Lanka */
	Lk: "LK",
	/** Liberia */
	Lr: "LR",
	/** Lesotho */
	Ls: "LS",
	/** Lithuania */
	Lt: "LT",
	/** Luxembourg */
	Lu: "LU",
	/** Latvia */
	Lv: "LV",
	/** Libya */
	Ly: "LY",
	/** Morocco */
	Ma: "MA",
	/** Monaco */
	Mc: "MC",
	/** Moldova */
	Md: "MD",
	/** Montenegro */
	Me: "ME",
	/** Saint Martin (French part) */
	Mf: "MF",
	/** Madagascar */
	Mg: "MG",
	/** Marshall Islands */
	Mh: "MH",
	/** North Macedonia */
	Mk: "MK",
	/** Mali */
	Ml: "ML",
	/** Myanmar */
	Mm: "MM",
	/** Mongolia */
	Mn: "MN",
	/** Macao */
	Mo: "MO",
	/** Northern Mariana Islands */
	Mp: "MP",
	/** Martinique */
	Mq: "MQ",
	/** Mauritania */
	Mr: "MR",
	/** Montserrat */
	Ms: "MS",
	/** Malta */
	Mt: "MT",
	/** Mauritius */
	Mu: "MU",
	/** Maldives */
	Mv: "MV",
	/** Malawi */
	Mw: "MW",
	/** Mexico */
	Mx: "MX",
	/** Malaysia */
	My: "MY",
	/** Mozambique */
	Mz: "MZ",
	/** Namibia */
	Na: "NA",
	/** New Caledonia */
	Nc: "NC",
	/** Niger */
	Ne: "NE",
	/** Norfolk Island */
	Nf: "NF",
	/** Nigeria */
	Ng: "NG",
	/** Nicaragua */
	Ni: "NI",
	/** Netherlands */
	Nl: "NL",
	/** Norway */
	No: "NO",
	/** Nepal */
	Np: "NP",
	/** Nauru */
	Nr: "NR",
	/** Niue */
	Nu: "NU",
	/** New Zealand */
	Nz: "NZ",
	/** Oman */
	Om: "OM",
	/** Panama */
	Pa: "PA",
	/** Peru */
	Pe: "PE",
	/** French Polynesia */
	Pf: "PF",
	/** Papua New Guinea */
	Pg: "PG",
	/** Philippines */
	Ph: "PH",
	/** Pakistan */
	Pk: "PK",
	/** Poland */
	Pl: "PL",
	/** Saint Pierre and Miquelon */
	Pm: "PM",
	/** Pitcairn */
	Pn: "PN",
	/** Puerto Rico */
	Pr: "PR",
	/** Palestine */
	Ps: "PS",
	/** Portugal */
	Pt: "PT",
	/** Palau */
	Pw: "PW",
	/** Paraguay */
	Py: "PY",
	/** Qatar */
	Qa: "QA",
	/** Réunion */
	Re: "RE",
	/** Romania */
	Ro: "RO",
	/** Serbia */
	Rs: "RS",
	/** Russia */
	Ru: "RU",
	/** Rwanda */
	Rw: "RW",
	/** Saudi Arabia */
	Sa: "SA",
	/** Solomon Islands */
	Sb: "SB",
	/** Seychelles */
	Sc: "SC",
	/** Sudan */
	Sd: "SD",
	/** Sweden */
	Se: "SE",
	/** Singapore */
	Sg: "SG",
	/** Saint Helena */
	Sh: "SH",
	/** Slovenia */
	Si: "SI",
	/** Svalbard and Jan Mayen */
	Sj: "SJ",
	/** Slovakia */
	Sk: "SK",
	/** Sierra Leone */
	Sl: "SL",
	/** San Marino */
	Sm: "SM",
	/** Senegal */
	Sn: "SN",
	/** Somalia */
	So: "SO",
	/** Suriname */
	Sr: "SR",
	/** South Sudan */
	Ss: "SS",
	/** Sao Tome and Principe */
	St: "ST",
	/** El Salvador */
	Sv: "SV",
	/** Sint Maarten (Dutch part) */
	Sx: "SX",
	/** Syria */
	Sy: "SY",
	/** Eswatini */
	Sz: "SZ",
	/** Turks and Caicos Islands */
	Tc: "TC",
	/** Chad */
	Td: "TD",
	/** French Southern Territories */
	Tf: "TF",
	/** Togo */
	Tg: "TG",
	/** Thailand */
	Th: "TH",
	/** Tajikistan */
	Tj: "TJ",
	/** Tokelau */
	Tk: "TK",
	/** Timor-Leste */
	Tl: "TL",
	/** Turkmenistan */
	Tm: "TM",
	/** Tunisia */
	Tn: "TN",
	/** Tonga */
	To: "TO",
	/** Türkiye */
	Tr: "TR",
	/** Trinidad and Tobago */
	Tt: "TT",
	/** Tuvalu */
	Tv: "TV",
	/** Taiwan */
	Tw: "TW",
	/** Tanzania */
	Tz: "TZ",
	/** Ukraine */
	Ua: "UA",
	/** Uganda */
	Ug: "UG",
	/** United States Minor Outlying Islands */
	Um: "UM",
	/** United States of America */
	Us: "US",
	/** Uruguay */
	Uy: "UY",
	/** Uzbekistan */
	Uz: "UZ",
	/** Vatican City */
	Va: "VA",
	/** Saint Vincent and the Grenadines */
	Vc: "VC",
	/** Venezuela */
	Ve: "VE",
	/** Virgin Islands (British) */
	Vg: "VG",
	/** Virgin Islands (U.S.) */
	Vi: "VI",
	/** Vietnam */
	Vn: "VN",
	/** Vanuatu */
	Vu: "VU",
	/** Wallis and Futuna */
	Wf: "WF",
	/** Samoa */
	Ws: "WS",
	/** Yemen */
	Ye: "YE",
	/** Mayotte */
	Yt: "YT",
	/** South Africa */
	Za: "ZA",
	/** Zambia */
	Zm: "ZM",
	/** Zimbabwe */
	Zw: "ZW",
} as const

export type ProjectCountryEnum =
	(typeof ProjectCountryEnum)[keyof typeof ProjectCountryEnum]
/** An enumeration. */
export const ProjectFixedInterestAmountPerShareCurrencyEnum = {
	/** Euro */
	Eur: "EUR",
} as const

export type ProjectFixedInterestAmountPerShareCurrencyEnum =
	(typeof ProjectFixedInterestAmountPerShareCurrencyEnum)[keyof typeof ProjectFixedInterestAmountPerShareCurrencyEnum]
export type ProjectForInvestorType = {
	__typename?: "ProjectForInvestorType"
	id: EntireFieldWrapper<Scalars["ID"]["output"]>
	/** The name of the project. */
	name: EntireFieldWrapper<Scalars["String"]["output"]>
}

/** An enumeration. */
export const ProjectHorizonAmountTotalCurrencyEnum = {
	/** Euro */
	Eur: "EUR",
} as const

export type ProjectHorizonAmountTotalCurrencyEnum =
	(typeof ProjectHorizonAmountTotalCurrencyEnum)[keyof typeof ProjectHorizonAmountTotalCurrencyEnum]
/** An enumeration. */
export const ProjectHorizonMaximumAmountTotalCurrencyEnum = {
	/** Euro */
	Eur: "EUR",
} as const

export type ProjectHorizonMaximumAmountTotalCurrencyEnum =
	(typeof ProjectHorizonMaximumAmountTotalCurrencyEnum)[keyof typeof ProjectHorizonMaximumAmountTotalCurrencyEnum]
/** An enumeration. */
export const ProjectInterestPaymentCalculationTypeEnum = {
	/** Endex + fixed surcharge */
	EndexEnergyCost: "ENDEX_ENERGY_COST",
	/** Fixed cost only */
	FixedEnergyCost: "FIXED_ENERGY_COST",
	/** Fixed interest amount */
	FixedInterestAmount: "FIXED_INTEREST_AMOUNT",
	/** Fixed interest rate */
	FixedInterestRate: "FIXED_INTEREST_RATE",
} as const

export type ProjectInterestPaymentCalculationTypeEnum =
	(typeof ProjectInterestPaymentCalculationTypeEnum)[keyof typeof ProjectInterestPaymentCalculationTypeEnum]
export type ProjectListType = {
	__typename?: "ProjectListType"
	/** Project list, paginated by LimitOffsetPaginator */
	results?: EntireFieldWrapper<Maybe<Array<Maybe<ProjectType>>>>
	/** Total count of matches elements */
	totalCount?: EntireFieldWrapper<Maybe<Scalars["Int"]["output"]>>
}

export type ProjectListTypeResultsArgs = {
	limit?: InputMaybe<Scalars["Int"]["input"]>
	offset?: InputMaybe<Scalars["Int"]["input"]>
	ordering?: InputMaybe<Scalars["String"]["input"]>
}

/**
 *
 *     Quick overview of Project performance.
 *
 */
export type ProjectOverviewStatsType = {
	__typename?: "ProjectOverviewStatsType"
	monitoring_status?: EntireFieldWrapper<Maybe<MonitoringStatusStatsType>>
	performance_ratio?: EntireFieldWrapper<Maybe<Scalars["Decimal"]["output"]>>
	pk?: EntireFieldWrapper<Maybe<Scalars["Int"]["output"]>>
	production_delta?: EntireFieldWrapper<Maybe<Scalars["Decimal"]["output"]>>
	targeted_performance_ratio?: EntireFieldWrapper<
		Maybe<Scalars["Decimal"]["output"]>
	>
	total_production?: EntireFieldWrapper<Maybe<Scalars["Decimal"]["output"]>>
	yearly_production_factor?: EntireFieldWrapper<
		Maybe<Scalars["Decimal"]["output"]>
	>
}

export type ProjectOwnerWithStatsType = {
	__typename?: "ProjectOwnerWithStatsType"
	business_legal_name?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	business_nr?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	id?: EntireFieldWrapper<Maybe<Scalars["ID"]["output"]>>
	projects?: EntireFieldWrapper<Maybe<Array<Maybe<PublicProjectType>>>>
	total_amount_raised?: EntireFieldWrapper<
		Maybe<Scalars["Decimal"]["output"]>
	>
	total_projects?: EntireFieldWrapper<Maybe<Scalars["Int"]["output"]>>
}

export type ProjectOwnersResultType = {
	__typename?: "ProjectOwnersResultType"
	results?: EntireFieldWrapper<Maybe<Array<Maybe<ProjectOwnerWithStatsType>>>>
	total_count?: EntireFieldWrapper<Maybe<Scalars["Int"]["output"]>>
	total_count_multiple_projects?: EntireFieldWrapper<
		Maybe<Scalars["Int"]["output"]>
	>
}

export type ProjectOwnersResultTypeResultsArgs = {
	limit?: InputMaybe<Scalars["Int"]["input"]>
	offset?: InputMaybe<Scalars["Int"]["input"]>
}

/** An enumeration. */
export const ProjectPaymentPeriodDurationFormatEnum = {
	/** Days */
	Days: "DAYS",
	/** Months */
	Months: "MONTHS",
	/** Weeks */
	Weeks: "WEEKS",
	/** Years */
	Years: "YEARS",
} as const

export type ProjectPaymentPeriodDurationFormatEnum =
	(typeof ProjectPaymentPeriodDurationFormatEnum)[keyof typeof ProjectPaymentPeriodDurationFormatEnum]
/** An enumeration. */
export const ProjectProjectObligationsStatusEnum = {
	/** Fulfilled */
	Fulfilled: "FULFILLED",
	/** Not fulfilled */
	NotFulfilled: "NOT_FULFILLED",
	/** Paid off */
	PaidOff: "PAID_OFF",
} as const

export type ProjectProjectObligationsStatusEnum =
	(typeof ProjectProjectObligationsStatusEnum)[keyof typeof ProjectProjectObligationsStatusEnum]
/** An enumeration. */
export const ProjectStateEnum = {
	/** Being installed */
	BeingInstalled: "BEING_INSTALLED",
	/** Directly financed */
	DirectlyFinanced: "DIRECTLY_FINANCED",
	/** Fixed interest */
	FixedInterest: "FIXED_INTEREST",
	/** Investment allocation */
	InvestmentAllocation: "INVESTMENT_ALLOCATION",
	/** In funding */
	InFunding: "IN_FUNDING",
	/** In production */
	InProduction: "IN_PRODUCTION",
	/** Monitoring offline */
	MonitoringOffline: "MONITORING_OFFLINE",
	/** No production */
	NoProduction: "NO_PRODUCTION",
	/** Paid off */
	PaidOff: "PAID_OFF",
} as const

export type ProjectStateEnum =
	(typeof ProjectStateEnum)[keyof typeof ProjectStateEnum]
export type ProjectStatisticsType = {
	__typename?: "ProjectStatisticsType"
	/**
	 * Percentage difference between the current and expected energy price for the running interest period.
	 *         Returns None for portfolio/bond project types or if there is no running period.
	 *
	 */
	delta_energy_price?: EntireFieldWrapper<Maybe<Scalars["Decimal"]["output"]>>
	/**
	 * Percentage difference between total actual and expected production.
	 *         Positive means above expected, negative means below.
	 *
	 */
	delta_production?: EntireFieldWrapper<Maybe<Scalars["Decimal"]["output"]>>
	/**
	 * Expected Internal Rate of Return (IRR) as a percentage, computed from the initial share value
	 *         and expected payment-per-share cashflows. Returns project.expected_irr if set, or the fixed
	 *         interest rate for fixed-interest projects.
	 *
	 */
	expected_internal_rate_of_return?: EntireFieldWrapper<
		Maybe<Scalars["Float"]["output"]>
	>
	/**
	 * Actual Internal Rate of Return (IRR) as a percentage, computed from the initial share value
	 *         and actual payment-per-share cashflows across all interest periods.
	 *         For fixed-interest projects, returns the fixed rate directly.
	 *
	 */
	internal_rate_of_return?: EntireFieldWrapper<
		Maybe<Scalars["Float"]["output"]>
	>
	solar_interest_chart_data?: EntireFieldWrapper<
		Maybe<SolarInterestChartDataType>
	>
	stats_information_by_interest_period?: EntireFieldWrapper<
		Maybe<Array<Maybe<StatsInformationByInterestPeriodType>>>
	>
}

export type ProjectType = {
	__typename?: "ProjectType"
	/** This is for reference. It is not used in any calculations. */
	actual_start_production?: EntireFieldWrapper<
		Maybe<Scalars["CustomDate"]["output"]>
	>
	/** The AFM (Authority for the Financial Markets) document in PDF format. */
	afm_document?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** The repayment schedule type for the project (Bullet, Linear, or Custom). */
	amortization_schedule?: EntireFieldWrapper<
		Maybe<ProjectAmortizationScheduleEnum>
	>
	/** The maximum interest amount per share (upper limit). */
	cap_eur_interest_per_share?: EntireFieldWrapper<
		Maybe<Scalars["Float"]["output"]>
	>
	/** Variable (in kWhs per square meter) used for calculating Project's performance ratio */
	cemm_correction_factor?: EntireFieldWrapper<
		Maybe<Scalars["Float"]["output"]>
	>
	/** The city where the project is located. */
	city?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** After entering the commissioning date, the maintenance and cleaning moments are automatically created. */
	commissioning_date?: EntireFieldWrapper<
		Maybe<Scalars["CustomDate"]["output"]>
	>
	/** The country where the project is located. */
	country?: EntireFieldWrapper<Maybe<ProjectCountryEnum>>
	/** Created At */
	created?: EntireFieldWrapper<Maybe<Scalars["CustomDateTime"]["output"]>>
	current_interest_period?: EntireFieldWrapper<Maybe<InterestPeriodType>>
	documents?: EntireFieldWrapper<
		Maybe<Array<Maybe<InvestmentCampaignDocument>>>
	>
	/** Duration of the project in years */
	duration?: EntireFieldWrapper<Maybe<Scalars["Int"]["output"]>>
	/** The 18-digit European Article Number (EAN) code for the installation's electricity meter. */
	ean_code?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** The date when the project is scheduled to end. */
	end?: EntireFieldWrapper<Maybe<Scalars["CustomDate"]["output"]>>
	/** Estimated energy price(in eurocent per kWh) used in the Information Memorandum. */
	estimated_energy_tariff?: EntireFieldWrapper<
		Maybe<Scalars["Float"]["output"]>
	>
	/** In % (percentage), the expected annual linear degradation factor. By default this is 0.5% */
	expected_degradation?: EntireFieldWrapper<Maybe<Scalars["Float"]["output"]>>
	/** Expected internal rate of return for paid-off/completed projects. It can be empty for other projects */
	expected_irr?: EntireFieldWrapper<Maybe<Scalars["Float"]["output"]>>
	/** The expected date when the project will start producing energy. */
	expected_start_production?: EntireFieldWrapper<
		Maybe<Scalars["CustomDate"]["output"]>
	>
	fiscal_overview?: EntireFieldWrapper<
		Maybe<Array<Maybe<FiscalOverviewType>>>
	>
	/** Energy price (in eurocent per kWh) for any solar interest period. When this is filled, then Endex data is not used. */
	fixed_energy_cost_per_kwh?: EntireFieldWrapper<
		Maybe<Scalars["Float"]["output"]>
	>
	/** Fixed interest amount per share for the interest periods payments. */
	fixed_interest_amount_per_share?: EntireFieldWrapper<
		Maybe<Scalars["Float"]["output"]>
	>
	/** fixed interest amount per share currency */
	fixed_interest_amount_per_share_currency?: EntireFieldWrapper<
		Maybe<ProjectFixedInterestAmountPerShareCurrencyEnum>
	>
	/** Fixed interest rate(%) for the interest periods payments. */
	fixed_interest_rate?: EntireFieldWrapper<Maybe<Scalars["Float"]["output"]>>
	/** Variable (in euros per mWh) used for calculating the price per kWh for Solar interest period. Summed up with Endex price. */
	fixed_surcharge?: EntireFieldWrapper<Maybe<Scalars["Float"]["output"]>>
	/** The minimum interest amount per share (lower limit). */
	floor_eur_interest_per_share?: EntireFieldWrapper<
		Maybe<Scalars["Float"]["output"]>
	>
	id?: EntireFieldWrapper<Maybe<Scalars["ID"]["output"]>>
	image_url?: EntireFieldWrapper<Maybe<Scalars["FileField"]["output"]>>
	installer?: EntireFieldWrapper<Maybe<InstallerType>>
	/** How to calculate interest for the interest periods payments? */
	interest_payment_calculation_type?: EntireFieldWrapper<
		Maybe<ProjectInterestPaymentCalculationTypeEnum>
	>
	interest_periods?: EntireFieldWrapper<
		Maybe<Array<Maybe<InterestPeriodType>>>
	>
	investor_production_stats?: EntireFieldWrapper<
		Maybe<InvestorProductionStatsType>
	>
	investor_shares_value_stats?: EntireFieldWrapper<
		Maybe<InvestorSharesValueStatsType>
	>
	investor_yearly_report_notification_status?: EntireFieldWrapper<
		Maybe<Scalars["Boolean"]["output"]>
	>
	/** Enabling this option removes the project from every query in django. Use this instead of deleting it. */
	is_deleted?: EntireFieldWrapper<Maybe<Scalars["Boolean"]["output"]>>
	/** This field is mandatory only for Solar Bonds. */
	issuance_date_in_information_memorandum?: EntireFieldWrapper<
		Maybe<Scalars["CustomDate"]["output"]>
	>
	/** Variable (in kWhs per square meter) used for calculating Project's performance ratio */
	knmi_correction_factor?: EntireFieldWrapper<
		Maybe<Scalars["Float"]["output"]>
	>
	/** Latitude coordinate of the project location. */
	latitude?: EntireFieldWrapper<Maybe<Scalars["Float"]["output"]>>
	/** Longitude coordinate of the project location. */
	longitude?: EntireFieldWrapper<Maybe<Scalars["Float"]["output"]>>
	/** (DEPRECATED) in kWh | Is an old calculation for dashboard. */
	max_power?: EntireFieldWrapper<Maybe<Scalars["Int"]["output"]>>
	/** in Watt */
	max_watt_panel?: EntireFieldWrapper<Maybe<Scalars["Int"]["output"]>>
	/** Modified At */
	modified?: EntireFieldWrapper<Maybe<Scalars["CustomDateTime"]["output"]>>
	/** The name of the project. */
	name?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	notificationconfiguration?: EntireFieldWrapper<
		Maybe<Array<NotificationConfigurationType>>
	>
	/** The house number of the project location. */
	number?: EntireFieldWrapper<Maybe<Scalars["Int"]["output"]>>
	/** Specific project stats */
	overall_statistics?: EntireFieldWrapper<Maybe<OverallStatisticsType>>
	overview?: EntireFieldWrapper<Maybe<ProjectOverviewStatsType>>
	owner?: EntireFieldWrapper<Maybe<OrganisationType>>
	/** Fill this in case if project was paid-off. Solar shares calculation will be affected accordingly. */
	paid_off_on?: EntireFieldWrapper<Maybe<Scalars["CustomDate"]["output"]>>
	/** Payment arrears status: 'No', number of days overdue (e.g. '22'), or '90+' (more than 90 days overdue) */
	payment_arrears?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** How many days after the interest period ending payout is planned? */
	payment_period_deadline_days_default?: EntireFieldWrapper<
		Maybe<Scalars["Int"]["output"]>
	>
	/** Used only for the first interest period. Leave empty if deadline should be default. */
	payment_period_deadline_days_first_period_delay?: EntireFieldWrapper<
		Maybe<Scalars["Int"]["output"]>
	>
	/** The duration of each interest payment period in the format specified above. */
	payment_period_duration?: EntireFieldWrapper<
		Maybe<Scalars["Int"]["output"]>
	>
	/** Always use the largest interval (1 year, not 365 days, etc.) */
	payment_period_duration_format?: EntireFieldWrapper<
		Maybe<ProjectPaymentPeriodDurationFormatEnum>
	>
	/** The project brochure in PDF format. */
	pdf_brochure?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	pdf_memorandum?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	pdf_service_agreement?: EntireFieldWrapper<
		Maybe<Scalars["String"]["output"]>
	>
	/** The postal code of the project location. */
	postcode?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** Indicates whether the project is in default. */
	project_in_default?: EntireFieldWrapper<Maybe<Scalars["Boolean"]["output"]>>
	/** Explanation providing details about the project's default status. */
	project_in_default_explanation_text?: EntireFieldWrapper<
		Maybe<Scalars["String"]["output"]>
	>
	/** Explanation of more project details or if project had any problems with payments or production or any other reasons */
	project_obligations_explanation_text?: EntireFieldWrapper<
		Maybe<Scalars["String"]["output"]>
	>
	/** The status of the project's obligations (Fulfilled, Not Fulfilled, or Paid Off). */
	project_obligations_status?: EntireFieldWrapper<
		Maybe<ProjectProjectObligationsStatusEnum>
	>
	project_owner_pay_in_link?: EntireFieldWrapper<
		Maybe<Scalars["String"]["output"]>
	>
	/** The number of solar shares allocated per panel. */
	shares_per_panel?: EntireFieldWrapper<Maybe<Scalars["Int"]["output"]>>
	/** This factor is derived from the Performance Ratio (PR = standard 81%) minus 4%.By default this is 0.81-0.04 = 0.77. If the PR based on PV-sol or PV-syst is higher than 81 is this value can be adjusted. */
	solar_derate_factor?: EntireFieldWrapper<Maybe<Scalars["Float"]["output"]>>
	solardistribution?: EntireFieldWrapper<Maybe<Array<SolarDistributionType>>>
	/** The date when the project officially starts. */
	start?: EntireFieldWrapper<Maybe<Scalars["CustomDate"]["output"]>>
	/** The current state of the project. */
	state?: EntireFieldWrapper<Maybe<ProjectStateEnum>>
	/** The street name of the project location. */
	street?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** The house number suffix (e.g., A, B, bis). */
	suffix?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	supplier?: EntireFieldWrapper<Maybe<EnergySupplierType>>
	/** Targeted performance ratio in % */
	targeted_performance_ratio?: EntireFieldWrapper<
		Maybe<Scalars["Float"]["output"]>
	>
	/** The total amount (in euros) of the Solar Bond Loan as stated in the Information Memorandum. */
	total_amount?: EntireFieldWrapper<Maybe<Scalars["Float"]["output"]>>
	/** in Kilowatt */
	total_inverter_power?: EntireFieldWrapper<Maybe<Scalars["Float"]["output"]>>
	/** The total number of solar panels in this project. */
	total_panels?: EntireFieldWrapper<Maybe<Scalars["Int"]["output"]>>
	/** The total number of solar shares issued for this project. */
	total_shares?: EntireFieldWrapper<Maybe<Scalars["Int"]["output"]>>
	/** The type of project (Shares (Solar Production Dependent), Bonds (Fixed Interest), Pro (Portfolio), Fund, or Lease). */
	type?: EntireFieldWrapper<Maybe<ProjectTypeEnum>>
	/** Universally unique identifier. */
	uuid?: EntireFieldWrapper<Maybe<Scalars["UUID"]["output"]>>
	/** Short version of the universally unique identifier. */
	uuid_short?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** in kWh */
	yearly_production?: EntireFieldWrapper<Maybe<Scalars["Int"]["output"]>>
}

export type ProjectTypeInvestor_Production_StatsArgs = {
	end?: InputMaybe<Scalars["DateTime"]["input"]>
	start?: InputMaybe<Scalars["DateTime"]["input"]>
}

export type ProjectTypeInvestor_Shares_Value_StatsArgs = {
	valuation_date?: InputMaybe<Scalars["Date"]["input"]>
}

export type ProjectTypeOverall_StatisticsArgs = {
	end?: InputMaybe<Scalars["DateTime"]["input"]>
	start?: InputMaybe<Scalars["DateTime"]["input"]>
}

/** An enumeration. */
export const ProjectTypeEnum = {
	/** Pro (Portfolio) */
	Portfolio: "PORTFOLIO",
	/** Bonds (Fixed Interest) */
	SolarBonds: "SOLAR_BONDS",
	/** Fund */
	SolarFunds: "SOLAR_FUNDS",
	/** Lease */
	SolarLease: "SOLAR_LEASE",
	/** Shares (Solar Production Dependent) */
	SolarShares: "SOLAR_SHARES",
} as const

export type ProjectTypeEnum =
	(typeof ProjectTypeEnum)[keyof typeof ProjectTypeEnum]
export type PublicProjectListType = {
	__typename?: "PublicProjectListType"
	/** Project list, paginated by LimitOffsetPaginator */
	results?: EntireFieldWrapper<Maybe<Array<Maybe<ProjectType>>>>
	/** Total count of matches elements */
	totalCount?: EntireFieldWrapper<Maybe<Scalars["Int"]["output"]>>
}

export type PublicProjectListTypeResultsArgs = {
	limit?: InputMaybe<Scalars["Int"]["input"]>
	offset?: InputMaybe<Scalars["Int"]["input"]>
	ordering?: InputMaybe<Scalars["String"]["input"]>
}

export type PublicProjectType = {
	__typename?: "PublicProjectType"
	amount_raised?: EntireFieldWrapper<Maybe<Scalars["Decimal"]["output"]>>
	amount_requested?: EntireFieldWrapper<Maybe<Scalars["Decimal"]["output"]>>
	/** Duration of the project in years */
	duration?: EntireFieldWrapper<Maybe<Scalars["Int"]["output"]>>
	end?: EntireFieldWrapper<Maybe<Scalars["DateTime"]["output"]>>
	/** Django object unique identification field */
	id: EntireFieldWrapper<Scalars["ID"]["output"]>
	image_url?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	internal_rate_of_return?: EntireFieldWrapper<
		Maybe<Scalars["Float"]["output"]>
	>
	/** Latitude coordinate of the project location. */
	latitude?: EntireFieldWrapper<Maybe<Scalars["Float"]["output"]>>
	/** Longitude coordinate of the project location. */
	longitude?: EntireFieldWrapper<Maybe<Scalars["Float"]["output"]>>
	min_investment_amount?: EntireFieldWrapper<
		Maybe<Scalars["Decimal"]["output"]>
	>
	/** The name of the project. */
	name?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	page_url?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** Payment arrears status: 'No', number of days overdue (e.g. '22'), or '90+' (more than 90 days overdue) */
	payment_arrears?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** The status of the project's obligations (Fulfilled, Not Fulfilled, or Paid Off). */
	project_obligations_status?: EntireFieldWrapper<
		Maybe<ProjectProjectObligationsStatusEnum>
	>
	start?: EntireFieldWrapper<Maybe<Scalars["DateTime"]["output"]>>
	supplier?: EntireFieldWrapper<Maybe<EnergySupplierType>>
	/** The total amount (in euros) of the Solar Bond Loan as stated in the Information Memorandum. */
	total_amount?: EntireFieldWrapper<Maybe<Scalars["Float"]["output"]>>
	type?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
}

export type Query = {
	__typename?: "Query"
	debug?: EntireFieldWrapper<Maybe<DjangoDebug>>
	/** Energy Suppliers */
	energy_suppliers?: EntireFieldWrapper<Maybe<Array<EnergySupplierType>>>
	/** Interest Payments */
	interest_payments?: EntireFieldWrapper<Maybe<InterestPaymentListType>>
	/** Investment campaign project */
	investment_campaign_project?: EntireFieldWrapper<
		Maybe<InvestmentCampaignProjectType>
	>
	/** Investment campaign projects */
	investment_campaign_projects?: EntireFieldWrapper<
		Maybe<Array<InvestmentCampaignProjectType>>
	>
	me?: EntireFieldWrapper<Maybe<UserType>>
	/** Zonhub overall project stats */
	overall_statistics?: EntireFieldWrapper<Maybe<OverallStatisticsType>>
	platform_statistics?: EntireFieldWrapper<Maybe<PlatformStatisticsType>>
	/** Platform statistics grouped by project type */
	platform_statistics_per_project_type?: EntireFieldWrapper<
		Maybe<Array<Maybe<PlatformStatisticsPerProjectType>>>
	>
	/** Zonhub Project */
	project?: EntireFieldWrapper<Maybe<ProjectType>>
	/** Zonhub project stats */
	project_statistics?: EntireFieldWrapper<Maybe<ProjectStatisticsType>>
	/** Zonhub Projects */
	projects?: EntireFieldWrapper<Maybe<Array<ProjectType>>>
	/**
	 * Projects located nearby a specific location.
	 * @deprecated Deprecated use `public_projects`
	 */
	projects_with_location?: EntireFieldWrapper<Maybe<NearbyProjectListType>>
	/** Projects located nearby a specific location. */
	public_projects?: EntireFieldWrapper<Maybe<PublicProjectListType>>
	version?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
}

export type QueryEnergy_SuppliersArgs = {
	id?: InputMaybe<Scalars["ID"]["input"]>
	is_partner?: InputMaybe<Scalars["Boolean"]["input"]>
	limit?: InputMaybe<Scalars["Int"]["input"]>
	name__icontains?: InputMaybe<Scalars["String"]["input"]>
	offset?: InputMaybe<Scalars["Int"]["input"]>
	ordering?: InputMaybe<Scalars["String"]["input"]>
}

export type QueryInterest_PaymentsArgs = {
	id?: InputMaybe<Scalars["ID"]["input"]>
	interestperiod__project?: InputMaybe<Scalars["ID"]["input"]>
	interestperiod__project__name__icontains?: InputMaybe<
		Scalars["String"]["input"]
	>
	q?: InputMaybe<Scalars["String"]["input"]>
	state?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
}

export type QueryInvestment_Campaign_ProjectArgs = {
	id: Scalars["ID"]["input"]
}

export type QueryInvestment_Campaign_ProjectsArgs = {
	id?: InputMaybe<Scalars["ID"]["input"]>
	limit?: InputMaybe<Scalars["Int"]["input"]>
	offset?: InputMaybe<Scalars["Int"]["input"]>
	ordering?: InputMaybe<Scalars["String"]["input"]>
	owner?: InputMaybe<Scalars["ID"]["input"]>
	partners?: InputMaybe<Scalars["ID"]["input"]>
	project?: InputMaybe<Scalars["ID"]["input"]>
	title__icontains?: InputMaybe<Scalars["String"]["input"]>
}

export type QueryOverall_StatisticsArgs = {
	end: Scalars["DateTime"]["input"]
	id?: InputMaybe<Scalars["ID"]["input"]>
	start: Scalars["DateTime"]["input"]
}

export type QueryPlatform_StatisticsArgs = {
	date?: InputMaybe<Scalars["DateTime"]["input"]>
	project_types?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
}

export type QueryPlatform_Statistics_Per_Project_TypeArgs = {
	date?: InputMaybe<Scalars["DateTime"]["input"]>
}

export type QueryProjectArgs = {
	id: Scalars["ID"]["input"]
}

export type QueryProject_StatisticsArgs = {
	id: Scalars["ID"]["input"]
}

export type QueryProjectsArgs = {
	id?: InputMaybe<Scalars["ID"]["input"]>
	limit?: InputMaybe<Scalars["Int"]["input"]>
	name__icontains?: InputMaybe<Scalars["String"]["input"]>
	offset?: InputMaybe<Scalars["Int"]["input"]>
	ordering?: InputMaybe<Scalars["String"]["input"]>
	state?: InputMaybe<Scalars["String"]["input"]>
	supplier__name__icontains?: InputMaybe<Scalars["String"]["input"]>
	type?: InputMaybe<Scalars["String"]["input"]>
}

export type QueryProjects_With_LocationArgs = {
	id?: InputMaybe<Scalars["ID"]["input"]>
	latitude: Scalars["Decimal"]["input"]
	longitude: Scalars["Decimal"]["input"]
	radius?: InputMaybe<Scalars["Decimal"]["input"]>
}

export type QueryPublic_ProjectsArgs = {
	id?: InputMaybe<Scalars["ID"]["input"]>
	latitude: Scalars["Decimal"]["input"]
	longitude: Scalars["Decimal"]["input"]
	name__icontains?: InputMaybe<Scalars["String"]["input"]>
	radius?: InputMaybe<Scalars["Decimal"]["input"]>
	state?: InputMaybe<Scalars["String"]["input"]>
	supplier__name__icontains?: InputMaybe<Scalars["String"]["input"]>
	type?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
}

/** An enumeration. */
export const RiskKycStateChoices = {
	/** Manual Process */
	ManualProcess: "MANUAL_PROCESS",
	/** PSP Verification Pending */
	PspVerificationPending: "PSP_VERIFICATION_PENDING",
	/** Uninitiated */
	Uninitiated: "UNINITIATED",
	/** Verification Failed */
	VerificationFailed: "VERIFICATION_FAILED",
	/** Verification Invalid */
	VerificationInvalid: "VERIFICATION_INVALID",
	/** Internal Verification Pending */
	VerificationPending: "VERIFICATION_PENDING",
	/** Verification Requested */
	VerificationRequested: "VERIFICATION_REQUESTED",
	/** Verification Success */
	VerificationSuccess: "VERIFICATION_SUCCESS",
} as const

export type RiskKycStateChoices =
	(typeof RiskKycStateChoices)[keyof typeof RiskKycStateChoices]
/** An enumeration. */
export const RiskKycVerificationDocumentDocumentTypeChoices = {
	/** Articles Of Association */
	ArticlesOfAssociation: "ARTICLES_OF_ASSOCIATION",
	/** Bank Card */
	BankCard: "BANK_CARD",
	/** Bank Statement */
	BankStatement: "BANK_STATEMENT",
	/** Contract */
	Contract: "CONTRACT",
	/** Credit Report (e.g Graydon Report) */
	CreditReport: "CREDIT_REPORT",
	/** Driving License */
	DrivingLicense: "DRIVING_LICENSE",
	/** Employment Certificate */
	EmploymentCertificate: "EMPLOYMENT_CERTIFICATE",
	/** National Id. Card */
	NationalIdNumber: "NATIONAL_ID_NUMBER",
	/** National Insurance Number */
	NationalInsuranceNumber: "NATIONAL_INSURANCE_NUMBER",
	/** Other */
	Other: "OTHER",
	/** Passport */
	Passport: "PASSPORT",
	/** Polling Card */
	PollingCard: "POLLING_CARD",
	/** Residence Permit */
	ResidencePermit: "RESIDENCE_PERMIT",
	/** Shareholder Declaration */
	ShareholderDeclaration: "SHAREHOLDER_DECLARATION",
	/** Social Security Number */
	SocialSecurityNumber: "SOCIAL_SECURITY_NUMBER",
	/** Tax Id. Number */
	TaxIdNumber: "TAX_ID_NUMBER",
	/** UBO Declaration */
	UboDeclaration: "UBO_DECLARATION",
	/** Utility Bill */
	UtilityBill: "UTILITY_BILL",
	/** Visa */
	Visa: "VISA",
} as const

export type RiskKycVerificationDocumentDocumentTypeChoices =
	(typeof RiskKycVerificationDocumentDocumentTypeChoices)[keyof typeof RiskKycVerificationDocumentDocumentTypeChoices]
/** Different Roles a user can have in the system */
export const Role = {
	Admin: "ADMIN",
	EnergySupplier: "ENERGY_SUPPLIER",
	Installer: "INSTALLER",
	Investor: "INVESTOR",
	ProjectOwner: "PROJECT_OWNER",
} as const

export type Role = (typeof Role)[keyof typeof Role]
/**
 * Start a Mangopay proxy consent session for the logged-in user and return the
 * redirect URL the frontend should send them to.
 *
 * Mangopay offers no way to set the consent scopes directly: the user ticks or
 * unticks them on the hosted SCA page, where they can grant consent for the
 * first time, add scopes, or revoke. The resulting ``sca_consent_*`` flags land
 * through the consent webhooks; call ``sca_status_refresh`` on the return leg
 * to read them without waiting for those.
 */
export type ScaConsentManage = {
	__typename?: "ScaConsentManage"
	/** URL to send the user to to manage their proxy consent. Null when no session was started (no Mangopay user, SCA enrollment required, or no pending action returned). The link expires 10 minutes after it is generated. */
	redirect_url?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** True when the user must complete SCA enrollment before managing proxy consent; chain the sca_enrollment_start mutation first. */
	sca_required?: EntireFieldWrapper<Maybe<Scalars["Boolean"]["output"]>>
}

/**
 * Create a new Mangopay SCA enrollment for the logged-in user and return the
 * redirect URL the frontend should send them to in order to complete strong
 * customer authentication.
 *
 * Each call creates a fresh enrollment on Mangopay's side (short TTL); the
 * frontend should invoke this only when the user explicitly starts the SCA
 * flow, not on every page load.
 */
export type ScaEnrollmentStart = {
	__typename?: "ScaEnrollmentStart"
	/** URL to send the user to to complete SCA. Null when no enrollment was created (no Mangopay user, unknown identity type, or no pending action returned). */
	redirect_url?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
}

/**
 * Reconcile the caller's SCA status against Mangopay and return the fresh values.
 *
 * Intended for the return leg of the Mangopay SCA redirect: the enrollment or
 * consent webhook may not have landed yet, and the user is looking at the page
 * right now. Kept out of the ``me`` query resolvers on purpose -- those run on
 * every page load and must not make PSP calls.
 */
export type ScaStatusRefresh = {
	__typename?: "ScaStatusRefresh"
	mangopay_sca?: EntireFieldWrapper<Maybe<MangopayScaType>>
	/** False when no Mangopay call was made, either because there is no Mangopay user or because the status was already synced within the throttle window. */
	refreshed?: EntireFieldWrapper<Maybe<Scalars["Boolean"]["output"]>>
}

/** An enumeration. */
export const SolarDistributionMonthEnum = {
	/** January */
	A_1: "A_1",
	/** February */
	A_2: "A_2",
	/** March */
	A_3: "A_3",
	/** April */
	A_4: "A_4",
	/** May */
	A_5: "A_5",
	/** June */
	A_6: "A_6",
	/** July */
	A_7: "A_7",
	/** August */
	A_8: "A_8",
	/** September */
	A_9: "A_9",
	/** October */
	A_10: "A_10",
	/** November */
	A_11: "A_11",
	/** December */
	A_12: "A_12",
} as const

export type SolarDistributionMonthEnum =
	(typeof SolarDistributionMonthEnum)[keyof typeof SolarDistributionMonthEnum]
export type SolarDistributionType = {
	__typename?: "SolarDistributionType"
	/** Distribution */
	distribution?: EntireFieldWrapper<Maybe<Scalars["Float"]["output"]>>
	/** Django object unique identification field */
	id: EntireFieldWrapper<Scalars["ID"]["output"]>
	/** Month */
	month?: EntireFieldWrapper<Maybe<SolarDistributionMonthEnum>>
}

export type SolarInterestChartDataType = {
	__typename?: "SolarInterestChartDataType"
	expected_roi_of_interest_periods?: EntireFieldWrapper<
		Maybe<Array<Maybe<Scalars["Float"]["output"]>>>
	>
	interest_period_numbers?: EntireFieldWrapper<
		Maybe<Array<Maybe<Scalars["Int"]["output"]>>>
	>
	roi_of_interest_periods?: EntireFieldWrapper<
		Maybe<Array<Maybe<Scalars["Float"]["output"]>>>
	>
}

export type SolarShareType = {
	__typename?: "SolarShareType"
	/** The date and time when this solar share was acquired by the investor. */
	acquired?: EntireFieldWrapper<Maybe<Scalars["CustomDateTime"]["output"]>>
	/** Indicates whether this share is part of a collective deposit. */
	collective_deposit?: EntireFieldWrapper<Maybe<Scalars["Boolean"]["output"]>>
	/** Created At */
	created?: EntireFieldWrapper<Maybe<Scalars["CustomDateTime"]["output"]>>
	/** Django object unique identification field */
	id: EntireFieldWrapper<Scalars["ID"]["output"]>
	/** The investor who owns this solar share. */
	investor?: EntireFieldWrapper<Maybe<InvestorType>>
	/** Modified At */
	modified?: EntireFieldWrapper<Maybe<Scalars["CustomDateTime"]["output"]>>
	/** The nominal value of this solar share in euros. */
	nominal_value?: EntireFieldWrapper<Maybe<Scalars["Float"]["output"]>>
	/** PaymentEntry list */
	paymententry?: EntireFieldWrapper<Maybe<Array<Maybe<PaymentEntryType>>>>
	/** The PDF certificate for this solar share. */
	pdf?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** The unique number identifying this solar share within the project. */
	share_number?: EntireFieldWrapper<Maybe<Scalars["Int"]["output"]>>
}

export type SolarShareTypePaymententryArgs = {
	id?: InputMaybe<Scalars["ID"]["input"]>
	name?: InputMaybe<Scalars["String"]["input"]>
	partner_supplier_only?: InputMaybe<Scalars["Boolean"]["input"]>
	state?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
	transaction_id?: InputMaybe<Scalars["String"]["input"]>
}

/** An enumeration. */
export const State = {
	Done: "DONE",
	New: "NEW",
	PendingApprovalByZpd: "PENDING_APPROVAL_BY_ZPD",
	PendingEmployee: "PENDING_EMPLOYEE",
	PendingInvestorPayment: "PENDING_INVESTOR_PAYMENT",
	PendingOwner: "PENDING_OWNER",
	PendingOwnerPayment: "PENDING_OWNER_PAYMENT",
	PendingSupplier: "PENDING_SUPPLIER",
	ScheduledCreation: "SCHEDULED_CREATION",
	Verified: "VERIFIED",
} as const

export type State = (typeof State)[keyof typeof State]
export type StatsInformationByInterestPeriodType = {
	__typename?: "StatsInformationByInterestPeriodType"
	/** End date of the interest period */
	end_date?: EntireFieldWrapper<Maybe<Scalars["DateTime"]["output"]>>
	/**
	 * Actual energy price per kWh in euros for this interest period.
	 *         For future/ongoing periods, uses the currently running interest period's price.
	 *
	 */
	energy_price?: EntireFieldWrapper<Maybe<Scalars["Decimal"]["output"]>>
	/**
	 * cache the return value of a method
	 *
	 *     This class is meant to be used as a decorator of methods. The return value
	 *     from a given method invocation will be cached on the instance whose method
	 *     was invoked. All arguments passed to a method decorated with memoize must
	 *     be hashable.
	 *
	 *     If a memoized method is invoked directly on its class the result will not
	 *     be cached. Instead the method will be invoked like a static method:
	 *     class Obj:
	 *         @memoize
	 *         def add_to(self, arg):
	 *             return self + arg
	 *     Obj.add_to(1) # not enough arguments
	 *     Obj.add_to(1, 2) # returns 3, result is not cached
	 *
	 */
	expected_energy_price?: EntireFieldWrapper<
		Maybe<Scalars["Decimal"]["output"]>
	>
	/** IM-committed interest payout (€) for this period, project-wide (across all bonds). Sourced directly from `InterestPeriod.expected_interest_amount`. */
	expected_interest_amount?: EntireFieldWrapper<
		Maybe<Scalars["Decimal"]["output"]>
	>
	/**
	 * cache the return value of a method
	 *
	 *     This class is meant to be used as a decorator of methods. The return value
	 *     from a given method invocation will be cached on the instance whose method
	 *     was invoked. All arguments passed to a method decorated with memoize must
	 *     be hashable.
	 *
	 *     If a memoized method is invoked directly on its class the result will not
	 *     be cached. Instead the method will be invoked like a static method:
	 *     class Obj:
	 *         @memoize
	 *         def add_to(self, arg):
	 *             return self + arg
	 *     Obj.add_to(1) # not enough arguments
	 *     Obj.add_to(1, 2) # returns 3, result is not cached
	 *
	 */
	expected_payment_per_share?: EntireFieldWrapper<
		Maybe<Scalars["Decimal"]["output"]>
	>
	/**
	 * cache the return value of a method
	 *
	 *     This class is meant to be used as a decorator of methods. The return value
	 *     from a given method invocation will be cached on the instance whose method
	 *     was invoked. All arguments passed to a method decorated with memoize must
	 *     be hashable.
	 *
	 *     If a memoized method is invoked directly on its class the result will not
	 *     be cached. Instead the method will be invoked like a static method:
	 *     class Obj:
	 *         @memoize
	 *         def add_to(self, arg):
	 *             return self + arg
	 *     Obj.add_to(1) # not enough arguments
	 *     Obj.add_to(1, 2) # returns 3, result is not cached
	 *
	 */
	expected_production_per_share?: EntireFieldWrapper<
		Maybe<Scalars["Decimal"]["output"]>
	>
	/**
	 * cache the return value of a method
	 *
	 *     This class is meant to be used as a decorator of methods. The return value
	 *     from a given method invocation will be cached on the instance whose method
	 *     was invoked. All arguments passed to a method decorated with memoize must
	 *     be hashable.
	 *
	 *     If a memoized method is invoked directly on its class the result will not
	 *     be cached. Instead the method will be invoked like a static method:
	 *     class Obj:
	 *         @memoize
	 *         def add_to(self, arg):
	 *             return self + arg
	 *     Obj.add_to(1) # not enough arguments
	 *     Obj.add_to(1, 2) # returns 3, result is not cached
	 *
	 */
	expected_return_on_investment?: EntireFieldWrapper<
		Maybe<Scalars["Decimal"]["output"]>
	>
	/**
	 * cache the return value of a method
	 *
	 *     This class is meant to be used as a decorator of methods. The return value
	 *     from a given method invocation will be cached on the instance whose method
	 *     was invoked. All arguments passed to a method decorated with memoize must
	 *     be hashable.
	 *
	 *     If a memoized method is invoked directly on its class the result will not
	 *     be cached. Instead the method will be invoked like a static method:
	 *     class Obj:
	 *         @memoize
	 *         def add_to(self, arg):
	 *             return self + arg
	 *     Obj.add_to(1) # not enough arguments
	 *     Obj.add_to(1, 2) # returns 3, result is not cached
	 *
	 */
	expected_solar_interest_per_share?: EntireFieldWrapper<
		Maybe<Scalars["Decimal"]["output"]>
	>
	/** Returns True if this interest period ended before today. */
	is_completed_interest_period?: EntireFieldWrapper<
		Maybe<Scalars["Boolean"]["output"]>
	>
	/** Returns True if today falls within this interest period. */
	is_current_interest_period?: EntireFieldWrapper<
		Maybe<Scalars["Boolean"]["output"]>
	>
	/** Total actual payment per share: solar interest + amortization + repayment. */
	payment_per_share?: EntireFieldWrapper<Maybe<Scalars["Decimal"]["output"]>>
	/** Returns the payment FSM state for completed periods, or None if the period is still ongoing. */
	payment_status?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** Actual production per theoretical share for this interest period in kWh. */
	production_per_share?: EntireFieldWrapper<
		Maybe<Scalars["Decimal"]["output"]>
	>
	/**
	 * Return on investment (in %) for Project given period, considering amortized value of the shares.
	 *
	 *                  solar interest for per 1 investor per 1 share
	 *         ROI =   ----------------------------------------------- * 100
	 *                     amortized value for 1 share
	 *
	 *         Note, ROI percentage does not depend on count of investor's shares.
	 *         ROI percentage is equal for all investors within time range of the same interest period.
	 *
	 */
	return_on_investment?: EntireFieldWrapper<
		Maybe<Scalars["Decimal"]["output"]>
	>
	/**
	 * cache the return value of a method
	 *
	 *     This class is meant to be used as a decorator of methods. The return value
	 *     from a given method invocation will be cached on the instance whose method
	 *     was invoked. All arguments passed to a method decorated with memoize must
	 *     be hashable.
	 *
	 *     If a memoized method is invoked directly on its class the result will not
	 *     be cached. Instead the method will be invoked like a static method:
	 *     class Obj:
	 *         @memoize
	 *         def add_to(self, arg):
	 *             return self + arg
	 *     Obj.add_to(1) # not enough arguments
	 *     Obj.add_to(1, 2) # returns 3, result is not cached
	 *
	 */
	share_value_after_interest_period_end?: EntireFieldWrapper<
		Maybe<Scalars["Decimal"]["output"]>
	>
	/**
	 * Actual solar interest per share for the period, with cap/floor limits applied.
	 *         For non-solar project types (bonds, portfolio), returns the expected value instead.
	 *
	 */
	solar_interest_per_share?: EntireFieldWrapper<
		Maybe<Scalars["Decimal"]["output"]>
	>
	/** Actual interest paid (€) for this period, project-wide (across all bonds). Sum of `PaymentEntry.cost` for the period's `Payment`, plus `PaymentEntry.repayment` when the project name contains 'Zonlease' (ad-hoc top-ups). Only counts payments that have transitioned out of `pending_owner_payment`, or Buckaroo payments in `done` state. None when no qualifying payment exists yet. */
	total_actual_interest?: EntireFieldWrapper<
		Maybe<Scalars["Decimal"]["output"]>
	>
}

export type StatsPerformanceRatioData = {
	__typename?: "StatsPerformanceRatioData"
	performance_ratio_data?: EntireFieldWrapper<
		Maybe<Array<Maybe<StatsPerformanceRatioGeneric>>>
	>
	total_performance_ratio?: EntireFieldWrapper<
		Maybe<Scalars["Decimal"]["output"]>
	>
}

export type StatsPerformanceRatioGeneric = {
	__typename?: "StatsPerformanceRatioGeneric"
	date?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	performance_ratio?: EntireFieldWrapper<Maybe<Scalars["Decimal"]["output"]>>
}

export type StatsProductionForDay = {
	__typename?: "StatsProductionForDay"
	production_data?: EntireFieldWrapper<
		Maybe<Array<Maybe<StatsProductionGeneric>>>
	>
	total_production?: EntireFieldWrapper<Maybe<Scalars["Decimal"]["output"]>>
}

export type StatsProductionGeneric = {
	__typename?: "StatsProductionGeneric"
	date?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	production?: EntireFieldWrapper<Maybe<Scalars["Decimal"]["output"]>>
}

/** An enumeration. */
export const SupplierVerificationStateEnum = {
	/** Accepted */
	Accepted: "ACCEPTED",
	/** Pending */
	Pending: "PENDING",
	/** Rejected */
	Rejected: "REJECTED",
} as const

export type SupplierVerificationStateEnum =
	(typeof SupplierVerificationStateEnum)[keyof typeof SupplierVerificationStateEnum]
export type SupplierVerificationType = {
	__typename?: "SupplierVerificationType"
	/** Created At */
	created?: EntireFieldWrapper<Maybe<Scalars["CustomDateTime"]["output"]>>
	/** id */
	id?: EntireFieldWrapper<Maybe<Scalars["UUID"]["output"]>>
	/** Message */
	message?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** Modified At */
	modified?: EntireFieldWrapper<Maybe<Scalars["CustomDateTime"]["output"]>>
	/** Opdrachtnummer */
	reference?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** State */
	state?: EntireFieldWrapper<Maybe<SupplierVerificationStateEnum>>
}

export type TotalProductionInHouseholdsUsagePerYearType = {
	__typename?: "TotalProductionInHouseholdsUsagePerYearType"
	production?: EntireFieldWrapper<Maybe<Scalars["Float"]["output"]>>
	year?: EntireFieldWrapper<Maybe<Scalars["Int"]["output"]>>
}

export type UserProfileType = {
	__typename?: "UserProfileType"
	address?: EntireFieldWrapper<Maybe<LocationType>>
	country_of_birth?: EntireFieldWrapper<
		Maybe<UsersUserProfileCountryOfBirthChoices>
	>
	country_of_residence?: EntireFieldWrapper<
		Maybe<UsersUserProfileCountryOfResidenceChoices>
	>
	created_at: EntireFieldWrapper<Scalars["DateTime"]["output"]>
	/** ISO 8601 date (YYYY-MM-DD). Must be a real past date on or after 1900-01-01. The account holder must be at least 18 years old and no older than 120 (rejected by our payment provider). */
	date_of_birth?: EntireFieldWrapper<Maybe<Scalars["Date"]["output"]>>
	deleted_at?: EntireFieldWrapper<Maybe<Scalars["DateTime"]["output"]>>
	gender: EntireFieldWrapper<UsersUserProfileGenderChoices>
	id: EntireFieldWrapper<Scalars["ID"]["output"]>
	identity_type: EntireFieldWrapper<UsersUserProfileIdentityTypeChoices>
	initials: EntireFieldWrapper<Scalars["String"]["output"]>
	language: EntireFieldWrapper<UsersUserProfileLanguageChoices>
	modified_at: EntireFieldWrapper<Scalars["DateTime"]["output"]>
	nationality?: EntireFieldWrapper<Maybe<UsersUserProfileNationalityChoices>>
	phone?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	timezone: EntireFieldWrapper<UsersUserProfileTimezoneChoices>
}

export type UserRoles = {
	__typename?: "UserRoles"
	is_energy_supplier?: EntireFieldWrapper<Maybe<Scalars["Boolean"]["output"]>>
	is_installer?: EntireFieldWrapper<Maybe<Scalars["Boolean"]["output"]>>
	is_investor?: EntireFieldWrapper<Maybe<Scalars["Boolean"]["output"]>>
	is_project_owner?: EntireFieldWrapper<Maybe<Scalars["Boolean"]["output"]>>
	is_staff?: EntireFieldWrapper<Maybe<Scalars["Boolean"]["output"]>>
	is_superuser?: EntireFieldWrapper<Maybe<Scalars["Boolean"]["output"]>>
}

export type UserType = {
	__typename?: "UserType"
	are_kyc_docs_requested?: EntireFieldWrapper<
		Maybe<Scalars["Boolean"]["output"]>
	>
	created_at: EntireFieldWrapper<Scalars["DateTime"]["output"]>
	date_joined: EntireFieldWrapper<Scalars["DateTime"]["output"]>
	deleted_at?: EntireFieldWrapper<Maybe<Scalars["DateTime"]["output"]>>
	email: EntireFieldWrapper<Scalars["String"]["output"]>
	energy_supplier_group?: EntireFieldWrapper<
		Maybe<Array<Maybe<EnergySupplierType>>>
	>
	/** Projects where the user is an owner, supplier or installer. */
	finance_projects?: EntireFieldWrapper<Maybe<ProjectListType>>
	first_name?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	full_first_name?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	full_name?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	id: EntireFieldWrapper<Scalars["ID"]["output"]>
	installer_group?: EntireFieldWrapper<Maybe<Array<Maybe<InstallerType>>>>
	/** Interest payments of the user. */
	interest_payments?: EntireFieldWrapper<Maybe<Array<InterestPaymentType>>>
	/** Projects investment campaigns where the user has invested in. */
	investment_campaigns?: EntireFieldWrapper<
		Maybe<Array<InvestmentCampaignProjectType>>
	>
	/** Projects where the user holds solar shares in. */
	investment_projects?: EntireFieldWrapper<Maybe<ProjectListType>>
	/** Investment tests that this user has taken */
	investment_tests?: EntireFieldWrapper<Maybe<Array<InvestmentTestType>>>
	investor?: EntireFieldWrapper<Maybe<InvestorType>>
	investor_production_stats?: EntireFieldWrapper<
		Maybe<InvestorProductionStatsType>
	>
	investor_shares_value_stats?: EntireFieldWrapper<
		Maybe<InvestorSharesValueStatsType>
	>
	/** Designates whether this user should be treated as active. Unselect this instead of deleting accounts. */
	is_active: EntireFieldWrapper<Scalars["Boolean"]["output"]>
	is_kyc_verified?: EntireFieldWrapper<Maybe<Scalars["Boolean"]["output"]>>
	kyc?: EntireFieldWrapper<Maybe<KycType>>
	last_login?: EntireFieldWrapper<Maybe<Scalars["DateTime"]["output"]>>
	last_name?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	mangopay?: EntireFieldWrapper<Maybe<MangopayScaType>>
	/** Mangopay SCA enrollment and proxy consent status. */
	mangopay_sca?: EntireFieldWrapper<Maybe<MangopayScaType>>
	/** Mangopay user remote information. */
	mangopay_user_remote?: EntireFieldWrapper<Maybe<MangopayUserRemoteType>>
	/** List of unredeemed conversion vouchers that the user has received from successful referrals. */
	member_get_member_conversions?: EntireFieldWrapper<
		Maybe<Array<Maybe<VoucherObjectType>>>
	>
	/** The referral voucher code for this user, if any. */
	member_get_member_voucher?: EntireFieldWrapper<Maybe<VoucherObjectType>>
	messages?: EntireFieldWrapper<Maybe<MessagesType>>
	modified_at: EntireFieldWrapper<Scalars["DateTime"]["output"]>
	name?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** The user who is a member of the organisation. */
	organisation_memberships: EntireFieldWrapper<
		Array<OrganisationMembershipType>
	>
	organisations?: EntireFieldWrapper<Maybe<Array<Maybe<OrganisationType>>>>
	/** Interest Payments paid out to a investor */
	payment_entries?: EntireFieldWrapper<Maybe<PaymentEntriesListType>>
	profile?: EntireFieldWrapper<Maybe<UserProfileType>>
	project_owner_group?: EntireFieldWrapper<
		Maybe<Array<Maybe<OrganisationType>>>
	>
	/** Provisional investments of the user. */
	provisional_investments?: EntireFieldWrapper<Maybe<InvestmentListType>>
	roles?: EntireFieldWrapper<Maybe<Array<Maybe<Role>>>>
	roles_old?: EntireFieldWrapper<Maybe<UserRoles>>
	/** Required. 150 characters or fewer. Letters, digits and @/./+/-/_ only. */
	username: EntireFieldWrapper<Scalars["String"]["output"]>
	uuid?: EntireFieldWrapper<Maybe<Scalars["UUID"]["output"]>>
	uuid_short?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
}

export type UserTypeFinance_ProjectsArgs = {
	id?: InputMaybe<Scalars["ID"]["input"]>
	name__icontains?: InputMaybe<Scalars["String"]["input"]>
	state?: InputMaybe<Scalars["String"]["input"]>
	supplier__name__icontains?: InputMaybe<Scalars["String"]["input"]>
	type?: InputMaybe<Scalars["String"]["input"]>
}

export type UserTypeInterest_PaymentsArgs = {
	id?: InputMaybe<Scalars["ID"]["input"]>
	interestperiod__project?: InputMaybe<Scalars["ID"]["input"]>
	interestperiod__project__name__icontains?: InputMaybe<
		Scalars["String"]["input"]
	>
	limit?: InputMaybe<Scalars["Int"]["input"]>
	offset?: InputMaybe<Scalars["Int"]["input"]>
	ordering?: InputMaybe<Scalars["String"]["input"]>
	q?: InputMaybe<Scalars["String"]["input"]>
	state?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
}

export type UserTypeInvestment_CampaignsArgs = {
	id?: InputMaybe<Scalars["ID"]["input"]>
	limit?: InputMaybe<Scalars["Int"]["input"]>
	offset?: InputMaybe<Scalars["Int"]["input"]>
	ordering?: InputMaybe<Scalars["String"]["input"]>
	owner?: InputMaybe<Scalars["ID"]["input"]>
	partners?: InputMaybe<Scalars["ID"]["input"]>
	project?: InputMaybe<Scalars["ID"]["input"]>
	title__icontains?: InputMaybe<Scalars["String"]["input"]>
}

export type UserTypeInvestment_ProjectsArgs = {
	id?: InputMaybe<Scalars["ID"]["input"]>
	name__icontains?: InputMaybe<Scalars["String"]["input"]>
	state?: InputMaybe<Scalars["String"]["input"]>
	supplier__name__icontains?: InputMaybe<Scalars["String"]["input"]>
	type?: InputMaybe<Scalars["String"]["input"]>
}

export type UserTypeInvestment_TestsArgs = {
	category?: InputMaybe<CoreInvestmentTestCategoryChoices>
	experience?: InputMaybe<CoreInvestmentTestExperienceChoices>
	expiry_date?: InputMaybe<Scalars["Date"]["input"]>
	id?: InputMaybe<Scalars["ID"]["input"]>
	investor?: InputMaybe<Scalars["ID"]["input"]>
	limit?: InputMaybe<Scalars["Int"]["input"]>
	offset?: InputMaybe<Scalars["Int"]["input"]>
	ordering?: InputMaybe<Scalars["String"]["input"]>
	select?: InputMaybe<Scalars["ID"]["input"]>
}

export type UserTypeInvestor_Production_StatsArgs = {
	end?: InputMaybe<Scalars["DateTime"]["input"]>
	project_ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>
	start?: InputMaybe<Scalars["DateTime"]["input"]>
}

export type UserTypeInvestor_Shares_Value_StatsArgs = {
	project_ids?: InputMaybe<Array<InputMaybe<Scalars["ID"]["input"]>>>
	valuation_date?: InputMaybe<Scalars["Date"]["input"]>
}

export type UserTypePayment_EntriesArgs = {
	end?: InputMaybe<Scalars["Date"]["input"]>
	id?: InputMaybe<Scalars["ID"]["input"]>
	name?: InputMaybe<Scalars["String"]["input"]>
	partner_supplier_only?: InputMaybe<Scalars["Boolean"]["input"]>
	start?: InputMaybe<Scalars["Date"]["input"]>
	state?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>
	transaction_id?: InputMaybe<Scalars["String"]["input"]>
}

export type UserTypeProvisional_InvestmentsArgs = {
	id?: InputMaybe<Scalars["ID"]["input"]>
	state?: InputMaybe<Scalars["String"]["input"]>
}

/** An enumeration. */
export const UsersUserMangopayRecipientStatusChoices = {
	/** Active */
	Active: "ACTIVE",
	/** Canceled */
	Canceled: "CANCELED",
	/** Deactivated */
	Deactivated: "DEACTIVATED",
	/** Pending */
	Pending: "PENDING",
} as const

export type UsersUserMangopayRecipientStatusChoices =
	(typeof UsersUserMangopayRecipientStatusChoices)[keyof typeof UsersUserMangopayRecipientStatusChoices]
/** An enumeration. */
export const UsersUserProfileCountryOfBirthChoices = {
	/** Andorra */
	Ad: "AD",
	/** United Arab Emirates */
	Ae: "AE",
	/** Afghanistan */
	Af: "AF",
	/** Antigua and Barbuda */
	Ag: "AG",
	/** Anguilla */
	Ai: "AI",
	/** Albania */
	Al: "AL",
	/** Armenia */
	Am: "AM",
	/** Angola */
	Ao: "AO",
	/** Antarctica */
	Aq: "AQ",
	/** Argentina */
	Ar: "AR",
	/** American Samoa */
	As: "AS",
	/** Austria */
	At: "AT",
	/** Australia */
	Au: "AU",
	/** Aruba */
	Aw: "AW",
	/** Åland Islands */
	Ax: "AX",
	/** Azerbaijan */
	Az: "AZ",
	/** Bosnia and Herzegovina */
	Ba: "BA",
	/** Barbados */
	Bb: "BB",
	/** Bangladesh */
	Bd: "BD",
	/** Belgium */
	Be: "BE",
	/** Burkina Faso */
	Bf: "BF",
	/** Bulgaria */
	Bg: "BG",
	/** Bahrain */
	Bh: "BH",
	/** Burundi */
	Bi: "BI",
	/** Benin */
	Bj: "BJ",
	/** Saint Barthélemy */
	Bl: "BL",
	/** Bermuda */
	Bm: "BM",
	/** Brunei */
	Bn: "BN",
	/** Bolivia */
	Bo: "BO",
	/** Bonaire, Sint Eustatius and Saba */
	Bq: "BQ",
	/** Brazil */
	Br: "BR",
	/** Bahamas (The) */
	Bs: "BS",
	/** Bhutan */
	Bt: "BT",
	/** Bouvet Island */
	Bv: "BV",
	/** Botswana */
	Bw: "BW",
	/** Belarus */
	By: "BY",
	/** Belize */
	Bz: "BZ",
	/** Canada */
	Ca: "CA",
	/** Cocos (Keeling) Islands */
	Cc: "CC",
	/** Democratic Republic of the Congo */
	Cd: "CD",
	/** Central African Republic */
	Cf: "CF",
	/** Congo */
	Cg: "CG",
	/** Switzerland */
	Ch: "CH",
	/** Côte d'Ivoire */
	Ci: "CI",
	/** Cook Islands */
	Ck: "CK",
	/** Chile */
	Cl: "CL",
	/** Cameroon */
	Cm: "CM",
	/** China */
	Cn: "CN",
	/** Colombia */
	Co: "CO",
	/** Costa Rica */
	Cr: "CR",
	/** Cuba */
	Cu: "CU",
	/** Cabo Verde */
	Cv: "CV",
	/** Curaçao */
	Cw: "CW",
	/** Christmas Island */
	Cx: "CX",
	/** Cyprus */
	Cy: "CY",
	/** Czechia */
	Cz: "CZ",
	/** Germany */
	De: "DE",
	/** Djibouti */
	Dj: "DJ",
	/** Denmark */
	Dk: "DK",
	/** Dominica */
	Dm: "DM",
	/** Dominican Republic */
	Do: "DO",
	/** Algeria */
	Dz: "DZ",
	/** Ecuador */
	Ec: "EC",
	/** Estonia */
	Ee: "EE",
	/** Egypt */
	Eg: "EG",
	/** Western Sahara */
	Eh: "EH",
	/** Eritrea */
	Er: "ER",
	/** Spain */
	Es: "ES",
	/** Ethiopia */
	Et: "ET",
	/** Finland */
	Fi: "FI",
	/** Fiji */
	Fj: "FJ",
	/** Falkland Islands (Malvinas) */
	Fk: "FK",
	/** Micronesia */
	Fm: "FM",
	/** Faroe Islands */
	Fo: "FO",
	/** France */
	Fr: "FR",
	/** Gabon */
	Ga: "GA",
	/** United Kingdom */
	Gb: "GB",
	/** Grenada */
	Gd: "GD",
	/** Georgia */
	Ge: "GE",
	/** French Guiana */
	Gf: "GF",
	/** Guernsey */
	Gg: "GG",
	/** Ghana */
	Gh: "GH",
	/** Gibraltar */
	Gi: "GI",
	/** Greenland */
	Gl: "GL",
	/** Gambia */
	Gm: "GM",
	/** Guinea */
	Gn: "GN",
	/** Guadeloupe */
	Gp: "GP",
	/** Equatorial Guinea */
	Gq: "GQ",
	/** Greece */
	Gr: "GR",
	/** South Georgia */
	Gs: "GS",
	/** Guatemala */
	Gt: "GT",
	/** Guam */
	Gu: "GU",
	/** Guinea-Bissau */
	Gw: "GW",
	/** Guyana */
	Gy: "GY",
	/** Hong Kong */
	Hk: "HK",
	/** Heard Island and McDonald Islands */
	Hm: "HM",
	/** Honduras */
	Hn: "HN",
	/** Croatia */
	Hr: "HR",
	/** Haiti */
	Ht: "HT",
	/** Hungary */
	Hu: "HU",
	/** Indonesia */
	Id: "ID",
	/** Ireland */
	Ie: "IE",
	/** Israel */
	Il: "IL",
	/** Isle of Man */
	Im: "IM",
	/** India */
	In: "IN",
	/** British Indian Ocean Territory */
	Io: "IO",
	/** Iraq */
	Iq: "IQ",
	/** Iran */
	Ir: "IR",
	/** Iceland */
	Is: "IS",
	/** Italy */
	It: "IT",
	/** Jersey */
	Je: "JE",
	/** Jamaica */
	Jm: "JM",
	/** Jordan */
	Jo: "JO",
	/** Japan */
	Jp: "JP",
	/** Kenya */
	Ke: "KE",
	/** Kyrgyzstan */
	Kg: "KG",
	/** Cambodia */
	Kh: "KH",
	/** Kiribati */
	Ki: "KI",
	/** Comoros */
	Km: "KM",
	/** Saint Kitts and Nevis */
	Kn: "KN",
	/** North Korea */
	Kp: "KP",
	/** South Korea */
	Kr: "KR",
	/** Kuwait */
	Kw: "KW",
	/** Cayman Islands */
	Ky: "KY",
	/** Kazakhstan */
	Kz: "KZ",
	/** Laos */
	La: "LA",
	/** Lebanon */
	Lb: "LB",
	/** Saint Lucia */
	Lc: "LC",
	/** Liechtenstein */
	Li: "LI",
	/** Sri Lanka */
	Lk: "LK",
	/** Liberia */
	Lr: "LR",
	/** Lesotho */
	Ls: "LS",
	/** Lithuania */
	Lt: "LT",
	/** Luxembourg */
	Lu: "LU",
	/** Latvia */
	Lv: "LV",
	/** Libya */
	Ly: "LY",
	/** Morocco */
	Ma: "MA",
	/** Monaco */
	Mc: "MC",
	/** Moldova */
	Md: "MD",
	/** Montenegro */
	Me: "ME",
	/** Saint Martin (French part) */
	Mf: "MF",
	/** Madagascar */
	Mg: "MG",
	/** Marshall Islands */
	Mh: "MH",
	/** North Macedonia */
	Mk: "MK",
	/** Mali */
	Ml: "ML",
	/** Myanmar */
	Mm: "MM",
	/** Mongolia */
	Mn: "MN",
	/** Macao */
	Mo: "MO",
	/** Northern Mariana Islands */
	Mp: "MP",
	/** Martinique */
	Mq: "MQ",
	/** Mauritania */
	Mr: "MR",
	/** Montserrat */
	Ms: "MS",
	/** Malta */
	Mt: "MT",
	/** Mauritius */
	Mu: "MU",
	/** Maldives */
	Mv: "MV",
	/** Malawi */
	Mw: "MW",
	/** Mexico */
	Mx: "MX",
	/** Malaysia */
	My: "MY",
	/** Mozambique */
	Mz: "MZ",
	/** Namibia */
	Na: "NA",
	/** New Caledonia */
	Nc: "NC",
	/** Niger */
	Ne: "NE",
	/** Norfolk Island */
	Nf: "NF",
	/** Nigeria */
	Ng: "NG",
	/** Nicaragua */
	Ni: "NI",
	/** Netherlands */
	Nl: "NL",
	/** Norway */
	No: "NO",
	/** Nepal */
	Np: "NP",
	/** Nauru */
	Nr: "NR",
	/** Niue */
	Nu: "NU",
	/** New Zealand */
	Nz: "NZ",
	/** Oman */
	Om: "OM",
	/** Panama */
	Pa: "PA",
	/** Peru */
	Pe: "PE",
	/** French Polynesia */
	Pf: "PF",
	/** Papua New Guinea */
	Pg: "PG",
	/** Philippines */
	Ph: "PH",
	/** Pakistan */
	Pk: "PK",
	/** Poland */
	Pl: "PL",
	/** Saint Pierre and Miquelon */
	Pm: "PM",
	/** Pitcairn */
	Pn: "PN",
	/** Puerto Rico */
	Pr: "PR",
	/** Palestine */
	Ps: "PS",
	/** Portugal */
	Pt: "PT",
	/** Palau */
	Pw: "PW",
	/** Paraguay */
	Py: "PY",
	/** Qatar */
	Qa: "QA",
	/** Réunion */
	Re: "RE",
	/** Romania */
	Ro: "RO",
	/** Serbia */
	Rs: "RS",
	/** Russia */
	Ru: "RU",
	/** Rwanda */
	Rw: "RW",
	/** Saudi Arabia */
	Sa: "SA",
	/** Solomon Islands */
	Sb: "SB",
	/** Seychelles */
	Sc: "SC",
	/** Sudan */
	Sd: "SD",
	/** Sweden */
	Se: "SE",
	/** Singapore */
	Sg: "SG",
	/** Saint Helena */
	Sh: "SH",
	/** Slovenia */
	Si: "SI",
	/** Svalbard and Jan Mayen */
	Sj: "SJ",
	/** Slovakia */
	Sk: "SK",
	/** Sierra Leone */
	Sl: "SL",
	/** San Marino */
	Sm: "SM",
	/** Senegal */
	Sn: "SN",
	/** Somalia */
	So: "SO",
	/** Suriname */
	Sr: "SR",
	/** South Sudan */
	Ss: "SS",
	/** Sao Tome and Principe */
	St: "ST",
	/** El Salvador */
	Sv: "SV",
	/** Sint Maarten (Dutch part) */
	Sx: "SX",
	/** Syria */
	Sy: "SY",
	/** Eswatini */
	Sz: "SZ",
	/** Turks and Caicos Islands */
	Tc: "TC",
	/** Chad */
	Td: "TD",
	/** French Southern Territories */
	Tf: "TF",
	/** Togo */
	Tg: "TG",
	/** Thailand */
	Th: "TH",
	/** Tajikistan */
	Tj: "TJ",
	/** Tokelau */
	Tk: "TK",
	/** Timor-Leste */
	Tl: "TL",
	/** Turkmenistan */
	Tm: "TM",
	/** Tunisia */
	Tn: "TN",
	/** Tonga */
	To: "TO",
	/** Türkiye */
	Tr: "TR",
	/** Trinidad and Tobago */
	Tt: "TT",
	/** Tuvalu */
	Tv: "TV",
	/** Taiwan */
	Tw: "TW",
	/** Tanzania */
	Tz: "TZ",
	/** Ukraine */
	Ua: "UA",
	/** Uganda */
	Ug: "UG",
	/** United States Minor Outlying Islands */
	Um: "UM",
	/** United States of America */
	Us: "US",
	/** Uruguay */
	Uy: "UY",
	/** Uzbekistan */
	Uz: "UZ",
	/** Vatican City */
	Va: "VA",
	/** Saint Vincent and the Grenadines */
	Vc: "VC",
	/** Venezuela */
	Ve: "VE",
	/** Virgin Islands (British) */
	Vg: "VG",
	/** Virgin Islands (U.S.) */
	Vi: "VI",
	/** Vietnam */
	Vn: "VN",
	/** Vanuatu */
	Vu: "VU",
	/** Wallis and Futuna */
	Wf: "WF",
	/** Samoa */
	Ws: "WS",
	/** Yemen */
	Ye: "YE",
	/** Mayotte */
	Yt: "YT",
	/** South Africa */
	Za: "ZA",
	/** Zambia */
	Zm: "ZM",
	/** Zimbabwe */
	Zw: "ZW",
} as const

export type UsersUserProfileCountryOfBirthChoices =
	(typeof UsersUserProfileCountryOfBirthChoices)[keyof typeof UsersUserProfileCountryOfBirthChoices]
/** An enumeration. */
export const UsersUserProfileCountryOfResidenceChoices = {
	/** Andorra */
	Ad: "AD",
	/** United Arab Emirates */
	Ae: "AE",
	/** Afghanistan */
	Af: "AF",
	/** Antigua and Barbuda */
	Ag: "AG",
	/** Anguilla */
	Ai: "AI",
	/** Albania */
	Al: "AL",
	/** Armenia */
	Am: "AM",
	/** Angola */
	Ao: "AO",
	/** Antarctica */
	Aq: "AQ",
	/** Argentina */
	Ar: "AR",
	/** American Samoa */
	As: "AS",
	/** Austria */
	At: "AT",
	/** Australia */
	Au: "AU",
	/** Aruba */
	Aw: "AW",
	/** Åland Islands */
	Ax: "AX",
	/** Azerbaijan */
	Az: "AZ",
	/** Bosnia and Herzegovina */
	Ba: "BA",
	/** Barbados */
	Bb: "BB",
	/** Bangladesh */
	Bd: "BD",
	/** Belgium */
	Be: "BE",
	/** Burkina Faso */
	Bf: "BF",
	/** Bulgaria */
	Bg: "BG",
	/** Bahrain */
	Bh: "BH",
	/** Burundi */
	Bi: "BI",
	/** Benin */
	Bj: "BJ",
	/** Saint Barthélemy */
	Bl: "BL",
	/** Bermuda */
	Bm: "BM",
	/** Brunei */
	Bn: "BN",
	/** Bolivia */
	Bo: "BO",
	/** Bonaire, Sint Eustatius and Saba */
	Bq: "BQ",
	/** Brazil */
	Br: "BR",
	/** Bahamas (The) */
	Bs: "BS",
	/** Bhutan */
	Bt: "BT",
	/** Bouvet Island */
	Bv: "BV",
	/** Botswana */
	Bw: "BW",
	/** Belarus */
	By: "BY",
	/** Belize */
	Bz: "BZ",
	/** Canada */
	Ca: "CA",
	/** Cocos (Keeling) Islands */
	Cc: "CC",
	/** Democratic Republic of the Congo */
	Cd: "CD",
	/** Central African Republic */
	Cf: "CF",
	/** Congo */
	Cg: "CG",
	/** Switzerland */
	Ch: "CH",
	/** Côte d'Ivoire */
	Ci: "CI",
	/** Cook Islands */
	Ck: "CK",
	/** Chile */
	Cl: "CL",
	/** Cameroon */
	Cm: "CM",
	/** China */
	Cn: "CN",
	/** Colombia */
	Co: "CO",
	/** Costa Rica */
	Cr: "CR",
	/** Cuba */
	Cu: "CU",
	/** Cabo Verde */
	Cv: "CV",
	/** Curaçao */
	Cw: "CW",
	/** Christmas Island */
	Cx: "CX",
	/** Cyprus */
	Cy: "CY",
	/** Czechia */
	Cz: "CZ",
	/** Germany */
	De: "DE",
	/** Djibouti */
	Dj: "DJ",
	/** Denmark */
	Dk: "DK",
	/** Dominica */
	Dm: "DM",
	/** Dominican Republic */
	Do: "DO",
	/** Algeria */
	Dz: "DZ",
	/** Ecuador */
	Ec: "EC",
	/** Estonia */
	Ee: "EE",
	/** Egypt */
	Eg: "EG",
	/** Western Sahara */
	Eh: "EH",
	/** Eritrea */
	Er: "ER",
	/** Spain */
	Es: "ES",
	/** Ethiopia */
	Et: "ET",
	/** Finland */
	Fi: "FI",
	/** Fiji */
	Fj: "FJ",
	/** Falkland Islands (Malvinas) */
	Fk: "FK",
	/** Micronesia */
	Fm: "FM",
	/** Faroe Islands */
	Fo: "FO",
	/** France */
	Fr: "FR",
	/** Gabon */
	Ga: "GA",
	/** United Kingdom */
	Gb: "GB",
	/** Grenada */
	Gd: "GD",
	/** Georgia */
	Ge: "GE",
	/** French Guiana */
	Gf: "GF",
	/** Guernsey */
	Gg: "GG",
	/** Ghana */
	Gh: "GH",
	/** Gibraltar */
	Gi: "GI",
	/** Greenland */
	Gl: "GL",
	/** Gambia */
	Gm: "GM",
	/** Guinea */
	Gn: "GN",
	/** Guadeloupe */
	Gp: "GP",
	/** Equatorial Guinea */
	Gq: "GQ",
	/** Greece */
	Gr: "GR",
	/** South Georgia */
	Gs: "GS",
	/** Guatemala */
	Gt: "GT",
	/** Guam */
	Gu: "GU",
	/** Guinea-Bissau */
	Gw: "GW",
	/** Guyana */
	Gy: "GY",
	/** Hong Kong */
	Hk: "HK",
	/** Heard Island and McDonald Islands */
	Hm: "HM",
	/** Honduras */
	Hn: "HN",
	/** Croatia */
	Hr: "HR",
	/** Haiti */
	Ht: "HT",
	/** Hungary */
	Hu: "HU",
	/** Indonesia */
	Id: "ID",
	/** Ireland */
	Ie: "IE",
	/** Israel */
	Il: "IL",
	/** Isle of Man */
	Im: "IM",
	/** India */
	In: "IN",
	/** British Indian Ocean Territory */
	Io: "IO",
	/** Iraq */
	Iq: "IQ",
	/** Iran */
	Ir: "IR",
	/** Iceland */
	Is: "IS",
	/** Italy */
	It: "IT",
	/** Jersey */
	Je: "JE",
	/** Jamaica */
	Jm: "JM",
	/** Jordan */
	Jo: "JO",
	/** Japan */
	Jp: "JP",
	/** Kenya */
	Ke: "KE",
	/** Kyrgyzstan */
	Kg: "KG",
	/** Cambodia */
	Kh: "KH",
	/** Kiribati */
	Ki: "KI",
	/** Comoros */
	Km: "KM",
	/** Saint Kitts and Nevis */
	Kn: "KN",
	/** North Korea */
	Kp: "KP",
	/** South Korea */
	Kr: "KR",
	/** Kuwait */
	Kw: "KW",
	/** Cayman Islands */
	Ky: "KY",
	/** Kazakhstan */
	Kz: "KZ",
	/** Laos */
	La: "LA",
	/** Lebanon */
	Lb: "LB",
	/** Saint Lucia */
	Lc: "LC",
	/** Liechtenstein */
	Li: "LI",
	/** Sri Lanka */
	Lk: "LK",
	/** Liberia */
	Lr: "LR",
	/** Lesotho */
	Ls: "LS",
	/** Lithuania */
	Lt: "LT",
	/** Luxembourg */
	Lu: "LU",
	/** Latvia */
	Lv: "LV",
	/** Libya */
	Ly: "LY",
	/** Morocco */
	Ma: "MA",
	/** Monaco */
	Mc: "MC",
	/** Moldova */
	Md: "MD",
	/** Montenegro */
	Me: "ME",
	/** Saint Martin (French part) */
	Mf: "MF",
	/** Madagascar */
	Mg: "MG",
	/** Marshall Islands */
	Mh: "MH",
	/** North Macedonia */
	Mk: "MK",
	/** Mali */
	Ml: "ML",
	/** Myanmar */
	Mm: "MM",
	/** Mongolia */
	Mn: "MN",
	/** Macao */
	Mo: "MO",
	/** Northern Mariana Islands */
	Mp: "MP",
	/** Martinique */
	Mq: "MQ",
	/** Mauritania */
	Mr: "MR",
	/** Montserrat */
	Ms: "MS",
	/** Malta */
	Mt: "MT",
	/** Mauritius */
	Mu: "MU",
	/** Maldives */
	Mv: "MV",
	/** Malawi */
	Mw: "MW",
	/** Mexico */
	Mx: "MX",
	/** Malaysia */
	My: "MY",
	/** Mozambique */
	Mz: "MZ",
	/** Namibia */
	Na: "NA",
	/** New Caledonia */
	Nc: "NC",
	/** Niger */
	Ne: "NE",
	/** Norfolk Island */
	Nf: "NF",
	/** Nigeria */
	Ng: "NG",
	/** Nicaragua */
	Ni: "NI",
	/** Netherlands */
	Nl: "NL",
	/** Norway */
	No: "NO",
	/** Nepal */
	Np: "NP",
	/** Nauru */
	Nr: "NR",
	/** Niue */
	Nu: "NU",
	/** New Zealand */
	Nz: "NZ",
	/** Oman */
	Om: "OM",
	/** Panama */
	Pa: "PA",
	/** Peru */
	Pe: "PE",
	/** French Polynesia */
	Pf: "PF",
	/** Papua New Guinea */
	Pg: "PG",
	/** Philippines */
	Ph: "PH",
	/** Pakistan */
	Pk: "PK",
	/** Poland */
	Pl: "PL",
	/** Saint Pierre and Miquelon */
	Pm: "PM",
	/** Pitcairn */
	Pn: "PN",
	/** Puerto Rico */
	Pr: "PR",
	/** Palestine */
	Ps: "PS",
	/** Portugal */
	Pt: "PT",
	/** Palau */
	Pw: "PW",
	/** Paraguay */
	Py: "PY",
	/** Qatar */
	Qa: "QA",
	/** Réunion */
	Re: "RE",
	/** Romania */
	Ro: "RO",
	/** Serbia */
	Rs: "RS",
	/** Russia */
	Ru: "RU",
	/** Rwanda */
	Rw: "RW",
	/** Saudi Arabia */
	Sa: "SA",
	/** Solomon Islands */
	Sb: "SB",
	/** Seychelles */
	Sc: "SC",
	/** Sudan */
	Sd: "SD",
	/** Sweden */
	Se: "SE",
	/** Singapore */
	Sg: "SG",
	/** Saint Helena */
	Sh: "SH",
	/** Slovenia */
	Si: "SI",
	/** Svalbard and Jan Mayen */
	Sj: "SJ",
	/** Slovakia */
	Sk: "SK",
	/** Sierra Leone */
	Sl: "SL",
	/** San Marino */
	Sm: "SM",
	/** Senegal */
	Sn: "SN",
	/** Somalia */
	So: "SO",
	/** Suriname */
	Sr: "SR",
	/** South Sudan */
	Ss: "SS",
	/** Sao Tome and Principe */
	St: "ST",
	/** El Salvador */
	Sv: "SV",
	/** Sint Maarten (Dutch part) */
	Sx: "SX",
	/** Syria */
	Sy: "SY",
	/** Eswatini */
	Sz: "SZ",
	/** Turks and Caicos Islands */
	Tc: "TC",
	/** Chad */
	Td: "TD",
	/** French Southern Territories */
	Tf: "TF",
	/** Togo */
	Tg: "TG",
	/** Thailand */
	Th: "TH",
	/** Tajikistan */
	Tj: "TJ",
	/** Tokelau */
	Tk: "TK",
	/** Timor-Leste */
	Tl: "TL",
	/** Turkmenistan */
	Tm: "TM",
	/** Tunisia */
	Tn: "TN",
	/** Tonga */
	To: "TO",
	/** Türkiye */
	Tr: "TR",
	/** Trinidad and Tobago */
	Tt: "TT",
	/** Tuvalu */
	Tv: "TV",
	/** Taiwan */
	Tw: "TW",
	/** Tanzania */
	Tz: "TZ",
	/** Ukraine */
	Ua: "UA",
	/** Uganda */
	Ug: "UG",
	/** United States Minor Outlying Islands */
	Um: "UM",
	/** United States of America */
	Us: "US",
	/** Uruguay */
	Uy: "UY",
	/** Uzbekistan */
	Uz: "UZ",
	/** Vatican City */
	Va: "VA",
	/** Saint Vincent and the Grenadines */
	Vc: "VC",
	/** Venezuela */
	Ve: "VE",
	/** Virgin Islands (British) */
	Vg: "VG",
	/** Virgin Islands (U.S.) */
	Vi: "VI",
	/** Vietnam */
	Vn: "VN",
	/** Vanuatu */
	Vu: "VU",
	/** Wallis and Futuna */
	Wf: "WF",
	/** Samoa */
	Ws: "WS",
	/** Yemen */
	Ye: "YE",
	/** Mayotte */
	Yt: "YT",
	/** South Africa */
	Za: "ZA",
	/** Zambia */
	Zm: "ZM",
	/** Zimbabwe */
	Zw: "ZW",
} as const

export type UsersUserProfileCountryOfResidenceChoices =
	(typeof UsersUserProfileCountryOfResidenceChoices)[keyof typeof UsersUserProfileCountryOfResidenceChoices]
/** An enumeration. */
export const UsersUserProfileGenderChoices = {
	/** Female */
	Female: "FEMALE",
	/** Male */
	Male: "MALE",
	/** Not Specified */
	NotSpecified: "NOT_SPECIFIED",
	/** Other */
	Other: "OTHER",
} as const

export type UsersUserProfileGenderChoices =
	(typeof UsersUserProfileGenderChoices)[keyof typeof UsersUserProfileGenderChoices]
/** An enumeration. */
export const UsersUserProfileIdentityTypeChoices = {
	/** Business */
	Business: "BUSINESS",
	/** Private */
	Private: "PRIVATE",
	/** Unavailable */
	Unavailable: "UNAVAILABLE",
} as const

export type UsersUserProfileIdentityTypeChoices =
	(typeof UsersUserProfileIdentityTypeChoices)[keyof typeof UsersUserProfileIdentityTypeChoices]
/** An enumeration. */
export const UsersUserProfileLanguageChoices = {
	/** English */
	En: "EN",
	/** French */
	Fr: "FR",
	/** Dutch */
	Nl: "NL",
} as const

export type UsersUserProfileLanguageChoices =
	(typeof UsersUserProfileLanguageChoices)[keyof typeof UsersUserProfileLanguageChoices]
/** An enumeration. */
export const UsersUserProfileNationalityChoices = {
	/** Andorra */
	Ad: "AD",
	/** United Arab Emirates */
	Ae: "AE",
	/** Afghanistan */
	Af: "AF",
	/** Antigua and Barbuda */
	Ag: "AG",
	/** Anguilla */
	Ai: "AI",
	/** Albania */
	Al: "AL",
	/** Armenia */
	Am: "AM",
	/** Angola */
	Ao: "AO",
	/** Antarctica */
	Aq: "AQ",
	/** Argentina */
	Ar: "AR",
	/** American Samoa */
	As: "AS",
	/** Austria */
	At: "AT",
	/** Australia */
	Au: "AU",
	/** Aruba */
	Aw: "AW",
	/** Åland Islands */
	Ax: "AX",
	/** Azerbaijan */
	Az: "AZ",
	/** Bosnia and Herzegovina */
	Ba: "BA",
	/** Barbados */
	Bb: "BB",
	/** Bangladesh */
	Bd: "BD",
	/** Belgium */
	Be: "BE",
	/** Burkina Faso */
	Bf: "BF",
	/** Bulgaria */
	Bg: "BG",
	/** Bahrain */
	Bh: "BH",
	/** Burundi */
	Bi: "BI",
	/** Benin */
	Bj: "BJ",
	/** Saint Barthélemy */
	Bl: "BL",
	/** Bermuda */
	Bm: "BM",
	/** Brunei */
	Bn: "BN",
	/** Bolivia */
	Bo: "BO",
	/** Bonaire, Sint Eustatius and Saba */
	Bq: "BQ",
	/** Brazil */
	Br: "BR",
	/** Bahamas (The) */
	Bs: "BS",
	/** Bhutan */
	Bt: "BT",
	/** Bouvet Island */
	Bv: "BV",
	/** Botswana */
	Bw: "BW",
	/** Belarus */
	By: "BY",
	/** Belize */
	Bz: "BZ",
	/** Canada */
	Ca: "CA",
	/** Cocos (Keeling) Islands */
	Cc: "CC",
	/** Democratic Republic of the Congo */
	Cd: "CD",
	/** Central African Republic */
	Cf: "CF",
	/** Congo */
	Cg: "CG",
	/** Switzerland */
	Ch: "CH",
	/** Côte d'Ivoire */
	Ci: "CI",
	/** Cook Islands */
	Ck: "CK",
	/** Chile */
	Cl: "CL",
	/** Cameroon */
	Cm: "CM",
	/** China */
	Cn: "CN",
	/** Colombia */
	Co: "CO",
	/** Costa Rica */
	Cr: "CR",
	/** Cuba */
	Cu: "CU",
	/** Cabo Verde */
	Cv: "CV",
	/** Curaçao */
	Cw: "CW",
	/** Christmas Island */
	Cx: "CX",
	/** Cyprus */
	Cy: "CY",
	/** Czechia */
	Cz: "CZ",
	/** Germany */
	De: "DE",
	/** Djibouti */
	Dj: "DJ",
	/** Denmark */
	Dk: "DK",
	/** Dominica */
	Dm: "DM",
	/** Dominican Republic */
	Do: "DO",
	/** Algeria */
	Dz: "DZ",
	/** Ecuador */
	Ec: "EC",
	/** Estonia */
	Ee: "EE",
	/** Egypt */
	Eg: "EG",
	/** Western Sahara */
	Eh: "EH",
	/** Eritrea */
	Er: "ER",
	/** Spain */
	Es: "ES",
	/** Ethiopia */
	Et: "ET",
	/** Finland */
	Fi: "FI",
	/** Fiji */
	Fj: "FJ",
	/** Falkland Islands (Malvinas) */
	Fk: "FK",
	/** Micronesia */
	Fm: "FM",
	/** Faroe Islands */
	Fo: "FO",
	/** France */
	Fr: "FR",
	/** Gabon */
	Ga: "GA",
	/** United Kingdom */
	Gb: "GB",
	/** Grenada */
	Gd: "GD",
	/** Georgia */
	Ge: "GE",
	/** French Guiana */
	Gf: "GF",
	/** Guernsey */
	Gg: "GG",
	/** Ghana */
	Gh: "GH",
	/** Gibraltar */
	Gi: "GI",
	/** Greenland */
	Gl: "GL",
	/** Gambia */
	Gm: "GM",
	/** Guinea */
	Gn: "GN",
	/** Guadeloupe */
	Gp: "GP",
	/** Equatorial Guinea */
	Gq: "GQ",
	/** Greece */
	Gr: "GR",
	/** South Georgia */
	Gs: "GS",
	/** Guatemala */
	Gt: "GT",
	/** Guam */
	Gu: "GU",
	/** Guinea-Bissau */
	Gw: "GW",
	/** Guyana */
	Gy: "GY",
	/** Hong Kong */
	Hk: "HK",
	/** Heard Island and McDonald Islands */
	Hm: "HM",
	/** Honduras */
	Hn: "HN",
	/** Croatia */
	Hr: "HR",
	/** Haiti */
	Ht: "HT",
	/** Hungary */
	Hu: "HU",
	/** Indonesia */
	Id: "ID",
	/** Ireland */
	Ie: "IE",
	/** Israel */
	Il: "IL",
	/** Isle of Man */
	Im: "IM",
	/** India */
	In: "IN",
	/** British Indian Ocean Territory */
	Io: "IO",
	/** Iraq */
	Iq: "IQ",
	/** Iran */
	Ir: "IR",
	/** Iceland */
	Is: "IS",
	/** Italy */
	It: "IT",
	/** Jersey */
	Je: "JE",
	/** Jamaica */
	Jm: "JM",
	/** Jordan */
	Jo: "JO",
	/** Japan */
	Jp: "JP",
	/** Kenya */
	Ke: "KE",
	/** Kyrgyzstan */
	Kg: "KG",
	/** Cambodia */
	Kh: "KH",
	/** Kiribati */
	Ki: "KI",
	/** Comoros */
	Km: "KM",
	/** Saint Kitts and Nevis */
	Kn: "KN",
	/** North Korea */
	Kp: "KP",
	/** South Korea */
	Kr: "KR",
	/** Kuwait */
	Kw: "KW",
	/** Cayman Islands */
	Ky: "KY",
	/** Kazakhstan */
	Kz: "KZ",
	/** Laos */
	La: "LA",
	/** Lebanon */
	Lb: "LB",
	/** Saint Lucia */
	Lc: "LC",
	/** Liechtenstein */
	Li: "LI",
	/** Sri Lanka */
	Lk: "LK",
	/** Liberia */
	Lr: "LR",
	/** Lesotho */
	Ls: "LS",
	/** Lithuania */
	Lt: "LT",
	/** Luxembourg */
	Lu: "LU",
	/** Latvia */
	Lv: "LV",
	/** Libya */
	Ly: "LY",
	/** Morocco */
	Ma: "MA",
	/** Monaco */
	Mc: "MC",
	/** Moldova */
	Md: "MD",
	/** Montenegro */
	Me: "ME",
	/** Saint Martin (French part) */
	Mf: "MF",
	/** Madagascar */
	Mg: "MG",
	/** Marshall Islands */
	Mh: "MH",
	/** North Macedonia */
	Mk: "MK",
	/** Mali */
	Ml: "ML",
	/** Myanmar */
	Mm: "MM",
	/** Mongolia */
	Mn: "MN",
	/** Macao */
	Mo: "MO",
	/** Northern Mariana Islands */
	Mp: "MP",
	/** Martinique */
	Mq: "MQ",
	/** Mauritania */
	Mr: "MR",
	/** Montserrat */
	Ms: "MS",
	/** Malta */
	Mt: "MT",
	/** Mauritius */
	Mu: "MU",
	/** Maldives */
	Mv: "MV",
	/** Malawi */
	Mw: "MW",
	/** Mexico */
	Mx: "MX",
	/** Malaysia */
	My: "MY",
	/** Mozambique */
	Mz: "MZ",
	/** Namibia */
	Na: "NA",
	/** New Caledonia */
	Nc: "NC",
	/** Niger */
	Ne: "NE",
	/** Norfolk Island */
	Nf: "NF",
	/** Nigeria */
	Ng: "NG",
	/** Nicaragua */
	Ni: "NI",
	/** Netherlands */
	Nl: "NL",
	/** Norway */
	No: "NO",
	/** Nepal */
	Np: "NP",
	/** Nauru */
	Nr: "NR",
	/** Niue */
	Nu: "NU",
	/** New Zealand */
	Nz: "NZ",
	/** Oman */
	Om: "OM",
	/** Panama */
	Pa: "PA",
	/** Peru */
	Pe: "PE",
	/** French Polynesia */
	Pf: "PF",
	/** Papua New Guinea */
	Pg: "PG",
	/** Philippines */
	Ph: "PH",
	/** Pakistan */
	Pk: "PK",
	/** Poland */
	Pl: "PL",
	/** Saint Pierre and Miquelon */
	Pm: "PM",
	/** Pitcairn */
	Pn: "PN",
	/** Puerto Rico */
	Pr: "PR",
	/** Palestine */
	Ps: "PS",
	/** Portugal */
	Pt: "PT",
	/** Palau */
	Pw: "PW",
	/** Paraguay */
	Py: "PY",
	/** Qatar */
	Qa: "QA",
	/** Réunion */
	Re: "RE",
	/** Romania */
	Ro: "RO",
	/** Serbia */
	Rs: "RS",
	/** Russia */
	Ru: "RU",
	/** Rwanda */
	Rw: "RW",
	/** Saudi Arabia */
	Sa: "SA",
	/** Solomon Islands */
	Sb: "SB",
	/** Seychelles */
	Sc: "SC",
	/** Sudan */
	Sd: "SD",
	/** Sweden */
	Se: "SE",
	/** Singapore */
	Sg: "SG",
	/** Saint Helena */
	Sh: "SH",
	/** Slovenia */
	Si: "SI",
	/** Svalbard and Jan Mayen */
	Sj: "SJ",
	/** Slovakia */
	Sk: "SK",
	/** Sierra Leone */
	Sl: "SL",
	/** San Marino */
	Sm: "SM",
	/** Senegal */
	Sn: "SN",
	/** Somalia */
	So: "SO",
	/** Suriname */
	Sr: "SR",
	/** South Sudan */
	Ss: "SS",
	/** Sao Tome and Principe */
	St: "ST",
	/** El Salvador */
	Sv: "SV",
	/** Sint Maarten (Dutch part) */
	Sx: "SX",
	/** Syria */
	Sy: "SY",
	/** Eswatini */
	Sz: "SZ",
	/** Turks and Caicos Islands */
	Tc: "TC",
	/** Chad */
	Td: "TD",
	/** French Southern Territories */
	Tf: "TF",
	/** Togo */
	Tg: "TG",
	/** Thailand */
	Th: "TH",
	/** Tajikistan */
	Tj: "TJ",
	/** Tokelau */
	Tk: "TK",
	/** Timor-Leste */
	Tl: "TL",
	/** Turkmenistan */
	Tm: "TM",
	/** Tunisia */
	Tn: "TN",
	/** Tonga */
	To: "TO",
	/** Türkiye */
	Tr: "TR",
	/** Trinidad and Tobago */
	Tt: "TT",
	/** Tuvalu */
	Tv: "TV",
	/** Taiwan */
	Tw: "TW",
	/** Tanzania */
	Tz: "TZ",
	/** Ukraine */
	Ua: "UA",
	/** Uganda */
	Ug: "UG",
	/** United States Minor Outlying Islands */
	Um: "UM",
	/** United States of America */
	Us: "US",
	/** Uruguay */
	Uy: "UY",
	/** Uzbekistan */
	Uz: "UZ",
	/** Vatican City */
	Va: "VA",
	/** Saint Vincent and the Grenadines */
	Vc: "VC",
	/** Venezuela */
	Ve: "VE",
	/** Virgin Islands (British) */
	Vg: "VG",
	/** Virgin Islands (U.S.) */
	Vi: "VI",
	/** Vietnam */
	Vn: "VN",
	/** Vanuatu */
	Vu: "VU",
	/** Wallis and Futuna */
	Wf: "WF",
	/** Samoa */
	Ws: "WS",
	/** Yemen */
	Ye: "YE",
	/** Mayotte */
	Yt: "YT",
	/** South Africa */
	Za: "ZA",
	/** Zambia */
	Zm: "ZM",
	/** Zimbabwe */
	Zw: "ZW",
} as const

export type UsersUserProfileNationalityChoices =
	(typeof UsersUserProfileNationalityChoices)[keyof typeof UsersUserProfileNationalityChoices]
/** An enumeration. */
export const UsersUserProfileTimezoneChoices = {
	/** Africa/Abidjan */
	AfricaAbidjan: "AFRICA_ABIDJAN",
	/** Africa/Accra */
	AfricaAccra: "AFRICA_ACCRA",
	/** Africa/Addis Ababa */
	AfricaAddisAbaba: "AFRICA_ADDIS_ABABA",
	/** Africa/Algiers */
	AfricaAlgiers: "AFRICA_ALGIERS",
	/** Africa/Asmara */
	AfricaAsmara: "AFRICA_ASMARA",
	/** Africa/Asmera */
	AfricaAsmera: "AFRICA_ASMERA",
	/** Africa/Bamako */
	AfricaBamako: "AFRICA_BAMAKO",
	/** Africa/Bangui */
	AfricaBangui: "AFRICA_BANGUI",
	/** Africa/Banjul */
	AfricaBanjul: "AFRICA_BANJUL",
	/** Africa/Bissau */
	AfricaBissau: "AFRICA_BISSAU",
	/** Africa/Blantyre */
	AfricaBlantyre: "AFRICA_BLANTYRE",
	/** Africa/Brazzaville */
	AfricaBrazzaville: "AFRICA_BRAZZAVILLE",
	/** Africa/Bujumbura */
	AfricaBujumbura: "AFRICA_BUJUMBURA",
	/** Africa/Cairo */
	AfricaCairo: "AFRICA_CAIRO",
	/** Africa/Casablanca */
	AfricaCasablanca: "AFRICA_CASABLANCA",
	/** Africa/Ceuta */
	AfricaCeuta: "AFRICA_CEUTA",
	/** Africa/Conakry */
	AfricaConakry: "AFRICA_CONAKRY",
	/** Africa/Dakar */
	AfricaDakar: "AFRICA_DAKAR",
	/** Africa/Dar es Salaam */
	AfricaDarEsSalaam: "AFRICA_DAR_ES_SALAAM",
	/** Africa/Djibouti */
	AfricaDjibouti: "AFRICA_DJIBOUTI",
	/** Africa/Douala */
	AfricaDouala: "AFRICA_DOUALA",
	/** Africa/El Aaiun */
	AfricaElAaiun: "AFRICA_EL_AAIUN",
	/** Africa/Freetown */
	AfricaFreetown: "AFRICA_FREETOWN",
	/** Africa/Gaborone */
	AfricaGaborone: "AFRICA_GABORONE",
	/** Africa/Harare */
	AfricaHarare: "AFRICA_HARARE",
	/** Africa/Johannesburg */
	AfricaJohannesburg: "AFRICA_JOHANNESBURG",
	/** Africa/Juba */
	AfricaJuba: "AFRICA_JUBA",
	/** Africa/Kampala */
	AfricaKampala: "AFRICA_KAMPALA",
	/** Africa/Khartoum */
	AfricaKhartoum: "AFRICA_KHARTOUM",
	/** Africa/Kigali */
	AfricaKigali: "AFRICA_KIGALI",
	/** Africa/Kinshasa */
	AfricaKinshasa: "AFRICA_KINSHASA",
	/** Africa/Lagos */
	AfricaLagos: "AFRICA_LAGOS",
	/** Africa/Libreville */
	AfricaLibreville: "AFRICA_LIBREVILLE",
	/** Africa/Lome */
	AfricaLome: "AFRICA_LOME",
	/** Africa/Luanda */
	AfricaLuanda: "AFRICA_LUANDA",
	/** Africa/Lubumbashi */
	AfricaLubumbashi: "AFRICA_LUBUMBASHI",
	/** Africa/Lusaka */
	AfricaLusaka: "AFRICA_LUSAKA",
	/** Africa/Malabo */
	AfricaMalabo: "AFRICA_MALABO",
	/** Africa/Maputo */
	AfricaMaputo: "AFRICA_MAPUTO",
	/** Africa/Maseru */
	AfricaMaseru: "AFRICA_MASERU",
	/** Africa/Mbabane */
	AfricaMbabane: "AFRICA_MBABANE",
	/** Africa/Mogadishu */
	AfricaMogadishu: "AFRICA_MOGADISHU",
	/** Africa/Monrovia */
	AfricaMonrovia: "AFRICA_MONROVIA",
	/** Africa/Nairobi */
	AfricaNairobi: "AFRICA_NAIROBI",
	/** Africa/Ndjamena */
	AfricaNdjamena: "AFRICA_NDJAMENA",
	/** Africa/Niamey */
	AfricaNiamey: "AFRICA_NIAMEY",
	/** Africa/Nouakchott */
	AfricaNouakchott: "AFRICA_NOUAKCHOTT",
	/** Africa/Ouagadougou */
	AfricaOuagadougou: "AFRICA_OUAGADOUGOU",
	/** Africa/Porto-Novo */
	AfricaPortoNovo: "AFRICA_PORTO_NOVO",
	/** Africa/Sao Tome */
	AfricaSaoTome: "AFRICA_SAO_TOME",
	/** Africa/Timbuktu */
	AfricaTimbuktu: "AFRICA_TIMBUKTU",
	/** Africa/Tripoli */
	AfricaTripoli: "AFRICA_TRIPOLI",
	/** Africa/Tunis */
	AfricaTunis: "AFRICA_TUNIS",
	/** Africa/Windhoek */
	AfricaWindhoek: "AFRICA_WINDHOEK",
	/** America/Adak */
	AmericaAdak: "AMERICA_ADAK",
	/** America/Anchorage */
	AmericaAnchorage: "AMERICA_ANCHORAGE",
	/** America/Anguilla */
	AmericaAnguilla: "AMERICA_ANGUILLA",
	/** America/Antigua */
	AmericaAntigua: "AMERICA_ANTIGUA",
	/** America/Araguaina */
	AmericaAraguaina: "AMERICA_ARAGUAINA",
	/** America/Argentina/Buenos Aires */
	AmericaArgentinaBuenosAires: "AMERICA_ARGENTINA_BUENOS_AIRES",
	/** America/Argentina/Catamarca */
	AmericaArgentinaCatamarca: "AMERICA_ARGENTINA_CATAMARCA",
	/** America/Argentina/ComodRivadavia */
	AmericaArgentinaComodrivadavia: "AMERICA_ARGENTINA_COMODRIVADAVIA",
	/** America/Argentina/Cordoba */
	AmericaArgentinaCordoba: "AMERICA_ARGENTINA_CORDOBA",
	/** America/Argentina/Jujuy */
	AmericaArgentinaJujuy: "AMERICA_ARGENTINA_JUJUY",
	/** America/Argentina/La Rioja */
	AmericaArgentinaLaRioja: "AMERICA_ARGENTINA_LA_RIOJA",
	/** America/Argentina/Mendoza */
	AmericaArgentinaMendoza: "AMERICA_ARGENTINA_MENDOZA",
	/** America/Argentina/Rio Gallegos */
	AmericaArgentinaRioGallegos: "AMERICA_ARGENTINA_RIO_GALLEGOS",
	/** America/Argentina/Salta */
	AmericaArgentinaSalta: "AMERICA_ARGENTINA_SALTA",
	/** America/Argentina/San Juan */
	AmericaArgentinaSanJuan: "AMERICA_ARGENTINA_SAN_JUAN",
	/** America/Argentina/San Luis */
	AmericaArgentinaSanLuis: "AMERICA_ARGENTINA_SAN_LUIS",
	/** America/Argentina/Tucuman */
	AmericaArgentinaTucuman: "AMERICA_ARGENTINA_TUCUMAN",
	/** America/Argentina/Ushuaia */
	AmericaArgentinaUshuaia: "AMERICA_ARGENTINA_USHUAIA",
	/** America/Aruba */
	AmericaAruba: "AMERICA_ARUBA",
	/** America/Asuncion */
	AmericaAsuncion: "AMERICA_ASUNCION",
	/** America/Atikokan */
	AmericaAtikokan: "AMERICA_ATIKOKAN",
	/** America/Atka */
	AmericaAtka: "AMERICA_ATKA",
	/** America/Bahia */
	AmericaBahia: "AMERICA_BAHIA",
	/** America/Bahia Banderas */
	AmericaBahiaBanderas: "AMERICA_BAHIA_BANDERAS",
	/** America/Barbados */
	AmericaBarbados: "AMERICA_BARBADOS",
	/** America/Belem */
	AmericaBelem: "AMERICA_BELEM",
	/** America/Belize */
	AmericaBelize: "AMERICA_BELIZE",
	/** America/Blanc-Sablon */
	AmericaBlancSablon: "AMERICA_BLANC_SABLON",
	/** America/Boa Vista */
	AmericaBoaVista: "AMERICA_BOA_VISTA",
	/** America/Bogota */
	AmericaBogota: "AMERICA_BOGOTA",
	/** America/Boise */
	AmericaBoise: "AMERICA_BOISE",
	/** America/Buenos Aires */
	AmericaBuenosAires: "AMERICA_BUENOS_AIRES",
	/** America/Cambridge Bay */
	AmericaCambridgeBay: "AMERICA_CAMBRIDGE_BAY",
	/** America/Campo Grande */
	AmericaCampoGrande: "AMERICA_CAMPO_GRANDE",
	/** America/Cancun */
	AmericaCancun: "AMERICA_CANCUN",
	/** America/Caracas */
	AmericaCaracas: "AMERICA_CARACAS",
	/** America/Catamarca */
	AmericaCatamarca: "AMERICA_CATAMARCA",
	/** America/Cayenne */
	AmericaCayenne: "AMERICA_CAYENNE",
	/** America/Cayman */
	AmericaCayman: "AMERICA_CAYMAN",
	/** America/Chicago */
	AmericaChicago: "AMERICA_CHICAGO",
	/** America/Chihuahua */
	AmericaChihuahua: "AMERICA_CHIHUAHUA",
	/** America/Ciudad Juarez */
	AmericaCiudadJuarez: "AMERICA_CIUDAD_JUAREZ",
	/** America/Coral Harbour */
	AmericaCoralHarbour: "AMERICA_CORAL_HARBOUR",
	/** America/Cordoba */
	AmericaCordoba: "AMERICA_CORDOBA",
	/** America/Costa Rica */
	AmericaCostaRica: "AMERICA_COSTA_RICA",
	/** America/Coyhaique */
	AmericaCoyhaique: "AMERICA_COYHAIQUE",
	/** America/Creston */
	AmericaCreston: "AMERICA_CRESTON",
	/** America/Cuiaba */
	AmericaCuiaba: "AMERICA_CUIABA",
	/** America/Curacao */
	AmericaCuracao: "AMERICA_CURACAO",
	/** America/Danmarkshavn */
	AmericaDanmarkshavn: "AMERICA_DANMARKSHAVN",
	/** America/Dawson */
	AmericaDawson: "AMERICA_DAWSON",
	/** America/Dawson Creek */
	AmericaDawsonCreek: "AMERICA_DAWSON_CREEK",
	/** America/Denver */
	AmericaDenver: "AMERICA_DENVER",
	/** America/Detroit */
	AmericaDetroit: "AMERICA_DETROIT",
	/** America/Dominica */
	AmericaDominica: "AMERICA_DOMINICA",
	/** America/Edmonton */
	AmericaEdmonton: "AMERICA_EDMONTON",
	/** America/Eirunepe */
	AmericaEirunepe: "AMERICA_EIRUNEPE",
	/** America/El Salvador */
	AmericaElSalvador: "AMERICA_EL_SALVADOR",
	/** America/Ensenada */
	AmericaEnsenada: "AMERICA_ENSENADA",
	/** America/Fortaleza */
	AmericaFortaleza: "AMERICA_FORTALEZA",
	/** America/Fort Nelson */
	AmericaFortNelson: "AMERICA_FORT_NELSON",
	/** America/Fort Wayne */
	AmericaFortWayne: "AMERICA_FORT_WAYNE",
	/** America/Glace Bay */
	AmericaGlaceBay: "AMERICA_GLACE_BAY",
	/** America/Godthab */
	AmericaGodthab: "AMERICA_GODTHAB",
	/** America/Goose Bay */
	AmericaGooseBay: "AMERICA_GOOSE_BAY",
	/** America/Grand Turk */
	AmericaGrandTurk: "AMERICA_GRAND_TURK",
	/** America/Grenada */
	AmericaGrenada: "AMERICA_GRENADA",
	/** America/Guadeloupe */
	AmericaGuadeloupe: "AMERICA_GUADELOUPE",
	/** America/Guatemala */
	AmericaGuatemala: "AMERICA_GUATEMALA",
	/** America/Guayaquil */
	AmericaGuayaquil: "AMERICA_GUAYAQUIL",
	/** America/Guyana */
	AmericaGuyana: "AMERICA_GUYANA",
	/** America/Halifax */
	AmericaHalifax: "AMERICA_HALIFAX",
	/** America/Havana */
	AmericaHavana: "AMERICA_HAVANA",
	/** America/Hermosillo */
	AmericaHermosillo: "AMERICA_HERMOSILLO",
	/** America/Indianapolis */
	AmericaIndianapolis: "AMERICA_INDIANAPOLIS",
	/** America/Indiana/Indianapolis */
	AmericaIndianaIndianapolis: "AMERICA_INDIANA_INDIANAPOLIS",
	/** America/Indiana/Knox */
	AmericaIndianaKnox: "AMERICA_INDIANA_KNOX",
	/** America/Indiana/Marengo */
	AmericaIndianaMarengo: "AMERICA_INDIANA_MARENGO",
	/** America/Indiana/Petersburg */
	AmericaIndianaPetersburg: "AMERICA_INDIANA_PETERSBURG",
	/** America/Indiana/Tell City */
	AmericaIndianaTellCity: "AMERICA_INDIANA_TELL_CITY",
	/** America/Indiana/Vevay */
	AmericaIndianaVevay: "AMERICA_INDIANA_VEVAY",
	/** America/Indiana/Vincennes */
	AmericaIndianaVincennes: "AMERICA_INDIANA_VINCENNES",
	/** America/Indiana/Winamac */
	AmericaIndianaWinamac: "AMERICA_INDIANA_WINAMAC",
	/** America/Inuvik */
	AmericaInuvik: "AMERICA_INUVIK",
	/** America/Iqaluit */
	AmericaIqaluit: "AMERICA_IQALUIT",
	/** America/Jamaica */
	AmericaJamaica: "AMERICA_JAMAICA",
	/** America/Jujuy */
	AmericaJujuy: "AMERICA_JUJUY",
	/** America/Juneau */
	AmericaJuneau: "AMERICA_JUNEAU",
	/** America/Kentucky/Louisville */
	AmericaKentuckyLouisville: "AMERICA_KENTUCKY_LOUISVILLE",
	/** America/Kentucky/Monticello */
	AmericaKentuckyMonticello: "AMERICA_KENTUCKY_MONTICELLO",
	/** America/Knox IN */
	AmericaKnoxIn: "AMERICA_KNOX_IN",
	/** America/Kralendijk */
	AmericaKralendijk: "AMERICA_KRALENDIJK",
	/** America/La Paz */
	AmericaLaPaz: "AMERICA_LA_PAZ",
	/** America/Lima */
	AmericaLima: "AMERICA_LIMA",
	/** America/Los Angeles */
	AmericaLosAngeles: "AMERICA_LOS_ANGELES",
	/** America/Louisville */
	AmericaLouisville: "AMERICA_LOUISVILLE",
	/** America/Lower Princes */
	AmericaLowerPrinces: "AMERICA_LOWER_PRINCES",
	/** America/Maceio */
	AmericaMaceio: "AMERICA_MACEIO",
	/** America/Managua */
	AmericaManagua: "AMERICA_MANAGUA",
	/** America/Manaus */
	AmericaManaus: "AMERICA_MANAUS",
	/** America/Marigot */
	AmericaMarigot: "AMERICA_MARIGOT",
	/** America/Martinique */
	AmericaMartinique: "AMERICA_MARTINIQUE",
	/** America/Matamoros */
	AmericaMatamoros: "AMERICA_MATAMOROS",
	/** America/Mazatlan */
	AmericaMazatlan: "AMERICA_MAZATLAN",
	/** America/Mendoza */
	AmericaMendoza: "AMERICA_MENDOZA",
	/** America/Menominee */
	AmericaMenominee: "AMERICA_MENOMINEE",
	/** America/Merida */
	AmericaMerida: "AMERICA_MERIDA",
	/** America/Metlakatla */
	AmericaMetlakatla: "AMERICA_METLAKATLA",
	/** America/Mexico City */
	AmericaMexicoCity: "AMERICA_MEXICO_CITY",
	/** America/Miquelon */
	AmericaMiquelon: "AMERICA_MIQUELON",
	/** America/Moncton */
	AmericaMoncton: "AMERICA_MONCTON",
	/** America/Monterrey */
	AmericaMonterrey: "AMERICA_MONTERREY",
	/** America/Montevideo */
	AmericaMontevideo: "AMERICA_MONTEVIDEO",
	/** America/Montreal */
	AmericaMontreal: "AMERICA_MONTREAL",
	/** America/Montserrat */
	AmericaMontserrat: "AMERICA_MONTSERRAT",
	/** America/Nassau */
	AmericaNassau: "AMERICA_NASSAU",
	/** America/New York */
	AmericaNewYork: "AMERICA_NEW_YORK",
	/** America/Nipigon */
	AmericaNipigon: "AMERICA_NIPIGON",
	/** America/Nome */
	AmericaNome: "AMERICA_NOME",
	/** America/Noronha */
	AmericaNoronha: "AMERICA_NORONHA",
	/** America/North Dakota/Beulah */
	AmericaNorthDakotaBeulah: "AMERICA_NORTH_DAKOTA_BEULAH",
	/** America/North Dakota/Center */
	AmericaNorthDakotaCenter: "AMERICA_NORTH_DAKOTA_CENTER",
	/** America/North Dakota/New Salem */
	AmericaNorthDakotaNewSalem: "AMERICA_NORTH_DAKOTA_NEW_SALEM",
	/** America/Nuuk */
	AmericaNuuk: "AMERICA_NUUK",
	/** America/Ojinaga */
	AmericaOjinaga: "AMERICA_OJINAGA",
	/** America/Panama */
	AmericaPanama: "AMERICA_PANAMA",
	/** America/Pangnirtung */
	AmericaPangnirtung: "AMERICA_PANGNIRTUNG",
	/** America/Paramaribo */
	AmericaParamaribo: "AMERICA_PARAMARIBO",
	/** America/Phoenix */
	AmericaPhoenix: "AMERICA_PHOENIX",
	/** America/Porto Acre */
	AmericaPortoAcre: "AMERICA_PORTO_ACRE",
	/** America/Porto Velho */
	AmericaPortoVelho: "AMERICA_PORTO_VELHO",
	/** America/Port-au-Prince */
	AmericaPortAuPrince: "AMERICA_PORT_AU_PRINCE",
	/** America/Port of Spain */
	AmericaPortOfSpain: "AMERICA_PORT_OF_SPAIN",
	/** America/Puerto Rico */
	AmericaPuertoRico: "AMERICA_PUERTO_RICO",
	/** America/Punta Arenas */
	AmericaPuntaArenas: "AMERICA_PUNTA_ARENAS",
	/** America/Rainy River */
	AmericaRainyRiver: "AMERICA_RAINY_RIVER",
	/** America/Rankin Inlet */
	AmericaRankinInlet: "AMERICA_RANKIN_INLET",
	/** America/Recife */
	AmericaRecife: "AMERICA_RECIFE",
	/** America/Regina */
	AmericaRegina: "AMERICA_REGINA",
	/** America/Resolute */
	AmericaResolute: "AMERICA_RESOLUTE",
	/** America/Rio Branco */
	AmericaRioBranco: "AMERICA_RIO_BRANCO",
	/** America/Rosario */
	AmericaRosario: "AMERICA_ROSARIO",
	/** America/Santarem */
	AmericaSantarem: "AMERICA_SANTAREM",
	/** America/Santa Isabel */
	AmericaSantaIsabel: "AMERICA_SANTA_ISABEL",
	/** America/Santiago */
	AmericaSantiago: "AMERICA_SANTIAGO",
	/** America/Santo Domingo */
	AmericaSantoDomingo: "AMERICA_SANTO_DOMINGO",
	/** America/Sao Paulo */
	AmericaSaoPaulo: "AMERICA_SAO_PAULO",
	/** America/Scoresbysund */
	AmericaScoresbysund: "AMERICA_SCORESBYSUND",
	/** America/Shiprock */
	AmericaShiprock: "AMERICA_SHIPROCK",
	/** America/Sitka */
	AmericaSitka: "AMERICA_SITKA",
	/** America/St Barthelemy */
	AmericaStBarthelemy: "AMERICA_ST_BARTHELEMY",
	/** America/St Johns */
	AmericaStJohns: "AMERICA_ST_JOHNS",
	/** America/St Kitts */
	AmericaStKitts: "AMERICA_ST_KITTS",
	/** America/St Lucia */
	AmericaStLucia: "AMERICA_ST_LUCIA",
	/** America/St Thomas */
	AmericaStThomas: "AMERICA_ST_THOMAS",
	/** America/St Vincent */
	AmericaStVincent: "AMERICA_ST_VINCENT",
	/** America/Swift Current */
	AmericaSwiftCurrent: "AMERICA_SWIFT_CURRENT",
	/** America/Tegucigalpa */
	AmericaTegucigalpa: "AMERICA_TEGUCIGALPA",
	/** America/Thule */
	AmericaThule: "AMERICA_THULE",
	/** America/Thunder Bay */
	AmericaThunderBay: "AMERICA_THUNDER_BAY",
	/** America/Tijuana */
	AmericaTijuana: "AMERICA_TIJUANA",
	/** America/Toronto */
	AmericaToronto: "AMERICA_TORONTO",
	/** America/Tortola */
	AmericaTortola: "AMERICA_TORTOLA",
	/** America/Vancouver */
	AmericaVancouver: "AMERICA_VANCOUVER",
	/** America/Virgin */
	AmericaVirgin: "AMERICA_VIRGIN",
	/** America/Whitehorse */
	AmericaWhitehorse: "AMERICA_WHITEHORSE",
	/** America/Winnipeg */
	AmericaWinnipeg: "AMERICA_WINNIPEG",
	/** America/Yakutat */
	AmericaYakutat: "AMERICA_YAKUTAT",
	/** America/Yellowknife */
	AmericaYellowknife: "AMERICA_YELLOWKNIFE",
	/** Antarctica/Casey */
	AntarcticaCasey: "ANTARCTICA_CASEY",
	/** Antarctica/Davis */
	AntarcticaDavis: "ANTARCTICA_DAVIS",
	/** Antarctica/DumontDUrville */
	AntarcticaDumontdurville: "ANTARCTICA_DUMONTDURVILLE",
	/** Antarctica/Macquarie */
	AntarcticaMacquarie: "ANTARCTICA_MACQUARIE",
	/** Antarctica/Mawson */
	AntarcticaMawson: "ANTARCTICA_MAWSON",
	/** Antarctica/McMurdo */
	AntarcticaMcmurdo: "ANTARCTICA_MCMURDO",
	/** Antarctica/Palmer */
	AntarcticaPalmer: "ANTARCTICA_PALMER",
	/** Antarctica/Rothera */
	AntarcticaRothera: "ANTARCTICA_ROTHERA",
	/** Antarctica/South Pole */
	AntarcticaSouthPole: "ANTARCTICA_SOUTH_POLE",
	/** Antarctica/Syowa */
	AntarcticaSyowa: "ANTARCTICA_SYOWA",
	/** Antarctica/Troll */
	AntarcticaTroll: "ANTARCTICA_TROLL",
	/** Antarctica/Vostok */
	AntarcticaVostok: "ANTARCTICA_VOSTOK",
	/** Arctic/Longyearbyen */
	ArcticLongyearbyen: "ARCTIC_LONGYEARBYEN",
	/** Asia/Aden */
	AsiaAden: "ASIA_ADEN",
	/** Asia/Almaty */
	AsiaAlmaty: "ASIA_ALMATY",
	/** Asia/Amman */
	AsiaAmman: "ASIA_AMMAN",
	/** Asia/Anadyr */
	AsiaAnadyr: "ASIA_ANADYR",
	/** Asia/Aqtau */
	AsiaAqtau: "ASIA_AQTAU",
	/** Asia/Aqtobe */
	AsiaAqtobe: "ASIA_AQTOBE",
	/** Asia/Ashgabat */
	AsiaAshgabat: "ASIA_ASHGABAT",
	/** Asia/Ashkhabad */
	AsiaAshkhabad: "ASIA_ASHKHABAD",
	/** Asia/Atyrau */
	AsiaAtyrau: "ASIA_ATYRAU",
	/** Asia/Baghdad */
	AsiaBaghdad: "ASIA_BAGHDAD",
	/** Asia/Bahrain */
	AsiaBahrain: "ASIA_BAHRAIN",
	/** Asia/Baku */
	AsiaBaku: "ASIA_BAKU",
	/** Asia/Bangkok */
	AsiaBangkok: "ASIA_BANGKOK",
	/** Asia/Barnaul */
	AsiaBarnaul: "ASIA_BARNAUL",
	/** Asia/Beirut */
	AsiaBeirut: "ASIA_BEIRUT",
	/** Asia/Bishkek */
	AsiaBishkek: "ASIA_BISHKEK",
	/** Asia/Brunei */
	AsiaBrunei: "ASIA_BRUNEI",
	/** Asia/Calcutta */
	AsiaCalcutta: "ASIA_CALCUTTA",
	/** Asia/Chita */
	AsiaChita: "ASIA_CHITA",
	/** Asia/Choibalsan */
	AsiaChoibalsan: "ASIA_CHOIBALSAN",
	/** Asia/Chongqing */
	AsiaChongqing: "ASIA_CHONGQING",
	/** Asia/Chungking */
	AsiaChungking: "ASIA_CHUNGKING",
	/** Asia/Colombo */
	AsiaColombo: "ASIA_COLOMBO",
	/** Asia/Dacca */
	AsiaDacca: "ASIA_DACCA",
	/** Asia/Damascus */
	AsiaDamascus: "ASIA_DAMASCUS",
	/** Asia/Dhaka */
	AsiaDhaka: "ASIA_DHAKA",
	/** Asia/Dili */
	AsiaDili: "ASIA_DILI",
	/** Asia/Dubai */
	AsiaDubai: "ASIA_DUBAI",
	/** Asia/Dushanbe */
	AsiaDushanbe: "ASIA_DUSHANBE",
	/** Asia/Famagusta */
	AsiaFamagusta: "ASIA_FAMAGUSTA",
	/** Asia/Gaza */
	AsiaGaza: "ASIA_GAZA",
	/** Asia/Harbin */
	AsiaHarbin: "ASIA_HARBIN",
	/** Asia/Hebron */
	AsiaHebron: "ASIA_HEBRON",
	/** Asia/Hong Kong */
	AsiaHongKong: "ASIA_HONG_KONG",
	/** Asia/Hovd */
	AsiaHovd: "ASIA_HOVD",
	/** Asia/Ho Chi Minh */
	AsiaHoChiMinh: "ASIA_HO_CHI_MINH",
	/** Asia/Irkutsk */
	AsiaIrkutsk: "ASIA_IRKUTSK",
	/** Asia/Istanbul */
	AsiaIstanbul: "ASIA_ISTANBUL",
	/** Asia/Jakarta */
	AsiaJakarta: "ASIA_JAKARTA",
	/** Asia/Jayapura */
	AsiaJayapura: "ASIA_JAYAPURA",
	/** Asia/Jerusalem */
	AsiaJerusalem: "ASIA_JERUSALEM",
	/** Asia/Kabul */
	AsiaKabul: "ASIA_KABUL",
	/** Asia/Kamchatka */
	AsiaKamchatka: "ASIA_KAMCHATKA",
	/** Asia/Karachi */
	AsiaKarachi: "ASIA_KARACHI",
	/** Asia/Kashgar */
	AsiaKashgar: "ASIA_KASHGAR",
	/** Asia/Kathmandu */
	AsiaKathmandu: "ASIA_KATHMANDU",
	/** Asia/Katmandu */
	AsiaKatmandu: "ASIA_KATMANDU",
	/** Asia/Khandyga */
	AsiaKhandyga: "ASIA_KHANDYGA",
	/** Asia/Kolkata */
	AsiaKolkata: "ASIA_KOLKATA",
	/** Asia/Krasnoyarsk */
	AsiaKrasnoyarsk: "ASIA_KRASNOYARSK",
	/** Asia/Kuala Lumpur */
	AsiaKualaLumpur: "ASIA_KUALA_LUMPUR",
	/** Asia/Kuching */
	AsiaKuching: "ASIA_KUCHING",
	/** Asia/Kuwait */
	AsiaKuwait: "ASIA_KUWAIT",
	/** Asia/Macao */
	AsiaMacao: "ASIA_MACAO",
	/** Asia/Macau */
	AsiaMacau: "ASIA_MACAU",
	/** Asia/Magadan */
	AsiaMagadan: "ASIA_MAGADAN",
	/** Asia/Makassar */
	AsiaMakassar: "ASIA_MAKASSAR",
	/** Asia/Manila */
	AsiaManila: "ASIA_MANILA",
	/** Asia/Muscat */
	AsiaMuscat: "ASIA_MUSCAT",
	/** Asia/Nicosia */
	AsiaNicosia: "ASIA_NICOSIA",
	/** Asia/Novokuznetsk */
	AsiaNovokuznetsk: "ASIA_NOVOKUZNETSK",
	/** Asia/Novosibirsk */
	AsiaNovosibirsk: "ASIA_NOVOSIBIRSK",
	/** Asia/Omsk */
	AsiaOmsk: "ASIA_OMSK",
	/** Asia/Oral */
	AsiaOral: "ASIA_ORAL",
	/** Asia/Phnom Penh */
	AsiaPhnomPenh: "ASIA_PHNOM_PENH",
	/** Asia/Pontianak */
	AsiaPontianak: "ASIA_PONTIANAK",
	/** Asia/Pyongyang */
	AsiaPyongyang: "ASIA_PYONGYANG",
	/** Asia/Qatar */
	AsiaQatar: "ASIA_QATAR",
	/** Asia/Qostanay */
	AsiaQostanay: "ASIA_QOSTANAY",
	/** Asia/Qyzylorda */
	AsiaQyzylorda: "ASIA_QYZYLORDA",
	/** Asia/Rangoon */
	AsiaRangoon: "ASIA_RANGOON",
	/** Asia/Riyadh */
	AsiaRiyadh: "ASIA_RIYADH",
	/** Asia/Saigon */
	AsiaSaigon: "ASIA_SAIGON",
	/** Asia/Sakhalin */
	AsiaSakhalin: "ASIA_SAKHALIN",
	/** Asia/Samarkand */
	AsiaSamarkand: "ASIA_SAMARKAND",
	/** Asia/Seoul */
	AsiaSeoul: "ASIA_SEOUL",
	/** Asia/Shanghai */
	AsiaShanghai: "ASIA_SHANGHAI",
	/** Asia/Singapore */
	AsiaSingapore: "ASIA_SINGAPORE",
	/** Asia/Srednekolymsk */
	AsiaSrednekolymsk: "ASIA_SREDNEKOLYMSK",
	/** Asia/Taipei */
	AsiaTaipei: "ASIA_TAIPEI",
	/** Asia/Tashkent */
	AsiaTashkent: "ASIA_TASHKENT",
	/** Asia/Tbilisi */
	AsiaTbilisi: "ASIA_TBILISI",
	/** Asia/Tehran */
	AsiaTehran: "ASIA_TEHRAN",
	/** Asia/Tel Aviv */
	AsiaTelAviv: "ASIA_TEL_AVIV",
	/** Asia/Thimbu */
	AsiaThimbu: "ASIA_THIMBU",
	/** Asia/Thimphu */
	AsiaThimphu: "ASIA_THIMPHU",
	/** Asia/Tokyo */
	AsiaTokyo: "ASIA_TOKYO",
	/** Asia/Tomsk */
	AsiaTomsk: "ASIA_TOMSK",
	/** Asia/Ujung Pandang */
	AsiaUjungPandang: "ASIA_UJUNG_PANDANG",
	/** Asia/Ulaanbaatar */
	AsiaUlaanbaatar: "ASIA_ULAANBAATAR",
	/** Asia/Ulan Bator */
	AsiaUlanBator: "ASIA_ULAN_BATOR",
	/** Asia/Urumqi */
	AsiaUrumqi: "ASIA_URUMQI",
	/** Asia/Ust-Nera */
	AsiaUstNera: "ASIA_UST_NERA",
	/** Asia/Vientiane */
	AsiaVientiane: "ASIA_VIENTIANE",
	/** Asia/Vladivostok */
	AsiaVladivostok: "ASIA_VLADIVOSTOK",
	/** Asia/Yakutsk */
	AsiaYakutsk: "ASIA_YAKUTSK",
	/** Asia/Yangon */
	AsiaYangon: "ASIA_YANGON",
	/** Asia/Yekaterinburg */
	AsiaYekaterinburg: "ASIA_YEKATERINBURG",
	/** Asia/Yerevan */
	AsiaYerevan: "ASIA_YEREVAN",
	/** Atlantic/Azores */
	AtlanticAzores: "ATLANTIC_AZORES",
	/** Atlantic/Bermuda */
	AtlanticBermuda: "ATLANTIC_BERMUDA",
	/** Atlantic/Canary */
	AtlanticCanary: "ATLANTIC_CANARY",
	/** Atlantic/Cape Verde */
	AtlanticCapeVerde: "ATLANTIC_CAPE_VERDE",
	/** Atlantic/Faeroe */
	AtlanticFaeroe: "ATLANTIC_FAEROE",
	/** Atlantic/Faroe */
	AtlanticFaroe: "ATLANTIC_FAROE",
	/** Atlantic/Jan Mayen */
	AtlanticJanMayen: "ATLANTIC_JAN_MAYEN",
	/** Atlantic/Madeira */
	AtlanticMadeira: "ATLANTIC_MADEIRA",
	/** Atlantic/Reykjavik */
	AtlanticReykjavik: "ATLANTIC_REYKJAVIK",
	/** Atlantic/South Georgia */
	AtlanticSouthGeorgia: "ATLANTIC_SOUTH_GEORGIA",
	/** Atlantic/Stanley */
	AtlanticStanley: "ATLANTIC_STANLEY",
	/** Atlantic/St Helena */
	AtlanticStHelena: "ATLANTIC_ST_HELENA",
	/** Australia/ACT */
	AustraliaAct: "AUSTRALIA_ACT",
	/** Australia/Adelaide */
	AustraliaAdelaide: "AUSTRALIA_ADELAIDE",
	/** Australia/Brisbane */
	AustraliaBrisbane: "AUSTRALIA_BRISBANE",
	/** Australia/Broken Hill */
	AustraliaBrokenHill: "AUSTRALIA_BROKEN_HILL",
	/** Australia/Canberra */
	AustraliaCanberra: "AUSTRALIA_CANBERRA",
	/** Australia/Currie */
	AustraliaCurrie: "AUSTRALIA_CURRIE",
	/** Australia/Darwin */
	AustraliaDarwin: "AUSTRALIA_DARWIN",
	/** Australia/Eucla */
	AustraliaEucla: "AUSTRALIA_EUCLA",
	/** Australia/Hobart */
	AustraliaHobart: "AUSTRALIA_HOBART",
	/** Australia/LHI */
	AustraliaLhi: "AUSTRALIA_LHI",
	/** Australia/Lindeman */
	AustraliaLindeman: "AUSTRALIA_LINDEMAN",
	/** Australia/Lord Howe */
	AustraliaLordHowe: "AUSTRALIA_LORD_HOWE",
	/** Australia/Melbourne */
	AustraliaMelbourne: "AUSTRALIA_MELBOURNE",
	/** Australia/North */
	AustraliaNorth: "AUSTRALIA_NORTH",
	/** Australia/NSW */
	AustraliaNsw: "AUSTRALIA_NSW",
	/** Australia/Perth */
	AustraliaPerth: "AUSTRALIA_PERTH",
	/** Australia/Queensland */
	AustraliaQueensland: "AUSTRALIA_QUEENSLAND",
	/** Australia/South */
	AustraliaSouth: "AUSTRALIA_SOUTH",
	/** Australia/Sydney */
	AustraliaSydney: "AUSTRALIA_SYDNEY",
	/** Australia/Tasmania */
	AustraliaTasmania: "AUSTRALIA_TASMANIA",
	/** Australia/Victoria */
	AustraliaVictoria: "AUSTRALIA_VICTORIA",
	/** Australia/West */
	AustraliaWest: "AUSTRALIA_WEST",
	/** Australia/Yancowinna */
	AustraliaYancowinna: "AUSTRALIA_YANCOWINNA",
	/** Brazil/Acre */
	BrazilAcre: "BRAZIL_ACRE",
	/** Brazil/DeNoronha */
	BrazilDenoronha: "BRAZIL_DENORONHA",
	/** Brazil/East */
	BrazilEast: "BRAZIL_EAST",
	/** Brazil/West */
	BrazilWest: "BRAZIL_WEST",
	/** Canada/Atlantic */
	CanadaAtlantic: "CANADA_ATLANTIC",
	/** Canada/Central */
	CanadaCentral: "CANADA_CENTRAL",
	/** Canada/Eastern */
	CanadaEastern: "CANADA_EASTERN",
	/** Canada/Mountain */
	CanadaMountain: "CANADA_MOUNTAIN",
	/** Canada/Newfoundland */
	CanadaNewfoundland: "CANADA_NEWFOUNDLAND",
	/** Canada/Pacific */
	CanadaPacific: "CANADA_PACIFIC",
	/** Canada/Saskatchewan */
	CanadaSaskatchewan: "CANADA_SASKATCHEWAN",
	/** Canada/Yukon */
	CanadaYukon: "CANADA_YUKON",
	/** CET */
	Cet: "CET",
	/** Chile/Continental */
	ChileContinental: "CHILE_CONTINENTAL",
	/** Chile/EasterIsland */
	ChileEasterisland: "CHILE_EASTERISLAND",
	/** CST6CDT */
	Cst6Cdt: "CST6CDT",
	/** Cuba */
	Cuba: "CUBA",
	/** EET */
	Eet: "EET",
	/** Egypt */
	Egypt: "EGYPT",
	/** Eire */
	Eire: "EIRE",
	/** EST */
	Est: "EST",
	/** EST5EDT */
	Est5Edt: "EST5EDT",
	/** Etc/GMT */
	EtcGmt: "ETC_GMT",
	/** Etc/GMT0 */
	EtcGmt0: "ETC_GMT0",
	/** Etc/GMT-0 */
	EtcGmt_0: "ETC_GMT_0",
	/** Etc/GMT+0 */
	EtcGmt_0_408: "ETC_GMT_0_408",
	/** Etc/GMT-1 */
	EtcGmt_1: "ETC_GMT_1",
	/** Etc/GMT+1 */
	EtcGmt_1_409: "ETC_GMT_1_409",
	/** Etc/GMT-2 */
	EtcGmt_2: "ETC_GMT_2",
	/** Etc/GMT+2 */
	EtcGmt_2_413: "ETC_GMT_2_413",
	/** Etc/GMT-3 */
	EtcGmt_3: "ETC_GMT_3",
	/** Etc/GMT+3 */
	EtcGmt_3_414: "ETC_GMT_3_414",
	/** Etc/GMT-4 */
	EtcGmt_4: "ETC_GMT_4",
	/** Etc/GMT+4 */
	EtcGmt_4_415: "ETC_GMT_4_415",
	/** Etc/GMT-5 */
	EtcGmt_5: "ETC_GMT_5",
	/** Etc/GMT+5 */
	EtcGmt_5_416: "ETC_GMT_5_416",
	/** Etc/GMT-6 */
	EtcGmt_6: "ETC_GMT_6",
	/** Etc/GMT+6 */
	EtcGmt_6_417: "ETC_GMT_6_417",
	/** Etc/GMT-7 */
	EtcGmt_7: "ETC_GMT_7",
	/** Etc/GMT+7 */
	EtcGmt_7_418: "ETC_GMT_7_418",
	/** Etc/GMT-8 */
	EtcGmt_8: "ETC_GMT_8",
	/** Etc/GMT+8 */
	EtcGmt_8_419: "ETC_GMT_8_419",
	/** Etc/GMT-9 */
	EtcGmt_9: "ETC_GMT_9",
	/** Etc/GMT+9 */
	EtcGmt_9_420: "ETC_GMT_9_420",
	/** Etc/GMT-10 */
	EtcGmt_10: "ETC_GMT_10",
	/** Etc/GMT+10 */
	EtcGmt_10_410: "ETC_GMT_10_410",
	/** Etc/GMT-11 */
	EtcGmt_11: "ETC_GMT_11",
	/** Etc/GMT+11 */
	EtcGmt_11_411: "ETC_GMT_11_411",
	/** Etc/GMT-12 */
	EtcGmt_12: "ETC_GMT_12",
	/** Etc/GMT+12 */
	EtcGmt_12_412: "ETC_GMT_12_412",
	/** Etc/GMT-13 */
	EtcGmt_13: "ETC_GMT_13",
	/** Etc/GMT-14 */
	EtcGmt_14: "ETC_GMT_14",
	/** Etc/Greenwich */
	EtcGreenwich: "ETC_GREENWICH",
	/** Etc/UCT */
	EtcUct: "ETC_UCT",
	/** Etc/Universal */
	EtcUniversal: "ETC_UNIVERSAL",
	/** Etc/UTC */
	EtcUtc: "ETC_UTC",
	/** Etc/Zulu */
	EtcZulu: "ETC_ZULU",
	/** Europe/Amsterdam */
	EuropeAmsterdam: "EUROPE_AMSTERDAM",
	/** Europe/Andorra */
	EuropeAndorra: "EUROPE_ANDORRA",
	/** Europe/Astrakhan */
	EuropeAstrakhan: "EUROPE_ASTRAKHAN",
	/** Europe/Athens */
	EuropeAthens: "EUROPE_ATHENS",
	/** Europe/Belfast */
	EuropeBelfast: "EUROPE_BELFAST",
	/** Europe/Belgrade */
	EuropeBelgrade: "EUROPE_BELGRADE",
	/** Europe/Berlin */
	EuropeBerlin: "EUROPE_BERLIN",
	/** Europe/Bratislava */
	EuropeBratislava: "EUROPE_BRATISLAVA",
	/** Europe/Brussels */
	EuropeBrussels: "EUROPE_BRUSSELS",
	/** Europe/Bucharest */
	EuropeBucharest: "EUROPE_BUCHAREST",
	/** Europe/Budapest */
	EuropeBudapest: "EUROPE_BUDAPEST",
	/** Europe/Busingen */
	EuropeBusingen: "EUROPE_BUSINGEN",
	/** Europe/Chisinau */
	EuropeChisinau: "EUROPE_CHISINAU",
	/** Europe/Copenhagen */
	EuropeCopenhagen: "EUROPE_COPENHAGEN",
	/** Europe/Dublin */
	EuropeDublin: "EUROPE_DUBLIN",
	/** Europe/Gibraltar */
	EuropeGibraltar: "EUROPE_GIBRALTAR",
	/** Europe/Guernsey */
	EuropeGuernsey: "EUROPE_GUERNSEY",
	/** Europe/Helsinki */
	EuropeHelsinki: "EUROPE_HELSINKI",
	/** Europe/Isle of Man */
	EuropeIsleOfMan: "EUROPE_ISLE_OF_MAN",
	/** Europe/Istanbul */
	EuropeIstanbul: "EUROPE_ISTANBUL",
	/** Europe/Jersey */
	EuropeJersey: "EUROPE_JERSEY",
	/** Europe/Kaliningrad */
	EuropeKaliningrad: "EUROPE_KALININGRAD",
	/** Europe/Kiev */
	EuropeKiev: "EUROPE_KIEV",
	/** Europe/Kirov */
	EuropeKirov: "EUROPE_KIROV",
	/** Europe/Kyiv */
	EuropeKyiv: "EUROPE_KYIV",
	/** Europe/Lisbon */
	EuropeLisbon: "EUROPE_LISBON",
	/** Europe/Ljubljana */
	EuropeLjubljana: "EUROPE_LJUBLJANA",
	/** Europe/London */
	EuropeLondon: "EUROPE_LONDON",
	/** Europe/Luxembourg */
	EuropeLuxembourg: "EUROPE_LUXEMBOURG",
	/** Europe/Madrid */
	EuropeMadrid: "EUROPE_MADRID",
	/** Europe/Malta */
	EuropeMalta: "EUROPE_MALTA",
	/** Europe/Mariehamn */
	EuropeMariehamn: "EUROPE_MARIEHAMN",
	/** Europe/Minsk */
	EuropeMinsk: "EUROPE_MINSK",
	/** Europe/Monaco */
	EuropeMonaco: "EUROPE_MONACO",
	/** Europe/Moscow */
	EuropeMoscow: "EUROPE_MOSCOW",
	/** Europe/Nicosia */
	EuropeNicosia: "EUROPE_NICOSIA",
	/** Europe/Oslo */
	EuropeOslo: "EUROPE_OSLO",
	/** Europe/Paris */
	EuropeParis: "EUROPE_PARIS",
	/** Europe/Podgorica */
	EuropePodgorica: "EUROPE_PODGORICA",
	/** Europe/Prague */
	EuropePrague: "EUROPE_PRAGUE",
	/** Europe/Riga */
	EuropeRiga: "EUROPE_RIGA",
	/** Europe/Rome */
	EuropeRome: "EUROPE_ROME",
	/** Europe/Samara */
	EuropeSamara: "EUROPE_SAMARA",
	/** Europe/San Marino */
	EuropeSanMarino: "EUROPE_SAN_MARINO",
	/** Europe/Sarajevo */
	EuropeSarajevo: "EUROPE_SARAJEVO",
	/** Europe/Saratov */
	EuropeSaratov: "EUROPE_SARATOV",
	/** Europe/Simferopol */
	EuropeSimferopol: "EUROPE_SIMFEROPOL",
	/** Europe/Skopje */
	EuropeSkopje: "EUROPE_SKOPJE",
	/** Europe/Sofia */
	EuropeSofia: "EUROPE_SOFIA",
	/** Europe/Stockholm */
	EuropeStockholm: "EUROPE_STOCKHOLM",
	/** Europe/Tallinn */
	EuropeTallinn: "EUROPE_TALLINN",
	/** Europe/Tirane */
	EuropeTirane: "EUROPE_TIRANE",
	/** Europe/Tiraspol */
	EuropeTiraspol: "EUROPE_TIRASPOL",
	/** Europe/Ulyanovsk */
	EuropeUlyanovsk: "EUROPE_ULYANOVSK",
	/** Europe/Uzhgorod */
	EuropeUzhgorod: "EUROPE_UZHGOROD",
	/** Europe/Vaduz */
	EuropeVaduz: "EUROPE_VADUZ",
	/** Europe/Vatican */
	EuropeVatican: "EUROPE_VATICAN",
	/** Europe/Vienna */
	EuropeVienna: "EUROPE_VIENNA",
	/** Europe/Vilnius */
	EuropeVilnius: "EUROPE_VILNIUS",
	/** Europe/Volgograd */
	EuropeVolgograd: "EUROPE_VOLGOGRAD",
	/** Europe/Warsaw */
	EuropeWarsaw: "EUROPE_WARSAW",
	/** Europe/Zagreb */
	EuropeZagreb: "EUROPE_ZAGREB",
	/** Europe/Zaporozhye */
	EuropeZaporozhye: "EUROPE_ZAPOROZHYE",
	/** Europe/Zurich */
	EuropeZurich: "EUROPE_ZURICH",
	/** GB */
	Gb: "GB",
	/** GB-Eire */
	GbEire: "GB_EIRE",
	/** GMT */
	Gmt: "GMT",
	/** GMT0 */
	Gmt0: "GMT0",
	/** GMT-0 */
	Gmt_0: "GMT_0",
	/** GMT+0 */
	Gmt_0_495: "GMT_0_495",
	/** Greenwich */
	Greenwich: "GREENWICH",
	/** Hongkong */
	Hongkong: "HONGKONG",
	/** HST */
	Hst: "HST",
	/** Iceland */
	Iceland: "ICELAND",
	/** Indian/Antananarivo */
	IndianAntananarivo: "INDIAN_ANTANANARIVO",
	/** Indian/Chagos */
	IndianChagos: "INDIAN_CHAGOS",
	/** Indian/Christmas */
	IndianChristmas: "INDIAN_CHRISTMAS",
	/** Indian/Cocos */
	IndianCocos: "INDIAN_COCOS",
	/** Indian/Comoro */
	IndianComoro: "INDIAN_COMORO",
	/** Indian/Kerguelen */
	IndianKerguelen: "INDIAN_KERGUELEN",
	/** Indian/Mahe */
	IndianMahe: "INDIAN_MAHE",
	/** Indian/Maldives */
	IndianMaldives: "INDIAN_MALDIVES",
	/** Indian/Mauritius */
	IndianMauritius: "INDIAN_MAURITIUS",
	/** Indian/Mayotte */
	IndianMayotte: "INDIAN_MAYOTTE",
	/** Indian/Reunion */
	IndianReunion: "INDIAN_REUNION",
	/** Iran */
	Iran: "IRAN",
	/** Israel */
	Israel: "ISRAEL",
	/** Jamaica */
	Jamaica: "JAMAICA",
	/** Japan */
	Japan: "JAPAN",
	/** Kwajalein */
	Kwajalein: "KWAJALEIN",
	/** Libya */
	Libya: "LIBYA",
	/** MET */
	Met: "MET",
	/** Mexico/BajaNorte */
	MexicoBajanorte: "MEXICO_BAJANORTE",
	/** Mexico/BajaSur */
	MexicoBajasur: "MEXICO_BAJASUR",
	/** Mexico/General */
	MexicoGeneral: "MEXICO_GENERAL",
	/** MST */
	Mst: "MST",
	/** MST7MDT */
	Mst7Mdt: "MST7MDT",
	/** Navajo */
	Navajo: "NAVAJO",
	/** NZ */
	Nz: "NZ",
	/** NZ-CHAT */
	NzChat: "NZ_CHAT",
	/** Pacific/Apia */
	PacificApia: "PACIFIC_APIA",
	/** Pacific/Auckland */
	PacificAuckland: "PACIFIC_AUCKLAND",
	/** Pacific/Bougainville */
	PacificBougainville: "PACIFIC_BOUGAINVILLE",
	/** Pacific/Chatham */
	PacificChatham: "PACIFIC_CHATHAM",
	/** Pacific/Chuuk */
	PacificChuuk: "PACIFIC_CHUUK",
	/** Pacific/Easter */
	PacificEaster: "PACIFIC_EASTER",
	/** Pacific/Efate */
	PacificEfate: "PACIFIC_EFATE",
	/** Pacific/Enderbury */
	PacificEnderbury: "PACIFIC_ENDERBURY",
	/** Pacific/Fakaofo */
	PacificFakaofo: "PACIFIC_FAKAOFO",
	/** Pacific/Fiji */
	PacificFiji: "PACIFIC_FIJI",
	/** Pacific/Funafuti */
	PacificFunafuti: "PACIFIC_FUNAFUTI",
	/** Pacific/Galapagos */
	PacificGalapagos: "PACIFIC_GALAPAGOS",
	/** Pacific/Gambier */
	PacificGambier: "PACIFIC_GAMBIER",
	/** Pacific/Guadalcanal */
	PacificGuadalcanal: "PACIFIC_GUADALCANAL",
	/** Pacific/Guam */
	PacificGuam: "PACIFIC_GUAM",
	/** Pacific/Honolulu */
	PacificHonolulu: "PACIFIC_HONOLULU",
	/** Pacific/Johnston */
	PacificJohnston: "PACIFIC_JOHNSTON",
	/** Pacific/Kanton */
	PacificKanton: "PACIFIC_KANTON",
	/** Pacific/Kiritimati */
	PacificKiritimati: "PACIFIC_KIRITIMATI",
	/** Pacific/Kosrae */
	PacificKosrae: "PACIFIC_KOSRAE",
	/** Pacific/Kwajalein */
	PacificKwajalein: "PACIFIC_KWAJALEIN",
	/** Pacific/Majuro */
	PacificMajuro: "PACIFIC_MAJURO",
	/** Pacific/Marquesas */
	PacificMarquesas: "PACIFIC_MARQUESAS",
	/** Pacific/Midway */
	PacificMidway: "PACIFIC_MIDWAY",
	/** Pacific/Nauru */
	PacificNauru: "PACIFIC_NAURU",
	/** Pacific/Niue */
	PacificNiue: "PACIFIC_NIUE",
	/** Pacific/Norfolk */
	PacificNorfolk: "PACIFIC_NORFOLK",
	/** Pacific/Noumea */
	PacificNoumea: "PACIFIC_NOUMEA",
	/** Pacific/Pago Pago */
	PacificPagoPago: "PACIFIC_PAGO_PAGO",
	/** Pacific/Palau */
	PacificPalau: "PACIFIC_PALAU",
	/** Pacific/Pitcairn */
	PacificPitcairn: "PACIFIC_PITCAIRN",
	/** Pacific/Pohnpei */
	PacificPohnpei: "PACIFIC_POHNPEI",
	/** Pacific/Ponape */
	PacificPonape: "PACIFIC_PONAPE",
	/** Pacific/Port Moresby */
	PacificPortMoresby: "PACIFIC_PORT_MORESBY",
	/** Pacific/Rarotonga */
	PacificRarotonga: "PACIFIC_RAROTONGA",
	/** Pacific/Saipan */
	PacificSaipan: "PACIFIC_SAIPAN",
	/** Pacific/Samoa */
	PacificSamoa: "PACIFIC_SAMOA",
	/** Pacific/Tahiti */
	PacificTahiti: "PACIFIC_TAHITI",
	/** Pacific/Tarawa */
	PacificTarawa: "PACIFIC_TARAWA",
	/** Pacific/Tongatapu */
	PacificTongatapu: "PACIFIC_TONGATAPU",
	/** Pacific/Truk */
	PacificTruk: "PACIFIC_TRUK",
	/** Pacific/Wake */
	PacificWake: "PACIFIC_WAKE",
	/** Pacific/Wallis */
	PacificWallis: "PACIFIC_WALLIS",
	/** Pacific/Yap */
	PacificYap: "PACIFIC_YAP",
	/** Poland */
	Poland: "POLAND",
	/** Portugal */
	Portugal: "PORTUGAL",
	/** PRC */
	Prc: "PRC",
	/** PST8PDT */
	Pst8Pdt: "PST8PDT",
	/** ROC */
	Roc: "ROC",
	/** ROK */
	Rok: "ROK",
	/** Singapore */
	Singapore: "SINGAPORE",
	/** Turkey */
	Turkey: "TURKEY",
	/** UCT */
	Uct: "UCT",
	/** Universal */
	Universal: "UNIVERSAL",
	/** US/Alaska */
	UsAlaska: "US_ALASKA",
	/** US/Aleutian */
	UsAleutian: "US_ALEUTIAN",
	/** US/Arizona */
	UsArizona: "US_ARIZONA",
	/** US/Central */
	UsCentral: "US_CENTRAL",
	/** US/Eastern */
	UsEastern: "US_EASTERN",
	/** US/East-Indiana */
	UsEastIndiana: "US_EAST_INDIANA",
	/** US/Hawaii */
	UsHawaii: "US_HAWAII",
	/** US/Indiana-Starke */
	UsIndianaStarke: "US_INDIANA_STARKE",
	/** US/Michigan */
	UsMichigan: "US_MICHIGAN",
	/** US/Mountain */
	UsMountain: "US_MOUNTAIN",
	/** US/Pacific */
	UsPacific: "US_PACIFIC",
	/** US/Samoa */
	UsSamoa: "US_SAMOA",
	/** UTC */
	Utc: "UTC",
	/** WET */
	Wet: "WET",
	/** W-SU */
	WSu: "W_SU",
	/** Zulu */
	Zulu: "ZULU",
} as const

export type UsersUserProfileTimezoneChoices =
	(typeof UsersUserProfileTimezoneChoices)[keyof typeof UsersUserProfileTimezoneChoices]
/** An enumeration. */
export const VoucherAmountCurrencyEnum = {
	/** Euro */
	Eur: "EUR",
} as const

export type VoucherAmountCurrencyEnum =
	(typeof VoucherAmountCurrencyEnum)[keyof typeof VoucherAmountCurrencyEnum]
/** A voucher object representing a discount code. */
export type VoucherObjectType = {
	__typename?: "VoucherObjectType"
	/** UTC Date Time after which voucher code can be used (default is today). */
	activation_at?: EntireFieldWrapper<
		Maybe<Scalars["CustomDateTime"]["output"]>
	>
	/** Enable/Disable validity within the voucher lifetime (between activation date and expiration date). */
	active?: EntireFieldWrapper<Maybe<Scalars["Boolean"]["output"]>>
	/** Voucher amount in Euros that will be discounted from the investment amount. */
	amount?: EntireFieldWrapper<Maybe<Scalars["Float"]["output"]>>
	/** amount currency */
	amount_currency?: EntireFieldWrapper<Maybe<VoucherAmountCurrencyEnum>>
	/** UUID of the campaign this voucher belongs to. */
	campaign_id?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** Unique alphanumeric 10 characters voucher code */
	code?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** Created At */
	created_at?: EntireFieldWrapper<Maybe<Scalars["CustomDateTime"]["output"]>>
	/** Deleted At */
	deleted_at?: EntireFieldWrapper<Maybe<Scalars["CustomDateTime"]["output"]>>
	/** Email must be specified ONLY IF the voucher belongs to campaign of type, single use with email. */
	email?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** UTC Date Time on which voucher code will expire (default is 2 years from today). */
	expiration_at?: EntireFieldWrapper<
		Maybe<Scalars["CustomDateTime"]["output"]>
	>
	/** Django object unique identification field */
	id: EntireFieldWrapper<Scalars["ID"]["output"]>
	/** Modified At */
	modified_at?: EntireFieldWrapper<Maybe<Scalars["CustomDateTime"]["output"]>>
	/** Investor who referred the new investor. */
	referrer?: EntireFieldWrapper<Maybe<InvestorType>>
	/** Public URL to the campaign's terms and conditions. */
	terms_url?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
	/** Max. no. of valid voucher usage. Blank indicates unlimited usage. A voucher can be used only once per email. */
	usage_limit?: EntireFieldWrapper<Maybe<Scalars["Int"]["output"]>>
	/** Universally unique identifier. */
	uuid?: EntireFieldWrapper<Maybe<Scalars["UUID"]["output"]>>
	/** Short version of the universally unique identifier. */
	uuid_short?: EntireFieldWrapper<Maybe<Scalars["String"]["output"]>>
}

/** An enumeration. */
export const Country = {
	/** Austria */
	At: "AT",
	/** Belgium */
	Be: "BE",
	/** Bulgaria */
	Bg: "BG",
	/** Cyprus */
	Cy: "CY",
	/** Czechia */
	Cz: "CZ",
	/** Germany */
	De: "DE",
	/** Denmark */
	Dk: "DK",
	/** Estonia */
	Ee: "EE",
	/** Spain */
	Es: "ES",
	/** Finland */
	Fi: "FI",
	/** France */
	Fr: "FR",
	/** Greece */
	Gr: "GR",
	/** Croatia */
	Hr: "HR",
	/** Hungary */
	Hu: "HU",
	/** Ireland */
	Ie: "IE",
	/** Italy */
	It: "IT",
	/** Lithuania */
	Lt: "LT",
	/** Luxembourg */
	Lu: "LU",
	/** Latvia */
	Lv: "LV",
	/** Malta */
	Mt: "MT",
	/** Netherlands */
	Nl: "NL",
	/** Poland */
	Pl: "PL",
	/** Portugal */
	Pt: "PT",
	/** Romania */
	Ro: "RO",
	/** Sweden */
	Se: "SE",
	/** Slovenia */
	Si: "SI",
	/** Slovakia */
	Sk: "SK",
} as const

export type Country = (typeof Country)[keyof typeof Country]
/** An enumeration. */
export const Language = {
	/** English */
	En: "EN",
	/** French */
	Fr: "FR",
	/** Dutch */
	Nl: "NL",
} as const

export type Language = (typeof Language)[keyof typeof Language]
/** An enumeration. */
export const Nationality = {
	/** Andorra */
	Ad: "AD",
	/** United Arab Emirates */
	Ae: "AE",
	/** Afghanistan */
	Af: "AF",
	/** Antigua and Barbuda */
	Ag: "AG",
	/** Anguilla */
	Ai: "AI",
	/** Albania */
	Al: "AL",
	/** Armenia */
	Am: "AM",
	/** Angola */
	Ao: "AO",
	/** Antarctica */
	Aq: "AQ",
	/** Argentina */
	Ar: "AR",
	/** American Samoa */
	As: "AS",
	/** Austria */
	At: "AT",
	/** Australia */
	Au: "AU",
	/** Aruba */
	Aw: "AW",
	/** Åland Islands */
	Ax: "AX",
	/** Azerbaijan */
	Az: "AZ",
	/** Bosnia and Herzegovina */
	Ba: "BA",
	/** Barbados */
	Bb: "BB",
	/** Bangladesh */
	Bd: "BD",
	/** Belgium */
	Be: "BE",
	/** Burkina Faso */
	Bf: "BF",
	/** Bulgaria */
	Bg: "BG",
	/** Bahrain */
	Bh: "BH",
	/** Burundi */
	Bi: "BI",
	/** Benin */
	Bj: "BJ",
	/** Saint Barthélemy */
	Bl: "BL",
	/** Bermuda */
	Bm: "BM",
	/** Brunei */
	Bn: "BN",
	/** Bolivia */
	Bo: "BO",
	/** Bonaire, Sint Eustatius and Saba */
	Bq: "BQ",
	/** Brazil */
	Br: "BR",
	/** Bahamas (The) */
	Bs: "BS",
	/** Bhutan */
	Bt: "BT",
	/** Bouvet Island */
	Bv: "BV",
	/** Botswana */
	Bw: "BW",
	/** Belarus */
	By: "BY",
	/** Belize */
	Bz: "BZ",
	/** Canada */
	Ca: "CA",
	/** Cocos (Keeling) Islands */
	Cc: "CC",
	/** Democratic Republic of the Congo */
	Cd: "CD",
	/** Central African Republic */
	Cf: "CF",
	/** Congo */
	Cg: "CG",
	/** Switzerland */
	Ch: "CH",
	/** Côte d'Ivoire */
	Ci: "CI",
	/** Cook Islands */
	Ck: "CK",
	/** Chile */
	Cl: "CL",
	/** Cameroon */
	Cm: "CM",
	/** China */
	Cn: "CN",
	/** Colombia */
	Co: "CO",
	/** Costa Rica */
	Cr: "CR",
	/** Cuba */
	Cu: "CU",
	/** Cabo Verde */
	Cv: "CV",
	/** Curaçao */
	Cw: "CW",
	/** Christmas Island */
	Cx: "CX",
	/** Cyprus */
	Cy: "CY",
	/** Czechia */
	Cz: "CZ",
	/** Germany */
	De: "DE",
	/** Djibouti */
	Dj: "DJ",
	/** Denmark */
	Dk: "DK",
	/** Dominica */
	Dm: "DM",
	/** Dominican Republic */
	Do: "DO",
	/** Algeria */
	Dz: "DZ",
	/** Ecuador */
	Ec: "EC",
	/** Estonia */
	Ee: "EE",
	/** Egypt */
	Eg: "EG",
	/** Western Sahara */
	Eh: "EH",
	/** Eritrea */
	Er: "ER",
	/** Spain */
	Es: "ES",
	/** Ethiopia */
	Et: "ET",
	/** Finland */
	Fi: "FI",
	/** Fiji */
	Fj: "FJ",
	/** Falkland Islands (Malvinas) */
	Fk: "FK",
	/** Micronesia */
	Fm: "FM",
	/** Faroe Islands */
	Fo: "FO",
	/** France */
	Fr: "FR",
	/** Gabon */
	Ga: "GA",
	/** United Kingdom */
	Gb: "GB",
	/** Grenada */
	Gd: "GD",
	/** Georgia */
	Ge: "GE",
	/** French Guiana */
	Gf: "GF",
	/** Guernsey */
	Gg: "GG",
	/** Ghana */
	Gh: "GH",
	/** Gibraltar */
	Gi: "GI",
	/** Greenland */
	Gl: "GL",
	/** Gambia */
	Gm: "GM",
	/** Guinea */
	Gn: "GN",
	/** Guadeloupe */
	Gp: "GP",
	/** Equatorial Guinea */
	Gq: "GQ",
	/** Greece */
	Gr: "GR",
	/** South Georgia */
	Gs: "GS",
	/** Guatemala */
	Gt: "GT",
	/** Guam */
	Gu: "GU",
	/** Guinea-Bissau */
	Gw: "GW",
	/** Guyana */
	Gy: "GY",
	/** Hong Kong */
	Hk: "HK",
	/** Heard Island and McDonald Islands */
	Hm: "HM",
	/** Honduras */
	Hn: "HN",
	/** Croatia */
	Hr: "HR",
	/** Haiti */
	Ht: "HT",
	/** Hungary */
	Hu: "HU",
	/** Indonesia */
	Id: "ID",
	/** Ireland */
	Ie: "IE",
	/** Israel */
	Il: "IL",
	/** Isle of Man */
	Im: "IM",
	/** India */
	In: "IN",
	/** British Indian Ocean Territory */
	Io: "IO",
	/** Iraq */
	Iq: "IQ",
	/** Iran */
	Ir: "IR",
	/** Iceland */
	Is: "IS",
	/** Italy */
	It: "IT",
	/** Jersey */
	Je: "JE",
	/** Jamaica */
	Jm: "JM",
	/** Jordan */
	Jo: "JO",
	/** Japan */
	Jp: "JP",
	/** Kenya */
	Ke: "KE",
	/** Kyrgyzstan */
	Kg: "KG",
	/** Cambodia */
	Kh: "KH",
	/** Kiribati */
	Ki: "KI",
	/** Comoros */
	Km: "KM",
	/** Saint Kitts and Nevis */
	Kn: "KN",
	/** North Korea */
	Kp: "KP",
	/** South Korea */
	Kr: "KR",
	/** Kuwait */
	Kw: "KW",
	/** Cayman Islands */
	Ky: "KY",
	/** Kazakhstan */
	Kz: "KZ",
	/** Laos */
	La: "LA",
	/** Lebanon */
	Lb: "LB",
	/** Saint Lucia */
	Lc: "LC",
	/** Liechtenstein */
	Li: "LI",
	/** Sri Lanka */
	Lk: "LK",
	/** Liberia */
	Lr: "LR",
	/** Lesotho */
	Ls: "LS",
	/** Lithuania */
	Lt: "LT",
	/** Luxembourg */
	Lu: "LU",
	/** Latvia */
	Lv: "LV",
	/** Libya */
	Ly: "LY",
	/** Morocco */
	Ma: "MA",
	/** Monaco */
	Mc: "MC",
	/** Moldova */
	Md: "MD",
	/** Montenegro */
	Me: "ME",
	/** Saint Martin (French part) */
	Mf: "MF",
	/** Madagascar */
	Mg: "MG",
	/** Marshall Islands */
	Mh: "MH",
	/** North Macedonia */
	Mk: "MK",
	/** Mali */
	Ml: "ML",
	/** Myanmar */
	Mm: "MM",
	/** Mongolia */
	Mn: "MN",
	/** Macao */
	Mo: "MO",
	/** Northern Mariana Islands */
	Mp: "MP",
	/** Martinique */
	Mq: "MQ",
	/** Mauritania */
	Mr: "MR",
	/** Montserrat */
	Ms: "MS",
	/** Malta */
	Mt: "MT",
	/** Mauritius */
	Mu: "MU",
	/** Maldives */
	Mv: "MV",
	/** Malawi */
	Mw: "MW",
	/** Mexico */
	Mx: "MX",
	/** Malaysia */
	My: "MY",
	/** Mozambique */
	Mz: "MZ",
	/** Namibia */
	Na: "NA",
	/** New Caledonia */
	Nc: "NC",
	/** Niger */
	Ne: "NE",
	/** Norfolk Island */
	Nf: "NF",
	/** Nigeria */
	Ng: "NG",
	/** Nicaragua */
	Ni: "NI",
	/** Netherlands */
	Nl: "NL",
	/** Norway */
	No: "NO",
	/** Nepal */
	Np: "NP",
	/** Nauru */
	Nr: "NR",
	/** Niue */
	Nu: "NU",
	/** New Zealand */
	Nz: "NZ",
	/** Oman */
	Om: "OM",
	/** Panama */
	Pa: "PA",
	/** Peru */
	Pe: "PE",
	/** French Polynesia */
	Pf: "PF",
	/** Papua New Guinea */
	Pg: "PG",
	/** Philippines */
	Ph: "PH",
	/** Pakistan */
	Pk: "PK",
	/** Poland */
	Pl: "PL",
	/** Saint Pierre and Miquelon */
	Pm: "PM",
	/** Pitcairn */
	Pn: "PN",
	/** Puerto Rico */
	Pr: "PR",
	/** Palestine */
	Ps: "PS",
	/** Portugal */
	Pt: "PT",
	/** Palau */
	Pw: "PW",
	/** Paraguay */
	Py: "PY",
	/** Qatar */
	Qa: "QA",
	/** Réunion */
	Re: "RE",
	/** Romania */
	Ro: "RO",
	/** Serbia */
	Rs: "RS",
	/** Russia */
	Ru: "RU",
	/** Rwanda */
	Rw: "RW",
	/** Saudi Arabia */
	Sa: "SA",
	/** Solomon Islands */
	Sb: "SB",
	/** Seychelles */
	Sc: "SC",
	/** Sudan */
	Sd: "SD",
	/** Sweden */
	Se: "SE",
	/** Singapore */
	Sg: "SG",
	/** Saint Helena */
	Sh: "SH",
	/** Slovenia */
	Si: "SI",
	/** Svalbard and Jan Mayen */
	Sj: "SJ",
	/** Slovakia */
	Sk: "SK",
	/** Sierra Leone */
	Sl: "SL",
	/** San Marino */
	Sm: "SM",
	/** Senegal */
	Sn: "SN",
	/** Somalia */
	So: "SO",
	/** Suriname */
	Sr: "SR",
	/** South Sudan */
	Ss: "SS",
	/** Sao Tome and Principe */
	St: "ST",
	/** El Salvador */
	Sv: "SV",
	/** Sint Maarten (Dutch part) */
	Sx: "SX",
	/** Syria */
	Sy: "SY",
	/** Eswatini */
	Sz: "SZ",
	/** Turks and Caicos Islands */
	Tc: "TC",
	/** Chad */
	Td: "TD",
	/** French Southern Territories */
	Tf: "TF",
	/** Togo */
	Tg: "TG",
	/** Thailand */
	Th: "TH",
	/** Tajikistan */
	Tj: "TJ",
	/** Tokelau */
	Tk: "TK",
	/** Timor-Leste */
	Tl: "TL",
	/** Turkmenistan */
	Tm: "TM",
	/** Tunisia */
	Tn: "TN",
	/** Tonga */
	To: "TO",
	/** Türkiye */
	Tr: "TR",
	/** Trinidad and Tobago */
	Tt: "TT",
	/** Tuvalu */
	Tv: "TV",
	/** Taiwan */
	Tw: "TW",
	/** Tanzania */
	Tz: "TZ",
	/** Ukraine */
	Ua: "UA",
	/** Uganda */
	Ug: "UG",
	/** United States Minor Outlying Islands */
	Um: "UM",
	/** United States of America */
	Us: "US",
	/** Uruguay */
	Uy: "UY",
	/** Uzbekistan */
	Uz: "UZ",
	/** Vatican City */
	Va: "VA",
	/** Saint Vincent and the Grenadines */
	Vc: "VC",
	/** Venezuela */
	Ve: "VE",
	/** Virgin Islands (British) */
	Vg: "VG",
	/** Virgin Islands (U.S.) */
	Vi: "VI",
	/** Vietnam */
	Vn: "VN",
	/** Vanuatu */
	Vu: "VU",
	/** Wallis and Futuna */
	Wf: "WF",
	/** Samoa */
	Ws: "WS",
	/** Yemen */
	Ye: "YE",
	/** Mayotte */
	Yt: "YT",
	/** South Africa */
	Za: "ZA",
	/** Zambia */
	Zm: "ZM",
	/** Zimbabwe */
	Zw: "ZW",
} as const

export type Nationality = (typeof Nationality)[keyof typeof Nationality]
/** An enumeration. */
export const Region = {
	/** Drenthe */
	Dr: "DR",
	/** Flevoland */
	Fl: "FL",
	/** Fryslân */
	Fr: "FR",
	/** Gelderland */
	Gl: "GL",
	/** Groningen */
	Gr: "GR",
	/** Limburg */
	Lb: "LB",
	/** Noord-Brabant */
	Nb: "NB",
	/** Noord-Holland */
	Nh: "NH",
	/** Overijssel */
	Ov: "OV",
	/** Utrecht */
	Ut: "UT",
	/** Zeeland */
	Ze: "ZE",
	/** Zuid-Holland */
	Zh: "ZH",
} as const

export type Region = (typeof Region)[keyof typeof Region]
